/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, s) {
    "use strict";
    function i() {
        if (document.querySelector("cart-items")) return;
        const t = document.createElement("cart-items");
        document.body.appendChild(t);
    }
    function o(t) {
        t.querySelectorAll(".form-field").forEach((t) => {
            const e = t.querySelector("label"),
                s = t.querySelector("input, textarea");
            e &&
                s &&
                (s.addEventListener("keyup", (t) => {
                    "" !== t.target.value ? e.classList.add("label--float") : e.classList.remove("label--float");
                }),
                s.value && s.value.length && e.classList.add("label--float"));
        });
    }
    !(function () {
        const t = { NODE_ENV: "production" };
        try {
            if (process) return (process.env = Object.assign({}, process.env)), void Object.assign(process.env, t);
        } catch (t) {}
        globalThis.process = { env: t };
    })(),
        (window.theme = window.theme || {}),
        (window.theme.sizes = { mobile: 480, small: 750, large: 990, widescreen: 1400 }),
        (window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    let n = d();
    function r() {
        const t = {};
        return (
            (t.windowHeight = Math.min(window.screen.height, window.innerHeight)),
            (t.footerHeight = h('[data-section-type*="footer"]')),
            (t.headerHeight = h("[data-header-height]")),
            (t.stickyHeaderHeight = document.querySelector("[data-header-sticky]") ? t.headerHeight : 0),
            (t.collectionNavHeight = h("[data-collection-nav]")),
            (t.logoHeight = (function () {
                const t = h("[data-footer-logo]");
                return t > 0 ? t + 20 : 0;
            })()),
            t
        );
    }
    function a() {
        document.addEventListener("theme:resize", c), l();
    }
    function l() {
        const { windowHeight: t, headerHeight: e, logoHeight: s, footerHeight: i, collectionNavHeight: o } = r();
        document.documentElement.style.setProperty("--full-height", `${t}px`),
            document.documentElement.style.setProperty("--three-quarters", t * (3 / 4) + "px"),
            document.documentElement.style.setProperty("--two-thirds", t * (2 / 3) + "px"),
            document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
            document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
            document.documentElement.style.setProperty("--collection-nav-height", `${o}px`),
            document.documentElement.style.setProperty("--header-height", `${e}px`),
            document.documentElement.style.setProperty("--footer-height", `${i}px`),
            document.documentElement.style.setProperty("--content-full", t - e - s / 2 + "px"),
            document.documentElement.style.setProperty("--content-min", t - e - i + "px");
    }
    function c() {
        const { windowHeight: t, headerHeight: e, logoHeight: s, footerHeight: i, collectionNavHeight: o } = r(),
            a = d();
        (a !== n || window.innerWidth > window.theme.sizes.mobile) &&
            (document.documentElement.style.setProperty("--full-height", `${t}px`),
            document.documentElement.style.setProperty("--three-quarters", t * (3 / 4) + "px"),
            document.documentElement.style.setProperty("--two-thirds", t * (2 / 3) + "px"),
            document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
            document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
            (n = a)),
            document.documentElement.style.setProperty("--collection-nav-height", `${o}px`),
            document.documentElement.style.setProperty("--header-height", `${e}px`),
            document.documentElement.style.setProperty("--footer-height", `${i}px`),
            document.documentElement.style.setProperty("--content-full", t - e - s / 2 + "px"),
            document.documentElement.style.setProperty("--content-min", t - e - i + "px");
    }
    function d() {
        return window.matchMedia("(orientation: portrait)").matches ? "portrait" : window.matchMedia("(orientation: landscape)").matches ? "landscape" : void 0;
    }
    function h(t) {
        const e = document.querySelector(t);
        return e ? e.offsetHeight : 0;
    }
    function u(t, e) {
        let s;
        return function () {
            if (t) {
                const i = () => t.apply(this, arguments);
                clearTimeout(s), (s = setTimeout(i, e));
            }
        };
    }
    function p() {
        return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
    }
    function m() {
        return document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight;
    }
    function v() {
        return p() >= window.theme.sizes.small;
    }
    function g() {
        return p() < window.theme.sizes.small;
    }
    window.initialWindowHeight = Math.min(window.screen.height, window.innerHeight);
    let b = p(),
        f = m();
    let y = window.scrollY,
        w = null,
        S = null,
        E = null,
        L = null,
        k = 0;
    function A(e) {
        setTimeout(() => {
            k && clearTimeout(k), t.disablePageScroll(e.detail, { allowTouchMove: (t) => "TEXTAREA" === t.tagName }), document.documentElement.setAttribute("data-scroll-locked", "");
        });
    }
    function C(t) {
        const e = t.detail;
        e ? (k = setTimeout(q, e)) : q();
    }
    function q() {
        t.clearQueueScrollLocks(), t.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked");
    }
    const T = (t, e = "", s) => {
        const i = s || document.createElement("div");
        return i.classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t);
    };
    function x(t) {
        t.querySelectorAll(".rte table").forEach((t) => {
            T(t, "rte__table-wrapper"), t.setAttribute("data-scroll-lock-scrollable", "");
        });
        t.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach((t) => {
            T(t, "rte__video-wrapper");
        });
    }
    function P(t) {
        const e = t.querySelectorAll("[data-aria-toggle]");
        e.length &&
            e.forEach((t) => {
                t.addEventListener("click", function (t) {
                    t.preventDefault();
                    const e = t.currentTarget;
                    e.setAttribute("aria-expanded", "false" == e.getAttribute("aria-expanded") ? "true" : "false");
                    const s = e.getAttribute("aria-controls"),
                        i = document.querySelector(`#${s}`),
                        o = () => {
                            i.classList.remove("expanding"), i.removeEventListener("transitionend", o);
                        },
                        n = () => {
                            i.classList.add("expanding"), i.removeEventListener("transitionstart", n);
                        };
                    i.addEventListener("transitionstart", n), i.addEventListener("transitionend", o), i.classList.toggle("expanded");
                });
            });
    }
    const I = "is-loading",
        H = "img.is-loading";
    function O(t, e) {
        e = e || {};
        var s = t.tabIndex;
        (t.tabIndex = -1),
            (t.dataset.tabIndex = s),
            t.focus(),
            void 0 !== e.className && t.classList.add(e.className),
            t.addEventListener("blur", function i(o) {
                o.target.removeEventListener(o.type, i), (t.tabIndex = s), delete t.dataset.tabIndex, void 0 !== e.className && t.classList.remove(e.className);
            });
    }
    function D(t) {
        return Array.prototype.slice.call(t.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled")).filter(function (t) {
            return !(!(t.offsetWidth || t.offsetHeight || t.getClientRects().length) || ((e = t), (s = window.getComputedStyle(e)), "none" === s.display || "hidden" === s.visibility));
            var e, s;
        });
    }
    var M = {};
    function B(t, e) {
        e = e || {};
        var s = D(t),
            i = e.elementToFocus || t,
            o = s[0],
            n = s[s.length - 1];
        F(),
            (M.focusin = function (e) {
                t !== e.target && !t.contains(e.target) && o && o === e.target && o.focus(), (e.target !== t && e.target !== n && e.target !== o) || document.addEventListener("keydown", M.keydown);
            }),
            (M.focusout = function () {
                document.removeEventListener("keydown", M.keydown);
            }),
            (M.keydown = function (e) {
                "Tab" === e.code && (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()), (e.target !== t && e.target !== o) || !e.shiftKey || (e.preventDefault(), n.focus()));
            }),
            document.addEventListener("focusout", M.focusout),
            document.addEventListener("focusin", M.focusin),
            O(i, e);
    }
    function F() {
        document.removeEventListener("focusin", M.focusin), document.removeEventListener("focusout", M.focusout), document.removeEventListener("keydown", M.keydown);
    }
    function _() {
        window.a11y.lastElement &&
            document.body.classList.contains("is-focused") &&
            setTimeout(() => {
                var t;
                null === (t = window.a11y.lastElement) || void 0 === t || t.focus();
            });
    }
    var $ = Object.freeze({
        __proto__: null,
        forceFocus: O,
        focusHash: function (t) {
            t = t || {};
            var e = window.location.hash,
                s = document.getElementById(e.slice(1));
            if (s && t.ignore && s.matches(t.ignore)) return !1;
            e && s && O(s, t);
        },
        bindInPageLinks: function (t) {
            return (
                (t = t || {}),
                Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function (e) {
                    if ("#" === e.hash || "" === e.hash) return !1;
                    if (t.ignore && e.matches(t.ignore)) return !1;
                    if (((s = e.hash.substr(1)), null === document.getElementById(s))) return !1;
                    var s,
                        i = document.querySelector(e.hash);
                    return (
                        !!i &&
                        (e.addEventListener("click", function () {
                            O(i, t);
                        }),
                        !0)
                    );
                })
            );
        },
        focusable: D,
        trapFocus: B,
        removeTrapFocus: F,
        autoFocusLastElement: _,
        accessibleLinks: function (t, e) {
            if ("string" != typeof t) throw new TypeError(t + " is not a String.");
            if (0 !== (t = document.querySelectorAll(t)).length) {
                (e = e || {}).messages = e.messages || {};
                var s,
                    i,
                    o,
                    n = {
                        newWindow: e.messages.newWindow || "Opens in a new window.",
                        external: e.messages.external || "Opens external website.",
                        newWindowExternal: e.messages.newWindowExternal || "Opens external website in a new window.",
                    },
                    r = e.prefix || "a11y",
                    a = { newWindow: r + "-new-window-message", external: r + "-external-message", newWindowExternal: r + "-new-window-external-message" };
                t.forEach(function (t) {
                    var e = t.getAttribute("target"),
                        s = t.getAttribute("rel"),
                        i = (function (t) {
                            return t.hostname !== window.location.hostname;
                        })(t),
                        o = "_blank" === e,
                        n = null === s || -1 === s.indexOf("noopener");
                    if (o && n) {
                        var r = null === s ? "noopener" : s + " noopener";
                        t.setAttribute("rel", r);
                    }
                    i && o ? t.setAttribute("aria-describedby", a.newWindowExternal) : i ? t.setAttribute("aria-describedby", a.external) : o && t.setAttribute("aria-describedby", a.newWindow);
                }),
                    (s = n),
                    (i = document.createElement("ul")),
                    (o = Object.keys(s).reduce(function (t, e) {
                        return t + "<li id=" + a[e] + ">" + s[e] + "</li>";
                    }, "")),
                    i.setAttribute("hidden", !0),
                    (i.innerHTML = o),
                    document.body.appendChild(i);
            }
        },
    });
    function N(t) {
        return new Promise((e) => {
            null == t ||
                t.addEventListener("animationend", function s(i) {
                    i.target == t && (t.removeEventListener("animationend", s), e());
                });
        });
    }
    const R = "[data-drawer-inner]",
        W = "[data-drawer-close]",
        U = "[data-drawer-underlay]",
        z = "[data-stagger-animation]",
        V = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        j = "drawer--animated",
        J = "is-open",
        X = "is-closing",
        G = "is-focused";
    let Q = class extends HTMLElement {
        connectDrawer() {
            this.addEventListener("theme:drawer:toggle", (t) => {
                var e;
                (this.triggerButton = null === (e = t.detail) || void 0 === e ? void 0 : e.button),
                    this.classList.contains(J) ? this.dispatchEvent(new CustomEvent("theme:drawer:close", { bubbles: !0 })) : this.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !0 }));
            }),
                this.addEventListener("theme:drawer:close", this.hideDrawer),
                this.addEventListener("theme:drawer:open", this.showDrawer),
                document.addEventListener("theme:cart-drawer:open", this.hideDrawer);
        }
        closers() {
            var t;
            null === (t = this.querySelectorAll(W)) ||
                void 0 === t ||
                t.forEach((t) => {
                    t.addEventListener("click", () => {
                        this.hideDrawer();
                    });
                }),
                document.addEventListener("keyup", (t) => {
                    "Escape" === t.code && this.hideDrawer();
                }),
                this.underlay.addEventListener("click", () => {
                    this.hideDrawer();
                });
        }
        showDrawer() {
            var t;
            this.isAnimating ||
                ((this.isAnimating = !0),
                null === (t = this.triggerButton) || void 0 === t || t.setAttribute("aria-expanded", !0),
                this.classList.add(J, j),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                this.drawerInner &&
                    (F(),
                    N(this.drawerInner).then(() => {
                        (this.isAnimating = !1), B(this.drawerInner, { elementToFocus: this.querySelector(V) });
                    })));
        }
        hideDrawer() {
            !this.isAnimating &&
                this.classList.contains(J) &&
                ((this.isAnimating = !0),
                this.classList.add(X),
                this.classList.remove(J),
                F(),
                this.triggerButton && (this.triggerButton.setAttribute("aria-expanded", !1), document.body.classList.contains(G) && this.triggerButton.focus()),
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                N(this.drawerInner).then(() => {
                    this.classList.remove(X, j), (this.isAnimating = !1), document.dispatchEvent(new CustomEvent("theme:sliderule:close", { bubbles: !1 }));
                }));
        }
        disconnectedCallback() {
            document.removeEventListener("theme:cart-drawer:open", this.hideDrawer);
        }
        constructor() {
            super(),
                (this.isAnimating = !1),
                (this.drawer = this),
                (this.drawerInner = this.querySelector(R)),
                (this.underlay = this.querySelector(U)),
                (this.triggerButton = null),
                (this.staggers = this.querySelectorAll(z)),
                (this.showDrawer = this.showDrawer.bind(this)),
                (this.hideDrawer = this.hideDrawer.bind(this)),
                this.connectDrawer(),
                this.closers();
        }
    };
    const Y = 'input[type="search"]',
        K = '[aria-selected="true"] a',
        Z = 'button[type="reset"]',
        tt = "hidden";
    let et = class extends HTMLElement {
        toggleResetButton() {
            const t = this.resetButton.classList.contains(tt);
            this.input.value.length > 0 && t ? this.resetButton.classList.remove(tt) : 0 !== this.input.value.length || t || this.resetButton.classList.add(tt);
        }
        onChange() {
            this.toggleResetButton();
        }
        shouldResetForm() {
            return !document.querySelector(K);
        }
        onFormReset(t) {
            t.preventDefault(), this.shouldResetForm() && ((this.input.value = ""), this.toggleResetButton(), t.target.querySelector(Y).focus());
        }
        constructor() {
            super(),
                (this.input = this.querySelector(Y)),
                (this.resetButton = this.querySelector(Z)),
                this.input &&
                    (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
                    this.input.addEventListener(
                        "input",
                        u((t) => {
                            this.onChange(t);
                        }, 300).bind(this)
                    ));
        }
    };
    customElements.define("header-search-form", et);
    const st = '[role="option"]',
        it = '[aria-selected="true"]',
        ot = "[data-popular-searches]",
        nt = "predictive-search",
        rt = "[data-predictive-search-results]",
        at = "[data-predictive-search-status]",
        lt = 'input[type="search"]',
        ct = "[data-popdown]",
        dt = "[data-predictive-search-live-region-count-value]",
        ht = "[data-search-results-groups-wrapper]",
        ut = "[data-predictive-search-search-for-text]",
        pt = "#shopify-section-predictive-search",
        mt = '[aria-selected="true"] a',
        vt = '[aria-selected="true"] a, button[aria-selected="true"]';
    let gt = class extends et {
        connectedCallback() {
            this.input.addEventListener("focus", this.onFocus.bind(this)),
                this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
                this.addEventListener("focusout", this.onFocusOut.bind(this)),
                this.addEventListener("keyup", this.onKeyup.bind(this)),
                this.addEventListener("keydown", this.onKeydown.bind(this));
        }
        getQuery() {
            return this.input.value.trim();
        }
        onChange() {
            super.onChange();
            const t = this.getQuery();
            var e;
            (this.searchTerm && t.startsWith(this.searchTerm)) || null === (e = this.querySelector(ht)) || void 0 === e || e.remove();
            this.updateSearchForTerm(this.searchTerm, t), (this.searchTerm = t), this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.reset();
        }
        onFormSubmit(t) {
            (this.getQuery().length && !this.querySelector(mt)) || t.preventDefault();
        }
        onFormReset(t) {
            super.onFormReset(t), super.shouldResetForm() && ((this.searchTerm = ""), this.abortController.abort(), (this.abortController = new AbortController()), this.closeResults(!0));
        }
        shouldResetForm() {
            return !document.querySelector(mt);
        }
        onFocus() {
            const t = this.getQuery();
            t.length && (this.searchTerm !== t ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm));
        }
        onFocusOut() {
            setTimeout(() => {
                this.contains(document.activeElement) || this.close();
            });
        }
        onKeyup(t) {
            switch ((this.getQuery().length || this.close(!0), t.preventDefault(), t.code)) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption();
            }
        }
        onKeydown(t) {
            ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
        }
        updateSearchForTerm(t, e) {
            const s = this.querySelector(ut),
                i = null == s ? void 0 : s.innerText;
            if (i) {
                var o;
                if ((null === (o = i.match(new RegExp(t, "g"))) || void 0 === o ? void 0 : o.length) > 1) return;
                const n = i.replace(t, e);
                s.innerText = n;
            }
        }
        switchOption(t) {
            if (!this.getAttribute("open")) return;
            const e = "up" === t,
                s = this.querySelector(it),
                i = Array.from(this.querySelectorAll(st)).filter((t) => null !== t.offsetParent);
            let o = 0;
            if (e && !s) return;
            let n = -1,
                r = 0;
            for (; -1 === n && r <= i.length; ) i[r] === s && (n = r), r++;
            if (((this.statusElement.textContent = ""), !e && s ? (o = n === i.length - 1 ? 0 : n + 1) : e && (o = 0 === n ? i.length - 1 : n - 1), o === n)) return;
            const a = i[o];
            a.setAttribute("aria-selected", !0), s && s.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", a.id);
        }
        selectOption() {
            const t = this.querySelector(vt);
            t && t.click();
        }
        getSearchResults(t) {
            const e = t.replace(" ", "-").toLowerCase();
            this.setLiveRegionLoadingState(),
                this.cachedResults[e]
                    ? this.renderSearchResults(this.cachedResults[e])
                    : fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(t)}&section_id=predictive-search`, { signal: this.abortController.signal })
                          .then((t) => {
                              if (!t.ok) {
                                  var e = new Error(t.status);
                                  throw (this.close(), e);
                              }
                              return t.text();
                          })
                          .then((t) => {
                              const s = new DOMParser().parseFromString(t, "text/html").querySelector(pt).innerHTML;
                              this.allPredictiveSearchInstances.forEach((t) => {
                                  t.cachedResults[e] = s;
                              }),
                                  this.renderSearchResults(s);
                          })
                          .catch((t) => {
                              if (20 !== (null == t ? void 0 : t.code)) throw (this.close(), t);
                          });
        }
        setLiveRegionLoadingState() {
            (this.statusElement = this.statusElement || this.querySelector(at)), (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", !0);
        }
        setLiveRegionText(t) {
            this.statusElement.setAttribute("aria-hidden", "false"),
                (this.statusElement.textContent = t),
                setTimeout(() => {
                    this.statusElement.setAttribute("aria-hidden", "true");
                }, 1e3);
        }
        renderSearchResults(t) {
            (this.predictiveSearchResults.innerHTML = t), this.setAttribute("results", !0), this.setLiveRegionResults(), this.open();
        }
        setLiveRegionResults() {
            this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(dt).textContent);
        }
        open() {
            this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), (this.isOpen = !0), this.predictiveSearchResults.style.setProperty("--full-screen", `${window.visualViewport.height}px`);
        }
        close(t = !1) {
            this.closeResults(t), (this.isOpen = !1), this.predictiveSearchResults.style.removeProperty("--full-screen");
        }
        closeResults(t = !1) {
            var e;
            t && ((this.input.value = ""), this.removeAttribute("results"));
            const s = this.querySelector(it);
            s && s.setAttribute("aria-selected", !1),
                this.input.setAttribute("aria-activedescendant", ""),
                this.removeAttribute("loading"),
                this.removeAttribute("open"),
                this.input.setAttribute("aria-expanded", !1),
                null === (e = this.predictiveSearchResults) || void 0 === e || e.removeAttribute("style");
        }
        reset() {
            (this.predictiveSearchResults.innerHTML = ""),
                (this.input.val = ""),
                this.a11y.removeTrapFocus(),
                this.popularSearches && (this.input.dispatchEvent(new Event("blur", { bubbles: !1 })), this.a11y.trapFocus(this.searchPopdown, { elementToFocus: this.input }));
        }
        constructor() {
            var t;
            super(),
                (this.a11y = $),
                (this.abortController = new AbortController()),
                (this.allPredictiveSearchInstances = document.querySelectorAll(nt)),
                (this.cachedResults = {}),
                (this.input = this.querySelector(lt)),
                (this.isOpen = !1),
                (this.predictiveSearchResults = this.querySelector(rt)),
                (this.searchPopdown = this.closest(ct)),
                (this.popularSearches = null === (t = this.searchPopdown) || void 0 === t ? void 0 : t.querySelector(ot)),
                (this.searchTerm = "");
        }
    };
    const bt = "[data-popout-list]",
        ft = "[data-popout-toggle]",
        yt = "[data-popout-toggle-text]",
        wt = "[data-popout-input]",
        St = "[data-popout-option]",
        Et = "[data-product-image]",
        Lt = "[data-grid-item]",
        kt = "popout-list--visible",
        At = "is-visible",
        Ct = "is-active",
        qt = "popout-list--top",
        Tt = "aria-expanded",
        xt = "aria-current",
        Pt = "data-value",
        It = "data-popout-toggle-text",
        Ht = "submit";
    let Ot = class extends HTMLElement {
        connectedCallback() {
            (this.popoutList = this.querySelector(bt)),
                (this.popoutToggle = this.querySelector(ft)),
                (this.popoutToggleText = this.querySelector(yt)),
                (this.popoutInput = this.querySelector(wt)),
                (this.popoutOptions = this.querySelectorAll(St)),
                (this.productGridItem = this.popoutList.closest(Lt)),
                (this.fireSubmitEvent = this.hasAttribute(Ht)),
                (this.popupToggleFocusoutEvent = (t) => this.onPopupToggleFocusout(t)),
                (this.popupListFocusoutEvent = (t) => this.onPopupListFocusout(t)),
                (this.popupToggleClickEvent = (t) => this.onPopupToggleClick(t)),
                (this.keyUpEvent = (t) => this.onKeyUp(t)),
                (this.bodyClickEvent = (t) => this.onBodyClick(t)),
                this._connectOptions(),
                this._connectToggle(),
                this._onFocusOut(),
                this.popupListSetDimensions();
        }
        onPopupToggleClick(t) {
            const e = "true" === t.currentTarget.getAttribute(Tt);
            if (this.productGridItem) {
                const t = this.productGridItem.querySelector(Et);
                t && t.classList.toggle(At, !e), (this.popoutList.style.maxHeight = `${Math.abs(this.popoutToggle.getBoundingClientRect().bottom - this.productGridItem.getBoundingClientRect().bottom)}px`);
            }
            t.currentTarget.setAttribute(Tt, !e), this.popoutList.classList.toggle(kt), this.popupListSetDimensions(), this.toggleListPosition(), document.body.addEventListener("click", this.bodyClickEvent);
        }
        onPopupToggleFocusout(t) {
            this.contains(t.relatedTarget) || this._hideList();
        }
        onPopupListFocusout(t) {
            const e = t.currentTarget.contains(t.relatedTarget);
            this.popoutList.classList.contains(kt) && !e && this._hideList();
        }
        toggleListPosition() {
            const t = "true" === this.querySelector(ft).getAttribute(Tt),
                e = window.innerHeight,
                s = this.getBoundingClientRect().top,
                i = () => {
                    this.popoutList.classList.remove(qt), this.popoutList.removeEventListener("transitionend", i);
                };
            t ? e / 2 > s && this.popoutList.classList.add(qt) : this.popoutList.addEventListener("transitionend", i);
        }
        popupListSetDimensions() {
            this.popoutList.style.setProperty("--max-width", "100vw"),
                this.popoutList.style.setProperty("--max-height", "100vh"),
                requestAnimationFrame(() => {
                    this.popoutList.style.setProperty("--max-width", `${parseInt(document.body.clientWidth - this.popoutList.getBoundingClientRect().left)}px`),
                        this.popoutList.style.setProperty("--max-height", `${parseInt(window.innerHeight - this.popoutList.getBoundingClientRect().top)}px`);
                });
        }
        popupOptionsClick(t) {
            if ("#" === t.target.closest(St).attributes.href.value) {
                t.preventDefault();
                const e = t.currentTarget.hasAttribute(Pt) ? t.currentTarget.getAttribute(Pt) : "";
                if (((this.popoutInput.value = e), this.popoutInput.disabled && this.popoutInput.removeAttribute("disabled"), this.fireSubmitEvent)) this._submitForm(e);
                else {
                    const s = t.currentTarget.parentElement,
                        i = this.popoutList.querySelector(`.${Ct}`),
                        o = this.popoutList.querySelector(`[${xt}]`);
                    this.popoutInput.dispatchEvent(new Event("change")),
                        i && (i.classList.remove(Ct), s.classList.add(Ct)),
                        "quantity" != this.popoutInput.name || s.nextSibling || this.classList.add(Ct),
                        o && o.hasAttribute(`${xt}`) && (o.removeAttribute(`${xt}`), t.currentTarget.setAttribute(`${xt}`, "true")),
                        "" !== e && ((this.popoutToggleText.innerHTML = e), this.popoutToggleText.hasAttribute(It) && "" !== this.popoutToggleText.getAttribute(It) && this.popoutToggleText.setAttribute(It, e)),
                        this.onPopupToggleFocusout(t),
                        this.onPopupListFocusout(t);
                }
            }
        }
        onKeyUp(t) {
            "Escape" === t.code && (this._hideList(), this.popoutToggle.focus());
        }
        onBodyClick(t) {
            const e = this.contains(t.target);
            this.popoutList.classList.contains(kt) && !e && this._hideList();
        }
        _connectToggle() {
            this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
        }
        _connectOptions() {
            this.popoutOptions.length &&
                this.popoutOptions.forEach((t) => {
                    t.addEventListener("click", (t) => this.popupOptionsClick(t));
                });
        }
        _onFocusOut() {
            this.addEventListener("keyup", this.keyUpEvent), this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent), this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent);
        }
        _submitForm() {
            const t = this.closest("form");
            t && t.submit();
        }
        _hideList() {
            this.popoutList.classList.remove(kt), this.popoutToggle.setAttribute(Tt, !1), this.toggleListPosition(), document.body.removeEventListener("click", this.bodyClickEvent);
        }
        constructor() {
            super();
        }
    };
    const Dt = "[data-aos]:not(.aos-animate)",
        Mt = "[data-aos-anchor]",
        Bt = "[data-aos]:not([data-aos-anchor]):not(.aos-animate)",
        Ft = "aos-animate",
        _t = { attributes: !1, childList: !0, subtree: !0 };
    let $t = [];
    const Nt = (t) => {
            for (const e of t)
                if ("childList" === e.type) {
                    const t = e.target,
                        s = t.querySelectorAll(Dt),
                        i = t.querySelectorAll(Mt);
                    s.length &&
                        s.forEach((t) => {
                            Rt.observe(t);
                        }),
                        i.length && Ut(i);
                }
        },
        Rt = new IntersectionObserver(
            (t, e) => {
                t.forEach((t) => {
                    t.isIntersecting && (t.target.classList.add(Ft), e.unobserve(t.target));
                });
            },
            { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
        ),
        Wt = new IntersectionObserver(
            (t, e) => {
                t.forEach((t) => {
                    if (t.intersectionRatio) {
                        const s = t.target.querySelectorAll(Dt);
                        s.length &&
                            s.forEach((t) => {
                                t.classList.add(Ft);
                            }),
                            e.unobserve(t.target);
                    }
                });
            },
            { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
        );
    function Ut(t) {
        t.length &&
            t.forEach((t) => {
                const e = t.dataset.aosAnchor;
                if (e && -1 === $t.indexOf(e)) {
                    const t = document.querySelector(e);
                    t && (Wt.observe(t), $t.push(e));
                }
            });
    }
    const zt = "[data-deferred-media-button]",
        Vt = "video, model-viewer, iframe",
        jt = '[data-host="youtube"]',
        Jt = '[data-host="vimeo"]',
        Xt = "[data-grid-item]",
        Gt = ".shopify-section",
        Qt = "template",
        Yt = "video",
        Kt = "product-model",
        Zt = "loaded",
        te = "autoplay";
    let ee = class extends HTMLElement {
        connectedCallback() {
            this.productGridItem && (this.section.addEventListener("mouseover", this.mouseOverEvent, { once: !0 }), this.addEventListener("mouseenter", this.mouseEnterEvent), this.addEventListener("mouseleave", this.mouseLeaveEvent));
        }
        disconnectedCallback() {
            this.productGridItem &&
                (this.section.removeEventListener("mouseover", this.mouseOverEvent, { once: !0 }), this.removeEventListener("mouseenter", this.mouseEnterEvent), this.removeEventListener("mouseleave", this.mouseLeaveEvent));
        }
        mouseEnterActions() {
            (this.hovered = !0), this.videoActions(), this.getAttribute(Zt) || this.loadContent();
        }
        mouseLeaveActions() {
            (this.hovered = !1), this.videoActions();
        }
        videoActions() {
            if (this.getAttribute(Zt)) {
                const t = this.querySelector(jt),
                    e = this.querySelector(Jt),
                    s = t || e,
                    i = this.querySelector(Yt);
                if (s) {
                    let t = this.hovered ? "playVideo" : "pauseVideo",
                        i = `{"event":"command","func":"${t}","args":""}`;
                    e && ((t = this.hovered ? "play" : "pause"), (i = `{"method":"${t}"}`)),
                        s.contentWindow.postMessage(i, "*"),
                        s.addEventListener("load", (t) => {
                            this.videoActions();
                        });
                } else i && (this.hovered ? i.play() : i.pause());
            }
        }
        loadContent(t = !0) {
            if ((this.pauseAllMedia(), !this.getAttribute(Zt))) {
                const e = document.createElement("div"),
                    s = this.querySelector(Qt).content.firstElementChild.cloneNode(!0);
                e.appendChild(s), this.setAttribute(Zt, !0);
                const i = this.appendChild(e.querySelector(Vt));
                t && i.focus(), "VIDEO" == i.nodeName && i.getAttribute(te) && i.play(), this.productGridItem && this.videoActions();
            }
        }
        pauseAllMedia() {
            document.querySelectorAll(jt).forEach((t) => {
                t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
            }),
                document.querySelectorAll(Jt).forEach((t) => {
                    t.contentWindow.postMessage('{"method":"pause"}', "*");
                }),
                document.querySelectorAll(Yt).forEach((t) => t.pause()),
                document.querySelectorAll(Kt).forEach((t) => {
                    t.modelViewerUI && t.modelViewerUI.pause();
                });
        }
        constructor() {
            super();
            const t = this.querySelector(zt);
            null == t || t.addEventListener("click", this.loadContent.bind(this)),
                (this.section = this.closest(Gt)),
                (this.productGridItem = this.closest(Xt)),
                (this.hovered = !1),
                (this.mouseEnterEvent = () => this.mouseEnterActions()),
                (this.mouseLeaveEvent = () => this.mouseLeaveActions());
        }
    };
    const se = "is-visible";
    class ie {
        init() {
            var t;
            const e = { root: this.container, threshold: [0.01, 0.5, 0.75, 0.99] };
            (this.observer = new IntersectionObserver((t) => {
                t.forEach((t) => {
                    t.intersectionRatio >= 0.99 ? t.target.classList.add(se) : t.target.classList.remove(se);
                });
            }, e)),
                null === (t = this.container.querySelectorAll(this.itemSelector)) ||
                    void 0 === t ||
                    t.forEach((t) => {
                        this.observer.observe(t);
                    });
        }
        destroy() {
            this.observer.disconnect();
        }
        constructor(t, e) {
            t && e && ((this.observer = null), (this.container = t), (this.itemSelector = e), this.init());
        }
    }
    const oe = "is-dragging",
        ne = "is-enabled",
        re = "is-scrolling",
        ae = "is-visible",
        le = "[data-grid-item]";
    class ce {
        handleMouseDown(t) {
            t.preventDefault(), (this.isDown = !0), (this.startX = t.pageX - this.slider.offsetLeft), (this.scrollLeft = this.slider.scrollLeft), this.cancelMomentumTracking();
        }
        handleMouseLeave() {
            this.isDown && ((this.isDown = !1), this.beginMomentumTracking());
        }
        handleMouseUp() {
            (this.isDown = !1), this.beginMomentumTracking();
        }
        handleMouseMove(t) {
            if (!this.isDown) return;
            t.preventDefault();
            const e = 1 * (t.pageX - this.slider.offsetLeft - this.startX),
                s = this.slider.scrollLeft,
                i = e > 0 ? 1 : -1;
            this.slider.classList.add(oe, re), (this.slider.scrollLeft = this.scrollLeft - e), this.slider.scrollLeft !== s && (this.velX = this.slider.scrollLeft - s || i);
        }
        handleMouseWheel() {
            this.cancelMomentumTracking(), this.slider.classList.remove(re);
        }
        beginMomentumTracking() {
            (this.isScrolling = !1), this.slider.classList.remove(oe), this.cancelMomentumTracking(), this.scrollToSlide();
        }
        cancelMomentumTracking() {
            cancelAnimationFrame(this.scrollAnimation);
        }
        scrollToSlide() {
            if (!this.velX && !this.isScrolling) return;
            const t = this.slider.querySelector(`${le}.${ae}`);
            if (!t) return;
            const e = parseInt(window.getComputedStyle(t).marginRight) || 0,
                s = t.offsetWidth + e,
                i = t.offsetLeft,
                o = this.velX > 0 ? 1 : -1,
                n = Math.floor(Math.abs(this.velX) / 100) || 1;
            (this.startPosition = this.slider.scrollLeft),
                (this.distance = i - this.startPosition),
                (this.startTime = performance.now()),
                (this.isScrolling = !0),
                o < 0 && this.velX < s && (this.distance -= s * n),
                o > 0 && this.velX < s && (this.distance += s * n),
                (this.scrollAnimation = requestAnimationFrame(this.scrollStep));
        }
        scrollStep() {
            const t = performance.now() - this.startTime,
                e = parseFloat(this.easeOutCubic(Math.min(t, this.duration))).toFixed(1);
            (this.slider.scrollLeft = e), t < this.duration ? (this.scrollAnimation = requestAnimationFrame(this.scrollStep)) : (this.slider.classList.remove(re), (this.velX = 0), (this.isScrolling = !1));
        }
        easeOutCubic(t) {
            return (t /= this.duration), t--, this.distance * (t * t * t + 1) + this.startPosition;
        }
        destroy() {
            this.slider.classList.remove(ne),
                this.slider.removeEventListener("mousedown", this.handleMouseDown),
                this.slider.removeEventListener("mouseleave", this.handleMouseLeave),
                this.slider.removeEventListener("mouseup", this.handleMouseUp),
                this.slider.removeEventListener("mousemove", this.handleMouseMove),
                this.slider.removeEventListener("wheel", this.handleMouseWheel);
        }
        constructor(t) {
            (this.slider = t),
                (this.isDown = !1),
                (this.startX = 0),
                (this.scrollLeft = 0),
                (this.velX = 0),
                (this.scrollAnimation = null),
                (this.isScrolling = !1),
                (this.duration = 800),
                (this.scrollStep = this.scrollStep.bind(this)),
                (this.scrollToSlide = this.scrollToSlide.bind(this)),
                (this.handleMouseDown = this.handleMouseDown.bind(this)),
                (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
                (this.handleMouseUp = this.handleMouseUp.bind(this)),
                (this.handleMouseMove = this.handleMouseMove.bind(this)),
                (this.handleMouseWheel = this.handleMouseWheel.bind(this)),
                this.slider.addEventListener("mousedown", this.handleMouseDown),
                this.slider.addEventListener("mouseleave", this.handleMouseLeave),
                this.slider.addEventListener("mouseup", this.handleMouseUp),
                this.slider.addEventListener("mousemove", this.handleMouseMove),
                this.slider.addEventListener("wheel", this.handleMouseWheel, { passive: !0 }),
                this.slider.classList.add(ne);
        }
    }
    const de = "[data-button-arrow]",
        he = "[data-collection-image]",
        ue = "[data-column-image]",
        pe = "[data-product-image]",
        me = "[data-grid-item]",
        ve = "[data-grid-slider]",
        ge = "data-button-prev",
        be = "data-button-next",
        fe = "align-arrows",
        ye = "slider__arrows",
        we = "is-visible",
        Se = "scroll-snap-disabled";
    class Ee extends HTMLElement {
        connectedCallback() {
            this.init(), this.addEventListener("theme:grid-slider:init", this.init);
        }
        init() {
            var t;
            (this.slider = this.querySelector(ve)),
                (this.slides = this.querySelectorAll(me)),
                (this.buttons = this.querySelectorAll(de)),
                this.slider.classList.add(Se),
                this.toggleSlider(),
                document.addEventListener("theme:resize:width", this.toggleSlider),
                ((t = this),
                new Promise((e, s) => {
                    const i = t.querySelectorAll("[data-aos]");
                    let o = 0;
                    function n(t) {
                        o++, o === i.length && e(), t.target.removeEventListener("animationend", n);
                    }
                    i.forEach((t) => {
                        t.addEventListener("animationend", n);
                    }),
                        o || s();
                }))
                    .then(() => {
                        this.slider.classList.remove(Se);
                    })
                    .catch(() => {
                        this.slider.classList.remove(Se);
                    });
        }
        toggleSlider() {
            if (!(this.slider.clientWidth < this.getSlidesWidth()) || (!v() && window.theme.touch)) this.destroy();
            else {
                if (this.isInitialized) return;
                (this.slidesObserver = new ie(this.slider, me)), this.initArrows(), (this.isInitialized = !0), (this.draggableSlider = new ce(this.slider));
            }
        }
        initArrows() {
            if (!this.buttons.length) {
                const t = document.createElement("div");
                t.classList.add(ye),
                    (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
                    this.append(t),
                    (this.buttons = this.querySelectorAll(de)),
                    (this.buttonPrev = this.querySelector(`[${ge}]`)),
                    (this.buttonNext = this.querySelector(`[${be}]`));
            }
            this.toggleArrowsObserver(),
                this.hasAttribute(fe) && (this.positionArrows(), this.arrowsResizeObserver()),
                this.buttons.forEach((t) => {
                    t.addEventListener("click", this.onButtonArrowClick);
                });
        }
        buttonArrowClickEvent(t) {
            t.preventDefault();
            const e = this.slider.querySelector(`${me}.${we}`);
            let s = null;
            t.target.hasAttribute(ge) && (s = null == e ? void 0 : e.previousElementSibling), t.target.hasAttribute(be) && (s = null == e ? void 0 : e.nextElementSibling), this.goToSlide(s);
        }
        removeArrows() {
            var t;
            null === (t = this.querySelector(`.${ye}`)) || void 0 === t || t.remove();
        }
        goToSlide(t) {
            t && this.slider.scrollTo({ top: 0, left: t.offsetLeft, behavior: "smooth" });
        }
        getSlidesWidth() {
            var t;
            return (null === (t = this.slider.querySelector(me)) || void 0 === t ? void 0 : t.clientWidth) * this.slider.querySelectorAll(me).length;
        }
        toggleArrowsObserver() {
            if (this.buttonPrev && this.buttonNext) {
                const t = this.slides.length,
                    e = this.slides[0],
                    s = this.slides[t - 1],
                    i = { attributes: !0, childList: !1, subtree: !1 },
                    o = (t) => {
                        for (const i of t)
                            if ("attributes" === i.type) {
                                const t = i.target,
                                    o = Boolean(t.classList.contains(we));
                                t == e && (this.buttonPrev.disabled = o), t == s && (this.buttonNext.disabled = o);
                            }
                    };
                e && s && ((this.firstLastSlidesObserver = new MutationObserver(o)), this.firstLastSlidesObserver.observe(e, i), this.firstLastSlidesObserver.observe(s, i));
            }
        }
        positionArrows() {
            const t = this.slider.querySelector(pe) || this.slider.querySelector(he) || this.slider.querySelector(ue) || this.slider;
            t && this.style.setProperty("--button-position", t.clientHeight / 2 + "px");
        }
        arrowsResizeObserver() {
            document.addEventListener("theme:resize:width", this.positionArrows);
        }
        disconnectedCallback() {
            this.destroy(), document.removeEventListener("theme:resize:width", this.toggleSlider);
        }
        destroy() {
            var t, e;
            (this.isInitialized = !1),
                null === (t = this.draggableSlider) || void 0 === t || t.destroy(),
                (this.draggableSlider = null),
                null === (e = this.slidesObserver) || void 0 === e || e.destroy(),
                (this.slidesObserver = null),
                this.removeArrows(),
                document.removeEventListener("theme:resize:width", this.positionArrows);
        }
        constructor() {
            super(),
                (this.isInitialized = !1),
                (this.draggableSlider = null),
                (this.positionArrows = this.positionArrows.bind(this)),
                (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
                (this.slidesObserver = null),
                (this.firstLastSlidesObserver = null),
                (this.isDragging = !1),
                (this.toggleSlider = this.toggleSlider.bind(this));
        }
    }
    const Le = "time",
        ke = "[data-days]",
        Ae = "[data-hours]",
        Ce = "[data-minutes]",
        qe = "[data-seconds]",
        Te = ".shopify-section",
        xe = "[data-countdown-block]",
        Pe = "[data-ticker-text]",
        Ie = "data-expiration-behavior",
        He = "data-clone",
        Oe = "show-message",
        De = "hidden",
        Me = "hide-section",
        Be = "show-message";
    let Fe = class extends HTMLElement {
        connectedCallback() {
            isNaN(this.endDate) || this.endDate <= Date.now() ? this.onComplete() : (this.update(), (this.interval = setInterval(this.update, 1e3)));
        }
        disconnectedCallback() {
            this.stopTimer();
        }
        convertTime(t) {
            const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
            t -= e * this.daysInMs;
            const s = this.formatDigits(parseInt(t / this.hoursInMs, 10));
            t -= s * this.hoursInMs;
            const i = this.formatDigits(parseInt(t / this.minutesInMs, 10));
            t -= i * this.minutesInMs;
            return { days: e, hours: s, minutes: i, seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10)) };
        }
        formatDigits(t) {
            return t < 10 && (t = "0" + t), t;
        }
        render(t) {
            (this.days.textContent = t.days), (this.hours.textContent = t.hours), (this.minutes.textContent = t.minutes), (this.seconds.textContent = t.seconds);
        }
        stopTimer() {
            clearInterval(this.interval);
        }
        onComplete() {
            var t, e;
            (this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }), this.shouldHideOnComplete) &&
                (null === (t = this.countdownParent) || void 0 === t || t.classList.add(De),
                null === (e = this.countdownParent) || void 0 === e || e.dispatchEvent(new CustomEvent("theme:countdown:hide", { detail: { element: this }, bubbles: !0 })));
            if (this.shouldShowMessage) {
                var s, i;
                if ((null === (s = this.classList) || void 0 === s || s.add(Oe), this.closest(Pe).hasAttribute(He))) return;
                null === (i = this.countdownParent) || void 0 === i || i.dispatchEvent(new CustomEvent("theme:countdown:expire", { bubbles: !0 }));
            }
        }
        update() {
            const t = new Date().getTime(),
                e = this.endDate - t;
            e < 1e3 && (this.stopTimer(), this.onComplete());
            const s = this.convertTime(e);
            this.render(s);
        }
        constructor() {
            super(),
                (this.section = this.closest(Te)),
                (this.countdownParent = this.closest(xe) || this.section),
                (this.expirationBehavior = this.getAttribute(Ie)),
                (this.time = this.querySelector(Le)),
                (this.days = this.querySelector(ke)),
                (this.hours = this.querySelector(Ae)),
                (this.minutes = this.querySelector(Ce)),
                (this.seconds = this.querySelector(qe)),
                (this.endDate = Date.parse(this.time.dateTime)),
                (this.daysInMs = 864e5),
                (this.hoursInMs = this.daysInMs / 24),
                (this.minutesInMs = this.hoursInMs / 60),
                (this.secondsInMs = this.minutesInMs / 60),
                (this.shouldHideOnComplete = this.expirationBehavior === Me),
                (this.shouldShowMessage = this.expirationBehavior === Be),
                (this.update = this.update.bind(this));
        }
    };
    const _e = {
            animates: "data-animates",
            sliderule: "[data-sliderule]",
            slideruleOpen: "data-sliderule-open",
            slideruleClose: "data-sliderule-close",
            sliderulePane: "data-sliderule-pane",
            drawerContent: "[data-drawer-content]",
            focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
            children: ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * > [data-animates],\n             :scope > * > .sliderule-grid  > *",
        },
        $e = "is-visible",
        Ne = "is-hiding",
        Re = "is-hidden",
        We = "is-focused",
        Ue = "is-scrolling";
    let ze = class extends HTMLElement {
        clickEvents() {
            this.trigger.addEventListener("click", () => {
                (this.cachedButton = this.trigger), this.showSliderule();
            }),
                this.exit.forEach((t) => {
                    t.addEventListener("click", () => {
                        this.hideSliderule();
                    });
                });
        }
        keyboardEvents() {
            this.addEventListener("keyup", (t) => {
                t.stopPropagation(), "Escape" === t.code && this.hideSliderule();
            });
        }
        trapFocusSliderule(t = !0) {
            const e = t ? this.querySelector(this.exitSelector) : this.cachedButton;
            this.accessibility.removeTrapFocus(), e && this.drawerContent && this.accessibility.trapFocus(this.drawerContent, { elementToFocus: document.body.classList.contains(We) ? e : null });
        }
        hideSliderule(t = !1) {
            const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
            this.pane.setAttribute(_e.sliderulePane, e), this.pane.classList.add(Ne), this.sliderule.classList.add(Ne);
            const s = t ? `[${_e.animates}].${Re}` : `[${_e.animates}="${e}"]`,
                i = this.pane.querySelectorAll(s);
            i.length &&
                i.forEach((t) => {
                    t.classList.remove(Re);
                });
            const o = t ? this.pane.querySelectorAll(`.${$e}, .${Ne}`) : this.childrenElements;
            o.forEach((s, i) => {
                const n = o.length - 1 == i;
                s.classList.remove($e), t && (s.classList.remove(Ne), this.pane.classList.remove(Ne));
                const r = () => {
                    parseInt(this.pane.getAttribute(_e.sliderulePane)) === e && this.sliderule.classList.remove($e),
                        this.sliderule.classList.remove(Ne),
                        this.pane.classList.remove(Ne),
                        n && (this.accessibility.removeTrapFocus(), t || this.trapFocusSliderule(!1)),
                        s.removeEventListener("animationend", r);
                };
                window.theme.settings.enableAnimations ? s.addEventListener("animationend", r) : r();
            });
        }
        showSliderule() {
            let t = null;
            const e = this.closest(`.${$e}`);
            let s = this.pane;
            e && (s = e), s.scrollTo({ top: 0, left: 0, behavior: "smooth" }), s.classList.add(Ue);
            const i = () => {
                s.scrollTop <= 0 ? (s.classList.remove(Ue), t && cancelAnimationFrame(t)) : (t = requestAnimationFrame(i));
            };
            t = requestAnimationFrame(i);
            const o = parseInt(this.pane.dataset.sliderulePane, 10),
                n = o + 1;
            this.sliderule.classList.add($e), this.pane.setAttribute(_e.sliderulePane, n);
            const r = this.pane.querySelectorAll(`[${_e.animates}="${o}"]`);
            r.length &&
                r.forEach((t, e) => {
                    const s = r.length - 1 == e;
                    t.classList.add(Ne);
                    const i = () => {
                        t.classList.remove(Ne), parseInt(this.pane.getAttribute(_e.sliderulePane)) !== o && t.classList.add(Re), s && this.trapFocusSliderule(), t.removeEventListener("animationend", i);
                    };
                    window.theme.settings.enableAnimations ? t.addEventListener("animationend", i) : i();
                });
        }
        closeSliderule() {
            this.pane &&
                this.pane.hasAttribute(_e.sliderulePane) &&
                parseInt(this.pane.getAttribute(_e.sliderulePane)) > 0 &&
                (this.hideSliderule(!0), parseInt(this.pane.getAttribute(_e.sliderulePane)) > 0 && this.pane.setAttribute(_e.sliderulePane, 0));
        }
        disconnectedCallback() {
            document.removeEventListener("theme:sliderule:close", this.closeSliderule);
        }
        constructor() {
            super(), (this.key = this.id), (this.sliderule = this.querySelector(_e.sliderule));
            const t = `[${_e.slideruleOpen}='${this.key}']`;
            (this.exitSelector = `[${_e.slideruleClose}='${this.key}']`),
                (this.trigger = this.querySelector(t)),
                (this.exit = document.querySelectorAll(this.exitSelector)),
                (this.pane = this.trigger.closest(`[${_e.sliderulePane}]`)),
                (this.childrenElements = this.querySelectorAll(_e.children)),
                (this.drawerContent = this.closest(_e.drawerContent)),
                (this.cachedButton = null),
                (this.accessibility = $),
                this.trigger.setAttribute("aria-haspopup", !0),
                this.trigger.setAttribute("aria-expanded", !1),
                this.trigger.setAttribute("aria-controls", this.key),
                (this.closeSliderule = this.closeSliderule.bind(this)),
                this.clickEvents(),
                this.keyboardEvents(),
                document.addEventListener("theme:sliderule:close", this.closeSliderule);
        }
    };
    (window.requestIdleCallback =
        window.requestIdleCallback ||
        function (t) {
            var e = Date.now();
            return setTimeout(function () {
                t({
                    didTimeout: !1,
                    timeRemaining: function () {
                        return Math.max(0, 50 - (Date.now() - e));
                    },
                });
            }, 1);
        }),
        (window.cancelIdleCallback =
            window.cancelIdleCallback ||
            function (t) {
                clearTimeout(t);
            }),
        window.theme.settings.enableAnimations &&
            (!(function () {
                const t = document.querySelectorAll(Bt);
                t.length &&
                    t.forEach((t) => {
                        Rt.observe(t);
                    });
            })(),
            (function () {
                const t = document.querySelectorAll(Mt);
                t.length && Ut(t);
            })(),
            new MutationObserver(Nt).observe(document.body, _t),
            document.addEventListener("shopify:section:unload", (t) => {
                var e;
                const s = "#" + (null === (e = t.target.querySelector("[data-section-id]")) || void 0 === e ? void 0 : e.id),
                    i = $t.indexOf(s);
                -1 !== i && $t.splice(i, 1);
            })),
        window.addEventListener(
            "resize",
            u(function () {
                document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
                    b !== p() && (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })), (b = p())),
                    f !== m() && (document.dispatchEvent(new CustomEvent("theme:resize:height", { bubbles: !0 })), (f = m()));
            }, 50)
        ),
        (function () {
            let t;
            window.addEventListener(
                "scroll",
                function () {
                    t && window.cancelAnimationFrame(t),
                        (t = window.requestAnimationFrame(function () {
                            !(function () {
                                const t = window.scrollY;
                                t > y ? ((S = !0), (w = !1)) : t < y ? ((S = !1), (w = !0)) : ((w = null), (S = null)),
                                    (y = t),
                                    document.dispatchEvent(new CustomEvent("theme:scroll", { detail: { up: w, down: S, position: t }, bubbles: !1 })),
                                    w && !E && document.dispatchEvent(new CustomEvent("theme:scroll:up", { detail: { position: t }, bubbles: !1 })),
                                    S && !L && document.dispatchEvent(new CustomEvent("theme:scroll:down", { detail: { position: t }, bubbles: !1 })),
                                    (L = S),
                                    (E = w);
                            })();
                        }));
                },
                { passive: !0 }
            ),
                window.addEventListener("theme:scroll:lock", A),
                window.addEventListener("theme:scroll:unlock", C);
        })(),
        "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
            ? ((document.documentElement.className = document.documentElement.className.replace("no-touch", "supports-touch")), (window.theme.touch = !0))
            : (window.theme.touch = !1),
        l(),
        document.addEventListener(
            "load",
            (t) => {
                "img" == t.target.tagName.toLowerCase() &&
                    t.target.classList.contains(I) &&
                    (t.target.classList.remove(I), t.target.parentNode.classList.remove(I), t.target.parentNode.parentNode.classList.contains(I) && t.target.parentNode.parentNode.classList.remove(I));
            },
            !0
        ),
        window.addEventListener("DOMContentLoaded", () => {
            a(),
                P(document),
                o(document),
                x(document),
                document.querySelectorAll(H).forEach((t) => {
                    t.complete && (t.classList.remove(I), t.parentNode.classList.remove(I), t.parentNode.parentNode.classList.contains(I) && t.parentNode.parentNode.classList.remove(I));
                }),
                document.body.classList.add("is-loaded"),
                i(),
                requestIdleCallback(() => {
                    Shopify.visualPreviewMode && document.documentElement.classList.add("preview-mode");
                });
        }),
        document.addEventListener("shopify:section:load", (t) => {
            const e = t.target;
            o(e), x(e), P(document), a();
        }),
        customElements.get("header-drawer") || customElements.define("header-drawer", Q),
        customElements.get("mobile-sliderule") || customElements.define("mobile-sliderule", ze),
        customElements.get("popout-select") || customElements.define("popout-select", Ot),
        customElements.get("predictive-search") || customElements.define("predictive-search", gt),
        customElements.get("deferred-media") || customElements.define("deferred-media", ee),
        customElements.get("grid-slider") || customElements.define("grid-slider", Ee),
        customElements.get("countdown-timer") || customElements.define("countdown-timer", Fe),
        (Shopify.Products = (function () {
            const t = { howManyToShow: 4, howManyToStoreInMemory: 10, wrapperId: "recently-viewed-products", section: null, target: "api-product-grid-item", onComplete: null };
            let e = [],
                s = null,
                i = null;
            const o = new Date(),
                n = new Date();
            n.setTime(o.getTime() + 7776e6);
            const r = {
                    configuration: { expires: n.toGMTString(), path: "/", domain: window.location.hostname, sameSite: "none", secure: !0 },
                    name: "shopify_recently_viewed",
                    write: function (t) {
                        const e = encodeURIComponent(t.join(" "));
                        document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
                    },
                    read: function () {
                        let t = [],
                            e = null;
                        return (
                            -1 !== document.cookie.indexOf("; ") &&
                                document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                                (e = document.cookie
                                    .split("; ")
                                    .find((t) => t.startsWith(this.name))
                                    .split("=")[1]),
                            null !== e && (t = decodeURIComponent(e).split(" ")),
                            t
                        );
                    },
                    destroy: function () {
                        document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
                    },
                    remove: function (t) {
                        const e = this.read(),
                            s = e.indexOf(t);
                        -1 !== s && (e.splice(s, 1), this.write(e));
                    },
                },
                a = (e, s, o, n, l, c) => {
                    s.length && e < c
                        ? fetch(`${window.theme.routes.root}products/${s[0]}?section_id=${l}`)
                              .then((t) => t.text())
                              .then((t) => {
                                  const i = 100 * e,
                                      r = o.id ? `#${o.id}` : "",
                                      d = document.createElement("div");
                                  let h = t;
                                  (h = h.includes("||itemAnimationDelay||") ? h.replaceAll("||itemAnimationDelay||", i) : h),
                                      (h = h.includes("||itemAnimationAnchor||") ? h.replaceAll("||itemAnimationAnchor||", r) : h),
                                      (d.innerHTML = h),
                                      (o.innerHTML += d.querySelector("[data-api-content]").innerHTML),
                                      s.shift(),
                                      e++,
                                      a(e, s, o, n, l, c);
                              })
                              .catch(() => {
                                  r.remove(s[0]), s.shift(), a(e, s, o, n, l, c);
                              })
                        : ((e, s) => {
                              e.classList.remove("hidden");
                              const o = r.read().length;
                              if (Shopify.recentlyViewed && i && o && o < i && e.children.length) {
                                  let t = [],
                                      s = [],
                                      i = 0;
                                  for (const e in Shopify.recentlyViewed) {
                                      i += 1;
                                      const o = Shopify.recentlyViewed[e].split(" "),
                                          n = parseInt(e.split("_")[1]);
                                      (t = [...t, ...o]), (r.read().length === n || (i === Object.keys(Shopify.recentlyViewed).length && !s.length)) && (s = [...s, ...o]);
                                  }
                                  for (let i = 0; i < e.children.length; i++) {
                                      const o = e.children[i];
                                      t.length && o.classList.remove(...t), s.length && o.classList.add(...s);
                                  }
                              }
                              if (t.onComplete)
                                  try {
                                      t.onComplete(e, s);
                                  } catch (t) {
                                      console.log(t);
                                  }
                          })(o, n);
                };
            return {
                showRecentlyViewed: function (o) {
                    const n = o || {};
                    Object.assign(t, n),
                        (e = r.read()),
                        (s = document.querySelector(`#${t.wrapperId}`)),
                        (i = t.howManyToShow),
                        (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
                        t.howManyToShow && s && a(0, e, s, t.section, t.target, i);
                },
                getConfig: function () {
                    return t;
                },
                clearList: function () {
                    r.destroy();
                },
                recordRecentlyViewed: function (e) {
                    const s = e || {};
                    Object.assign(t, s);
                    let i = r.read();
                    if (-1 !== window.location.pathname.indexOf("/products/")) {
                        let e = decodeURIComponent(window.location.pathname)
                            .match(
                                /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
                            )[0]
                            .split("/products/")[1];
                        t.handle && (e = t.handle);
                        const s = i.indexOf(e);
                        -1 === s ? (i.unshift(e), (i = i.splice(0, t.howManyToStoreInMemory))) : (i.splice(s, 1), i.unshift(e)), r.write(i);
                    }
                },
                hasProducts: r.read().length > 0,
            };
        })());
    const Ve = "is-focused",
        je = "[data-skip-content]",
        Je = 'a[href="#"]';
    window.a11y = new (class {
        init() {
            (this.a11y = $),
                (this.html = document.documentElement),
                (this.body = document.body),
                (this.inPageLink = document.querySelector(je)),
                (this.linkesWithOnlyHash = document.querySelectorAll(Je)),
                this.a11y.focusHash(),
                this.a11y.bindInPageLinks(),
                this.clickEvents(),
                this.focusEvents();
        }
        clickEvents() {
            this.inPageLink &&
                this.inPageLink.addEventListener("click", (t) => {
                    t.preventDefault();
                }),
                this.linkesWithOnlyHash &&
                    this.linkesWithOnlyHash.forEach((t) => {
                        t.addEventListener("click", (t) => {
                            t.preventDefault();
                        });
                    });
        }
        focusEvents() {
            document.addEventListener("mousedown", () => {
                this.body.classList.remove(Ve);
            }),
                document.addEventListener("keyup", (t) => {
                    "Tab" === t.code && this.body.classList.add(Ve);
                });
        }
        constructor() {
            this.init();
        }
    })();
    function Xe(t, e) {
        "string" == typeof t && (t = t.replace(".", ""));
        let s = "";
        const i = /\{\{\s*(\w+)\s*\}\}/,
            o = e || "${{amount}}";
        function n(t, e = 2, s = ",", i = ".") {
            if (isNaN(t) || null == t) return 0;
            const o = (t = (t / 100).toFixed(e)).split(".");
            return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${s}`) + (o[1] ? i + o[1] : "");
        }
        switch (o.match(i)[1]) {
            case "amount":
                s = n(t, 2);
                break;
            case "amount_no_decimals":
                s = n(t, 0);
                break;
            case "amount_with_comma_separator":
                s = n(t, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                s = n(t, 0, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                s = n(t, 2, "'", ".");
                break;
            case "amount_no_decimals_with_space_separator":
                s = n(t, 0, " ", "");
                break;
            case "amount_with_space_separator":
                s = n(t, 2, " ", ",");
                break;
            case "amount_with_period_and_space_separator":
                s = n(t, 2, " ", ".");
        }
        return o.replace(i, s);
    }
    const Ge = (t, e) => {
        let s, i;
        return function o(...n) {
            const r = Date.now();
            (i = clearTimeout(i)), !s || r - s >= e ? (t.apply(null, n), (s = r)) : (i = setTimeout(o.bind(null, ...n), e - (r - s)));
        };
    };
    function Qe(t) {
        (this.status = t.status || null), (this.headers = t.headers || null), (this.json = t.json || null), (this.body = t.body || null);
    }
    Qe.prototype = Error.prototype;
    const Ye = "is-animated",
        Ke = "is-added",
        Ze = "is-disabled",
        ts = "is-empty",
        es = "is-hidden",
        ss = "is-hiding",
        is = "is-loading",
        os = "is-open",
        ns = "is-removed",
        rs = "is-success",
        as = "is-visible",
        ls = "is-expanded",
        cs = "is-updated",
        ds = "variant--soldout",
        hs = "variant--unavailable",
        us = "[data-api-content]",
        ps = "[data-api-line-items]",
        ms = "[data-api-upsell-items]",
        vs = "[data-api-cart-price]",
        gs = "[data-animation]",
        bs = "[data-skip-upsell-product]",
        fs = "[data-add-to-cart-bar]",
        ys = "[data-cart-error-close]",
        ws = "cart-drawer",
        Ss = "[data-cart-drawer-close]",
        Es = "[data-cart-empty]",
        Ls = "[data-cart-errors]",
        ks = "[data-item-remove]",
        As = "[data-cart-page]",
        Cs = "[data-cart-form]",
        qs = "[data-cart-acceptance-checkbox]",
        Ts = "[data-cart-checkout-buttons]",
        xs = "[data-cart-checkout-button]",
        Ps = "[data-cart-total]",
        Is = "[data-checkout-buttons]",
        Hs = "[data-error-message]",
        Os = "[data-close-error]",
        Ds = "[data-cart-errors-container]",
        Ms = "[data-form-wrapper]",
        Bs = "[data-free-shipping]",
        Fs = "[data-progress-graph]",
        _s = "[data-progress-bar]",
        $s = "[data-header-wrapper]",
        Ns = "[data-item]",
        Rs = "[data-items-holder]",
        Ws = "[data-left-to-spend]",
        Us = "[data-drawer]",
        zs = "[data-section-id]",
        Vs = "[data-cart-price-holder]",
        js = "[data-quick-add-holder]",
        Js = "[data-quick-add-modal]",
        Xs = 'input[name="updates[]"]',
        Gs = "[data-upsell-products]",
        Qs = "[data-upsell-widget]",
        Ys = "[data-terms-error-message]",
        Ks = "[data-collapsible-body]",
        Zs = "recently-viewed-products-cart",
        ti = "noscript",
        ei = "data-cart-total",
        si = "disabled",
        ii = "data-free-shipping",
        oi = "data-free-shipping-limit",
        ni = "data-item",
        ri = "data-item-index",
        ai = "data-item-title",
        li = "open",
        ci = "data-quick-add-holder",
        di = "data-scroll-locked",
        hi = "data-upsell-auto-open",
        ui = "name";
    let pi = class extends HTMLElement {
        connectedCallback() {
            (this.cartPage = document.querySelector(As)),
                (this.cartForm = document.querySelector(Cs)),
                (this.cartDrawer = document.querySelector(ws)),
                (this.cartEmpty = document.querySelector(Es)),
                (this.cartTermsCheckbox = document.querySelector(qs)),
                (this.cartCheckoutButtonWrapper = document.querySelector(Ts)),
                (this.cartCheckoutButton = document.querySelector(xs)),
                (this.checkoutButtons = document.querySelector(Is)),
                (this.itemsHolder = document.querySelector(Rs)),
                (this.priceHolder = document.querySelector(Vs)),
                (this.items = document.querySelectorAll(Ns)),
                (this.cartTotal = document.querySelector(Ps)),
                (this.freeShipping = document.querySelectorAll(Bs)),
                (this.cartErrorHolder = document.querySelector(Ls)),
                (this.cartCloseErrorMessage = document.querySelector(ys)),
                (this.headerWrapper = document.querySelector($s)),
                (this.navDrawer = document.querySelector(Us)),
                (this.upsellProductsHolder = document.querySelector(Gs)),
                (this.subtotal = window.theme.subtotal),
                (this.cart = this.cartDrawer || this.cartPage),
                (this.animateItems = this.animateItems.bind(this)),
                (this.addToCart = this.addToCart.bind(this)),
                (this.cartAddEvent = this.cartAddEvent.bind(this)),
                (this.updateProgress = this.updateProgress.bind(this)),
                (this.onCartDrawerClose = this.onCartDrawerClose.bind(this)),
                document.addEventListener("theme:cart:add", this.cartAddEvent),
                document.addEventListener("theme:announcement:init", this.updateProgress),
                "drawer" == theme.settings.cartType && (document.addEventListener("theme:cart-drawer:open", this.animateItems), document.addEventListener("theme:cart-drawer:close", this.onCartDrawerClose)),
                (this.skipUpsellProductsArray = []),
                this.skipUpsellProductEvent(),
                this.checkSkippedUpsellProductsFromStorage(),
                this.toggleCartUpsellWidgetVisibility(),
                (this.circumference = 28 * Math.PI),
                (this.freeShippingLimit = this.freeShipping.length ? 100 * Number(this.freeShipping[0].getAttribute(oi)) * window.Shopify.currency.rate : 0),
                this.freeShippingMessageHandle(this.subtotal),
                this.updateProgress(),
                (this.build = this.build.bind(this)),
                (this.updateCart = this.updateCart.bind(this)),
                (this.productAddCallback = this.productAddCallback.bind(this)),
                (this.formSubmitHandler = Ge(this.formSubmitHandler.bind(this), 50)),
                this.cartPage && this.animateItems(),
                this.cart && (this.recentlyViewedProducts(), (this.hasItemsInCart = this.hasItemsInCart.bind(this)), (this.cartCount = this.getCartItemCount())),
                (this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this)),
                (this.totalItems = this.items.length),
                (this.cartUpdateFailed = !1),
                this.cartEvents(),
                this.cartRemoveEvents(),
                this.cartUpdateEvents(),
                document.addEventListener("theme:product:add", this.productAddCallback),
                document.addEventListener("theme:product:add-error", this.productAddCallback),
                document.addEventListener("theme:cart:refresh", this.getCart.bind(this)),
                document.dispatchEvent(new CustomEvent("theme:cart:load", { bubbles: !0 }));
        }
        disconnectedCallback() {
            document.removeEventListener("theme:cart:add", this.cartAddEvent),
                document.removeEventListener("theme:cart:refresh", this.cartAddEvent),
                document.removeEventListener("theme:announcement:init", this.updateProgress),
                document.removeEventListener("theme:product:add", this.productAddCallback),
                document.removeEventListener("theme:product:add-error", this.productAddCallback),
                document.dispatchEvent(new CustomEvent("theme:cart:unload", { bubbles: !0 })),
                document.documentElement.hasAttribute(di) && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
        }
        onCartDrawerClose() {
            var t;
            this.resetAnimatedItems(),
                (null === (t = this.cartDrawer) || void 0 === t ? void 0 : t.classList.contains(os)) && this.cart.classList.remove(cs),
                this.cartEmpty.classList.remove(cs),
                this.cartErrorHolder.classList.remove(ls),
                this.cart.querySelectorAll(gs).forEach((t) => {
                    const e = () => {
                        t.classList.remove(ss), t.removeEventListener("animationend", e);
                    };
                    t.classList.add(ss), t.addEventListener("animationend", e);
                });
        }
        cartUpdateEvents() {
            (this.items = document.querySelectorAll(Ns)),
                this.items.forEach((t) => {
                    t.addEventListener("theme:cart:update", (e) => {
                        this.updateCart({ id: e.detail.id, quantity: e.detail.quantity }, t);
                    });
                });
        }
        cartRemoveEvents() {
            document.querySelectorAll(ks).forEach((t) => {
                const e = t.closest(Ns);
                t.addEventListener("click", (s) => {
                    s.preventDefault(), t.classList.contains(Ze) || this.updateCart({ id: t.dataset.id, quantity: 0 }, e);
         
                        // if(t.hasAttribute('data-mws-product')){
                        //     setTimeout(() => {
                        //         this.updateCart({ id: t.dataset.id, quantity: 0 }, e);
                        //     }, 1200);
                        // }
                });
            }),
                this.cartCloseErrorMessage &&
                    this.cartCloseErrorMessage.addEventListener("click", (t) => {
                        t.preventDefault(), this.cartErrorHolder.classList.remove(ls);
                    });
        }
        cartAddEvent(t) {
            let e = "",
                s = t.detail.button;
            if (s.hasAttribute("disabled")) return;
            const i = s.closest("form");
            if (!i.checkValidity()) return void i.reportValidity();
            e = new FormData(i);
            [...i.elements].some((t) => t.closest(ti)) && (e = this.handleFormDataDuplicates([...i.elements], e)),
                (null !== i && i.querySelector('[type="file"]')) || ("drawer" === theme.settings.cartType && this.cartDrawer && t.preventDefault(), this.addToCart(e, s));
        }
        handleFormDataDuplicates(t, e) {
            return t.length && "object" == typeof e
                ? (t.forEach((t) => {
                      if (t.closest(ti)) {
                          const s = t.getAttribute(ui),
                              i = t.value;
                          if (s) {
                              const t = e.getAll(s);
                              t.length > 1 && t.splice(t.indexOf(i), 1), e.delete(s), e.set(s, t[0]);
                          }
                      }
                  }),
                  e)
                : e;
        }
        cartEvents() {
            this.cartTermsCheckbox &&
                (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler),
                this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler),
                this.cartForm.removeEventListener("submit", this.formSubmitHandler),
                this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler),
                this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler),
                this.cartForm.addEventListener("submit", this.formSubmitHandler));
        }
        formSubmitHandler() {
            const t = document.querySelector(qs).checked,
                e = document.querySelector(Ys);
            if (t) e.classList.remove(ls), this.cartCheckoutButton.removeAttribute(si);
            else {
                if (document.querySelector(Ys).length > 0) return;
                (e.innerText = theme.strings.cartAcceptanceError), this.cartCheckoutButton.setAttribute(si, !0), e.classList.add(ls);
            }
        }
        formErrorsEvents(t) {
            const e = t.querySelector(Os);
            null == e ||
                e.addEventListener("click", (e) => {
                    e.preventDefault(), t && t.classList.remove(as);
                });
        }
        getCart() {
            fetch(theme.routes.cart_url + "?section_id=api-cart-items")
                .then(this.cartErrorsHandler)
                .then((t) => t.text())
                .then((t) => {
                    const e = document.createElement("div");
                    e.innerHTML = t;
                    const s = e.querySelector(us);
                    this.build(s);
                })
                .catch((t) => console.log(t));
        }
        addToCart(t, e) {
            this.cart && this.cart.classList.add(is);
            const s = null == e ? void 0 : e.closest(js);
            e && (e.classList.add(is), (e.disabled = !0)),
                s && s.classList.add(as),
                fetch(theme.routes.cart_add_url, { method: "POST", headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" }, body: t })
                    .then((t) => t.json())
                    .then((t) => {
                        if (t.status) return this.addToCartError(t, e), void (e && (e.classList.remove(is), (e.disabled = !1)));
                        this.cart
                            ? (e && (e.classList.remove(is), e.classList.add(Ke), e.dispatchEvent(new CustomEvent("theme:product:add", { detail: { response: t, button: e }, bubbles: !0 }))),
                              "page" === theme.settings.cartType && (window.location = theme.routes.cart_url),
                              this.getCart())
                            : (window.location = theme.routes.cart_url);
                    })
                    .catch((t) => {
                        this.addToCartError(t, e), this.enableCartButtons();
                    });
        }
        updateCart(t = {}, e = null) {
            this.cart.classList.add(is);
            let s = t.quantity;
            null !== e && (s ? e.classList.add(is) : e.classList.add(ns)), this.disableCartButtons();
            const i = this.cart.querySelector(`[${ni}="${t.id}"]`) || e,
                o = (null == i ? void 0 : i.hasAttribute(ri)) ? parseInt(i.getAttribute(ri)) : 0,
                n = (null == i ? void 0 : i.hasAttribute(ai)) ? i.getAttribute(ai) : null;
            if (0 === o) return;
            const r = { line: o, quantity: s };
            fetch(theme.routes.cart_change_url, { method: "post", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(r) })
                .then((t) => t.text())
                .then((t) => {
                    if (JSON.parse(t).errors) return (this.cartUpdateFailed = !0), this.updateErrorText(n), this.toggleErrorMessage(), this.resetLineItem(e), void this.enableCartButtons();
                    this.getCart();
                })
                .catch((t) => {
                    console.log(t), this.enableCartButtons();
                });
        }
        resetLineItem(t) {
            const e = t.querySelector(Xs),
                s = e.getAttribute("value");
            (e.value = s), t.classList.remove(is);
        }
        disableCartButtons() {
            const t = this.cart.querySelectorAll("input"),
                e = this.cart.querySelectorAll(`button, ${ks}`);
            t.length &&
                t.forEach((t) => {
                    t.classList.add(Ze), t.blur(), (t.disabled = !0);
                }),
                e.length &&
                    e.forEach((t) => {
                        t.setAttribute(si, !0);
                    });
        }
        enableCartButtons() {
            const t = this.cart.querySelectorAll("input"),
                e = this.cart.querySelectorAll(`button, ${ks}`);
            t.length &&
                t.forEach((t) => {
                    t.classList.remove(Ze), (t.disabled = !1);
                }),
                e.length &&
                    e.forEach((t) => {
                        t.removeAttribute(si);
                    }),
                this.cart.classList.remove(is);
        }
        updateErrorText(t) {
            this.cartErrorHolder.querySelector(Hs).innerText = t;
        }
        toggleErrorMessage() {
            this.cartErrorHolder && (this.cartErrorHolder.classList.toggle(ls, this.cartUpdateFailed), (this.cartUpdateFailed = !1));
        }
        cartErrorsHandler(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new Qe({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        addToCartError(t, e) {
            var s;
            if (null !== e) {
                const s = e.closest(zs) || e.closest(js) || e.closest(Js);
                let i = null == s ? void 0 : s.querySelector(Ds);
                const o = e.closest(js);
                if ((o && o.querySelector(Ds) && (i = o.querySelector(Ds)), i)) {
                    let e = `${t.message}: ${t.description}`;
                    t.message == t.description && (e = t.message),
                        (i.innerHTML = `<div class="errors">${e}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`),
                        i.classList.add(as),
                        this.formErrorsEvents(i);
                }
                e.dispatchEvent(new CustomEvent("theme:product:add-error", { detail: { response: t, button: e }, bubbles: !0 }));
            }
            const i = null == e ? void 0 : e.closest(js);
            i && i.dispatchEvent(new CustomEvent("theme:cart:error", { bubbles: !0, detail: { message: t.message, description: t.description, holder: i } })), null === (s = this.cart) || void 0 === s || s.classList.remove(is);
        }
        productAddCallback(t) {
            let e = [],
                s = null;
            const i = "theme:product:add-error" == t.type,
                o = t.detail.button,
                n = document.querySelector(fs);
            e.push(o),
                (s = o.closest(js)),
                n && e.push(n),
                e.forEach((t) => {
                    t.classList.remove(is), i || t.classList.add(Ke);
                }),
                setTimeout(() => {
                    e.forEach((t) => {
                        var e, s;
                        t.classList.remove(Ke);
                        (null === (e = t.closest(Ms)) || void 0 === e ? void 0 : e.classList.contains(ds)) || (null === (s = t.closest(Ms)) || void 0 === s ? void 0 : s.classList.contains(hs)) || (t.disabled = !1);
                    }),
                        null == s || s.classList.remove(as);
                }, 1e3);
        }
        toggleClassesOnContainers() {
            const t = this.hasItemsInCart();
            this.cart.classList.toggle(ts, !t),
                !t &&
                    this.cartDrawer &&
                    setTimeout(() => {
                        B(this.cartDrawer, { elementToFocus: this.cartDrawer.querySelector(Ss) });
                    }, 100);
        }
        build(t) {
            var e;
            const s = t.querySelector(ps),
                i = t.querySelector(ms),
                o = Boolean(null === s && null === i),
                n = t.querySelector(vs),
                r = t.querySelector(Ps);
            this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML),
                o
                    ? ((this.itemsHolder.innerHTML = t.innerHTML), this.upsellProductsHolder && (this.upsellProductsHolder.innerHTML = ""))
                    : ((this.itemsHolder.innerHTML = s.innerHTML),
                      this.upsellProductsHolder && (this.upsellProductsHolder.innerHTML = i.innerHTML),
                      this.skipUpsellProductEvent(),
                      this.checkSkippedUpsellProductsFromStorage(),
                      this.toggleCartUpsellWidgetVisibility()),
                (this.newTotalItems = s && s.querySelectorAll(Ns).length ? s.querySelectorAll(Ns).length : 0),
                (this.subtotal = r && r.hasAttribute(ei) ? parseInt(r.getAttribute(ei)) : 0),
                (this.cartCount = this.getCartItemCount()),
                document.dispatchEvent(new CustomEvent("theme:cart:change", { bubbles: !0, detail: { cartCount: this.cartCount } })),
                (this.cartTotal.innerHTML = 0 === this.subtotal ? window.theme.strings.free : Xe(this.subtotal, theme.moneyWithCurrencyFormat)),
                this.totalItems !== this.newTotalItems && ((this.totalItems = this.newTotalItems), this.toggleClassesOnContainers()),
                (null === (e = this.cartDrawer) || void 0 === e ? void 0 : e.classList.contains(os)) && this.cart.classList.add(cs),
                this.cart.classList.remove(is),
                this.hasItemsInCart() ||
                    this.cartEmpty.querySelectorAll(gs).forEach((t) => {
                        t.classList.remove(Ye);
                    }),
                this.freeShippingMessageHandle(this.subtotal),
                this.cartRemoveEvents(),
                this.cartUpdateEvents(),
                this.toggleErrorMessage(),
                this.enableCartButtons(),
                this.updateProgress(),
                this.animateItems(),
                document.dispatchEvent(new CustomEvent("theme:product:added", { bubbles: !0 }));
        }
        getCartItemCount() {
            return Array.from(this.cart.querySelectorAll(Xs)).reduce((t, e) => t + parseInt(e.value), 0);
        }
        hasItemsInCart() {
            return this.totalItems > 0;
        }
        freeShippingMessageHandle(t) {
            this.freeShipping.length &&
                this.freeShipping.forEach((e) => {
                    const s = e.hasAttribute(ii) && "true" === e.getAttribute(ii) && t >= 0;
                    e.classList.toggle(rs, s && t >= this.freeShippingLimit);
                });
        }
        updateProgress() {
            if (((this.freeShipping = document.querySelectorAll(Bs)), !this.freeShipping.length)) return;
            const t = isNaN(this.subtotal / this.freeShippingLimit) ? 100 : this.subtotal / this.freeShippingLimit,
                e = Math.min(100 * t, 100),
                s = this.circumference - ((e / 100) * this.circumference) / 2,
                i = Xe(this.freeShippingLimit - this.subtotal, theme.moneyFormat);
            this.freeShipping.forEach((t) => {
                const o = t.querySelector(_s),
                    n = t.querySelector(Fs),
                    r = t.querySelector(Ws);
                r && (r.innerHTML = i.replace(".00", "")), o && (o.value = e), n && n.style.setProperty("--stroke-dashoffset", `${s}`);
            });
        }
        skipUpsellProductEvent() {
            if (null === this.upsellProductsHolder) return;
            const t = this.upsellProductsHolder.querySelectorAll(bs);
            t.length &&
                t.forEach((t) => {
                    t.addEventListener("click", (e) => {
                        e.preventDefault();
                        const s = t.closest(js).getAttribute(ci);
                        this.skipUpsellProductsArray.includes(s) || this.skipUpsellProductsArray.push(s),
                            window.sessionStorage.setItem("skip_upsell_products", this.skipUpsellProductsArray),
                            this.removeUpsellProduct(s),
                            this.toggleCartUpsellWidgetVisibility();
                    });
                });
        }
        checkSkippedUpsellProductsFromStorage() {
            const t = window.sessionStorage.getItem("skip_upsell_products");
            if (!t) return;
            t.split(",").forEach((t) => {
                this.skipUpsellProductsArray.includes(t) || this.skipUpsellProductsArray.push(t), this.removeUpsellProduct(t);
            });
        }
        removeUpsellProduct(t) {
            if (!this.upsellProductsHolder) return;
            const e = this.upsellProductsHolder.querySelector(`[${ci}="${t}"]`);
            e && e.parentNode.remove();
        }
        toggleCartUpsellWidgetVisibility() {
            if (!this.upsellProductsHolder) return;
            const t = this.upsellProductsHolder.querySelectorAll(js),
                e = this.upsellProductsHolder.closest(Qs);
            if (e && (e.classList.toggle(es, !t.length), t.length && !e.hasAttribute(li) && e.hasAttribute(hi))) {
                e.setAttribute(li, !0);
                const t = e.querySelector(Ks);
                t && (t.style.height = "auto");
            }
        }
        resetAnimatedItems() {
            this.cart.querySelectorAll(gs).forEach((t) => {
                t.classList.remove(Ye), t.classList.remove(ss);
            });
        }
        animateItems(t) {
            requestAnimationFrame(() => {
                let e = this.cart;
                t && t.detail && t.detail.target && (e = t.detail.target),
                    null == e ||
                        e.querySelectorAll(gs).forEach((t) => {
                            t.classList.add(Ye);
                        });
            });
        }
        recentlyViewedProducts() {
            this.cart.querySelector(`#${Zs}`) && Shopify.Products.showRecentlyViewed({ howManyToShow: 3, wrapperId: Zs, section: this, target: "api-upsell-product" });
        }
        constructor() {
            super();
        }
    };
    customElements.get("cart-items") || customElements.define("cart-items", pi);
    const mi = "data-cart-count",
        vi = "data-limit";
    let gi = class extends HTMLElement {
        connectedCallback() {
            document.addEventListener("theme:cart:change", this.onCartChangeCallback);
        }
        disconnectedCallback() {
            document.addEventListener("theme:cart:change", this.onCartChangeCallback);
        }
        onCartChange(t) {
            // (this.cartCount = t.detail.cartCount), this.update();
            // // mudar
            //     carrinho(this.cartCount);
            // // até aqui

            
            fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
            const validItems = cart.items.filter(item => {
                return !item.properties || !item.properties._mws_option;
            });

            const count = validItems.reduce((sum, item) => sum + item.quantity, 0);
            this.cartCount = count;
            this.update();
            carrinho(this.cartCount);
            });

        }
        update() {
            if (null !== this.cartCount) {
                this.setAttribute(mi, this.cartCount);
                let t = this.cartCount;
                this.limit && this.cartCount >= this.limit && (t = "9+"), (this.innerText = t);
            }
        }
        constructor() {
            super(), (this.cartCount = null), (this.limit = this.getAttribute(vi)), (this.onCartChangeCallback = this.onCartChange.bind(this));
        }
    };
    customElements.get("cart-count") || customElements.define("cart-count", gi);
    const bi = "is-open",
        fi = "is-closing",
        yi = "drawer--duplicate",
        wi = "drawer-editor-error",
        Si = { cartDrawer: "cart-drawer", cartDrawerClose: "[data-cart-drawer-close]", cartDrawerSection: '[data-section-type="cart-drawer"]', cartDrawerInner: "[data-cart-drawer-inner]", shopifySection: ".shopify-section" },
        Ei = "data-drawer-underlay";
    let Li = class extends HTMLElement {
        connectedCallback() {
            const t = this.closest(Si.shopifySection);
            if (window.theme.hasCartDrawer) {
                if (!window.Shopify.designMode) return void t.remove();
                {
                    const t = document.createElement("div");
                    t.classList.add(wi), (t.innerText = "Cart drawer section already exists."), this.querySelector(`.${wi}`) || this.querySelector(Si.cartDrawerInner).append(t), this.classList.add(yi);
                }
            }
            (window.theme.hasCartDrawer = !0),
                this.addEventListener("theme:cart-drawer:show", this.openCartDrawer),
                document.addEventListener("theme:cart:toggle", this.toggleCartDrawer),
                document.addEventListener("theme:quick-add:open", this.closeCartDrawer),
                document.addEventListener("theme:product:added", this.openCartDrawerOnProductAdded),
                document.addEventListener("shopify:block:select", this.openCartDrawerOnSelect),
                document.addEventListener("shopify:section:select", this.openCartDrawerOnSelect),
                document.addEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect);
        }
        disconnectedCallback() {
            document.removeEventListener("theme:product:added", this.openCartDrawerOnProductAdded),
                document.removeEventListener("theme:cart:toggle", this.toggleCartDrawer),
                document.removeEventListener("theme:quick-add:open", this.closeCartDrawer),
                document.removeEventListener("shopify:block:select", this.openCartDrawerOnSelect),
                document.removeEventListener("shopify:section:select", this.openCartDrawerOnSelect),
                document.removeEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect),
                document.querySelectorAll(Si.cartDrawer).length <= 1 && (window.theme.hasCartDrawer = !1),
                i();
        }
        openCartDrawerOnProductAdded() {
            this.cartDrawerIsOpen || this.openCartDrawer();
        }
        openCartDrawerOnSelect(t) {
            (t.target.querySelector(Si.shopifySection) || t.target.closest(Si.shopifySection) || t.target) === this.cartDrawerSection && this.openCartDrawer(!0);
        }
        closeCartDrawerOnDeselect() {
            this.cartDrawerIsOpen && this.closeCartDrawer();
        }
        openCartDrawer(t = !1) {
            (!t && this.classList.contains(yi)) ||
                ((this.cartDrawerIsOpen = !0),
                (this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)),
                document.body.addEventListener("click", this.onBodyClickEvent),
                document.dispatchEvent(new CustomEvent("theme:cart-drawer:open", { detail: { target: this }, bubbles: !0 })),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                this.classList.add(bi),
                this.observeAdditionalCheckoutButtons(),
                N(this.cartDrawerInner).then(() => {
                    B(this, { elementToFocus: this.querySelector(Si.cartDrawerClose) });
                }));
        }
        closeCartDrawer() {
            this.classList.contains(bi) &&
                (this.classList.add(fi),
                this.classList.remove(bi),
                (this.cartDrawerIsOpen = !1),
                document.dispatchEvent(new CustomEvent("theme:cart-drawer:close", { bubbles: !0 })),
                F(),
                _(),
                document.body.removeEventListener("click", this.onBodyClickEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                N(this.cartDrawerInner).then(() => {
                    this.classList.remove(fi);
                }));
        }
        toggleCartDrawer() {
            this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
        }
        closeCartEvents() {
            this.cartDrawerClose.addEventListener("click", (t) => {
                t.preventDefault(), this.closeCartDrawer();
            }),
                this.addEventListener("keyup", (t) => {
                    "Escape" === t.code && this.closeCartDrawer();
                });
        }
        onBodyClick(t) {
            t.target.hasAttribute(Ei) && this.closeCartDrawer();
        }
        observeAdditionalCheckoutButtons() {
            const t = this.querySelector(Si.additionalCheckoutButtons);
            if (t) {
                const e = new MutationObserver(() => {
                    B(this, { elementToFocus: this.querySelector(Si.cartDrawerClose) }), e.disconnect();
                });
                e.observe(t, { subtree: !0, childList: !0 });
            }
        }
        constructor() {
            super(),
                (this.cartDrawerIsOpen = !1),
                (this.cartDrawerClose = this.querySelector(Si.cartDrawerClose)),
                (this.cartDrawerInner = this.querySelector(Si.cartDrawerInner)),
                (this.openCartDrawer = this.openCartDrawer.bind(this)),
                (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
                (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
                (this.openCartDrawerOnProductAdded = this.openCartDrawerOnProductAdded.bind(this)),
                (this.openCartDrawerOnSelect = this.openCartDrawerOnSelect.bind(this)),
                (this.closeCartDrawerOnDeselect = this.closeCartDrawerOnDeselect.bind(this)),
                (this.cartDrawerSection = this.closest(Si.shopifySection)),
                this.closeCartEvents();
        }
    };
    customElements.get("cart-drawer") || customElements.define("cart-drawer", Li);
    const ki = "[data-collapsible]",
        Ai = "[data-collapsible-trigger]",
        Ci = "[data-collapsible-body]",
        qi = "[data-collapsible-content]",
        Ti = "desktop",
        xi = "disabled",
        Pi = "mobile",
        Ii = "open",
        Hi = "single";
    let Oi = class extends HTMLElement {
        connectedCallback() {
            this.toggle(),
                document.addEventListener("theme:resize:width", this.toggle),
                this.collapsibles.forEach((t) => {
                    const e = t.querySelector(Ai),
                        s = t.querySelector(Ci);
                    null == e || e.addEventListener("click", (t) => this.onCollapsibleClick(t)),
                        null == s ||
                            s.addEventListener("transitionend", (e) => {
                                e.target === s && ("true" == t.getAttribute(Ii) && this.setBodyHeight(s, "auto"), "false" == t.getAttribute(Ii) && (t.removeAttribute(Ii), this.setBodyHeight(s, "")));
                            });
                });
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.toggle);
        }
        toggle() {
            const t = v();
            this.collapsibles.forEach((e) => {
                if (!e.hasAttribute(Ti) && !e.hasAttribute(Pi)) return;
                const s = e.hasAttribute(Ti) ? e.getAttribute(Ti) : "true",
                    i = e.hasAttribute(Pi) ? e.getAttribute(Pi) : "true",
                    o = (t && "true" == s) || (!t && "true" == i),
                    n = e.querySelector(Ci);
                o
                    ? (e.removeAttribute(xi), e.querySelector(Ai).removeAttribute("tabindex"), e.removeAttribute(Ii), this.setBodyHeight(n, ""))
                    : (e.setAttribute(xi, ""), e.setAttribute("open", !0), e.querySelector(Ai).setAttribute("tabindex", -1));
            });
        }
        open(t) {
            if ("true" == t.getAttribute("open")) return;
            const e = t.querySelector(Ci),
                s = t.querySelector(qi);
            t.setAttribute("open", !0), this.setBodyHeight(e, s.offsetHeight);
        }
        close(t) {
            if (!t.hasAttribute("open")) return;
            const e = t.querySelector(Ci),
                s = t.querySelector(qi);
            this.setBodyHeight(e, s.offsetHeight),
                t.setAttribute("open", !1),
                setTimeout(() => {
                    requestAnimationFrame(() => {
                        this.setBodyHeight(e, 0);
                    });
                });
        }
        setBodyHeight(t, e) {
            t.style.height = "auto" !== e && "" !== e ? `${e}px` : e;
        }
        onCollapsibleClick(t) {
            t.preventDefault();
            const e = t.target.closest(ki);
            this.single &&
                this.collapsibles.forEach((t) => {
                    t.hasAttribute(Ii) &&
                        t != e &&
                        requestAnimationFrame(() => {
                            this.close(t);
                        });
                }),
                e.hasAttribute(Ii) ? this.close(e) : this.open(e),
                e.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "accordion" } })),
                e.dispatchEvent(new CustomEvent("theme:collapsible:toggle", { bubbles: !0 }));
        }
        constructor() {
            super(), (this.collapsibles = this.querySelectorAll(ki)), (this.single = this.hasAttribute(Hi)), (this.toggle = this.toggle.bind(this));
        }
    };
    customElements.get("collapsible-elements") || customElements.define("collapsible-elements", Oi);
    const Di = "details",
        Mi = "[data-popdown]",
        Bi = "[data-popdown-close]",
        Fi = 'input:not([type="hidden"])',
        _i = "mobile-menu",
        $i = "data-popdown-underlay",
        Ni = "data-scroll-locked",
        Ri = "is-open";
    let Wi = class extends HTMLElement {
        connectedCallback() {
            this.popdown.addEventListener("transitionend", this.popdownTransitionCallback),
                this.popdownContainer.addEventListener("keyup", (t) => "ESCAPE" === t.code.toUpperCase() && this.close()),
                this.popdownContainer.addEventListener("toggle", this.detailsToggleCallback),
                this.popdownClose.addEventListener("click", this.close.bind(this));
        }
        detailsToggleCallback(t) {
            t.target.hasAttribute("open") && this.open();
        }
        popdownTransitionCallback(t) {
            t.target === this.popdown &&
                (this.classList.contains(Ri)
                    ? ("transform" !== t.propertyName && "opacity" !== t.propertyName) || this.a11y.trapFocus(this.popdown, { elementToFocus: this.popdown.querySelector(Fi) })
                    : (this.popdownContainer.removeAttribute("open"), this.a11y.removeTrapFocus()));
        }
        onBodyClick(t) {
            (this.contains(t.target) && !t.target.hasAttribute($i)) || this.close();
        }
        open() {
            var t;
            (this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)),
                document.body.addEventListener("click", this.onBodyClickEvent),
                null === (t = this.mobileMenu) || void 0 === t || t.dispatchEvent(new CustomEvent("theme:search:open")),
                document.documentElement.hasAttribute(Ni) || document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                requestAnimationFrame(() => {
                    this.classList.add(Ri);
                });
        }
        close() {
            var t;
            this.classList.remove(Ri),
                null === (t = this.mobileMenu) || void 0 === t || t.dispatchEvent(new CustomEvent("theme:search:close")),
                document.body.removeEventListener("click", this.onBodyClickEvent),
                this.mobileMenu || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
        }
        constructor() {
            super(),
                (this.popdown = this.querySelector(Mi)),
                (this.popdownContainer = this.querySelector(Di)),
                (this.popdownClose = this.querySelector(Bi)),
                (this.popdownTransitionCallback = this.popdownTransitionCallback.bind(this)),
                (this.detailsToggleCallback = this.detailsToggleCallback.bind(this)),
                (this.mobileMenu = this.closest(_i)),
                (this.a11y = $);
        }
    };
    customElements.define("header-search-popdown", Wi);
    const Ui = 'input[type="search"]';
    customElements.define(
        "main-search",
        class extends et {
            setupEventListeners() {
                let t = [];
                this.allSearchInputs.forEach((e) => t.push(e.form)),
                    this.input.addEventListener("focus", this.onInputFocus.bind(this)),
                    t.length < 2 || (t.forEach((t) => t.addEventListener("reset", this.onFormReset.bind(this))), this.allSearchInputs.forEach((t) => t.addEventListener("input", this.onInput.bind(this))));
            }
            onFormReset(t) {
                super.onFormReset(t), super.shouldResetForm() && this.keepInSync("", this.input);
            }
            onInput(t) {
                const e = t.target;
                this.keepInSync(e.value, e);
            }
            onInputFocus() {
                v() || this.scrollIntoView({ behavior: "smooth" });
            }
            keepInSync(t, e) {
                this.allSearchInputs.forEach((s) => {
                    s !== e && (s.value = t);
                });
            }
            constructor() {
                super(), (this.allSearchInputs = document.querySelectorAll(Ui)), this.setupEventListeners();
            }
        }
    );
    const zi = "[data-actions]",
        Vi = "[data-content]",
        ji = "[data-button]",
        Ji = "data-height",
        Xi = "is-open",
        Gi = "is-enabled";
    let Qi = class extends HTMLElement {
        connectedCallback() {
            this.setHeight(this.initialHeight),
                this.trigger.addEventListener("click", () => {
                    this.setHeight(this.content.offsetHeight), this.classList.add(Xi);
                }),
                this.setHeight(this.initialHeight),
                this.toggleActions(),
                document.addEventListener("theme:resize", this.toggleActions),
                document.addEventListener("theme:collapsible:toggle", this.toggleActions);
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize", this.toggleActions), document.removeEventListener("theme:collapsible:toggle", this.toggleActions);
        }
        setHeight(t) {
            this.style.setProperty("--height", `${t}px`);
        }
        toggleActions() {
            this.classList.toggle(Gi, this.content.offsetHeight + this.actions.offsetHeight > this.initialHeight);
        }
        constructor() {
            super(),
                (this.initialHeight = this.getAttribute(Ji)),
                (this.content = this.querySelector(Vi)),
                (this.trigger = this.querySelector(ji)),
                (this.actions = this.querySelector(zi)),
                (this.toggleActions = this.toggleActions.bind(this));
        }
    };
    customElements.get("toggle-ellipsis") || customElements.define("toggle-ellipsis", Qi),
        (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    const Yi = window.Shopify.theme.sections.registered,
        Ki = window.Shopify.theme.sections.instances,
        Zi = "data-section-id",
        to = "data-section-type";
    let eo = class {
        callFunctions(t, e = null) {
            this.callStack[t].forEach((t) => {
                const s = { id: this.id, type: this.type, container: this.container };
                e ? t.call(s, e) : t.call(s);
            });
        }
        onLoad() {
            this.callFunctions("onLoad");
        }
        onUnload() {
            this.callFunctions("onUnload");
        }
        onSelect(t) {
            this.callFunctions("onSelect", t);
        }
        onDeselect(t) {
            this.callFunctions("onDeselect", t);
        }
        onBlockSelect(t) {
            this.callFunctions("onBlockSelect", t);
        }
        onBlockDeselect(t) {
            this.callFunctions("onBlockDeselect", t);
        }
        onReorder(t) {
            this.callFunctions("onReorder", t);
        }
        constructor(t, e) {
            (this.container = (function (t) {
                if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                if (null === t.getAttribute(Zi)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + Zi + " attribute.");
                return t;
            })(t)),
                (this.id = t.getAttribute(Zi)),
                (this.type = e.type),
                (this.callStack = e.getStack());
            try {
                this.onLoad();
            } catch (t) {
                console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t);
            }
        }
    };
    function so(t, e) {
        if ("string" != typeof t) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== Yi[t]) throw new Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        const s = new (class {
            getStack() {
                return this.callStack;
            }
            constructor(t = null, e = []) {
                (this.type = t),
                    (this.components = (function (t) {
                        if ((void 0 !== t && "object" != typeof t) || null === t) throw new TypeError("Theme Sections: The components object provided is not a valid");
                        return t;
                    })(e)),
                    (this.callStack = { onLoad: [], onUnload: [], onSelect: [], onDeselect: [], onBlockSelect: [], onBlockDeselect: [], onReorder: [] }),
                    e.forEach((t) => {
                        for (const [e, s] of Object.entries(t)) {
                            const t = this.callStack[e];
                            Array.isArray(t) && "function" == typeof s ? t.push(s) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(s));
                        }
                    });
            }
        })(t, e);
        return (Yi[t] = s), Yi;
    }
    function io(t, e) {
        (t = ro(t)),
            void 0 === e && (e = document.querySelectorAll("[" + to + "]")),
            (e = ao(e)),
            t.forEach(function (t) {
                const s = Yi[t];
                void 0 !== s &&
                    (e = e.filter(function (e) {
                        return !(oo(e).length > 0) && null !== e.getAttribute(to) && (e.getAttribute(to) !== t || (Ki.push(new eo(e, s)), !1));
                    }));
            });
    }
    function oo(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var s = t[0];
        if (t instanceof Element || s instanceof Element)
            ao(t).forEach(function (t) {
                e = e.concat(
                    Ki.filter(function (e) {
                        return e.container === t;
                    })
                );
            });
        else if ("string" == typeof t || "string" == typeof s) {
            ro(t).forEach(function (t) {
                e = e.concat(
                    Ki.filter(function (e) {
                        return e.type === t;
                    })
                );
            });
        }
        return e;
    }
    function no(t) {
        for (var e, s = 0; s < Ki.length; s++)
            if (Ki[s].id === t) {
                e = Ki[s];
                break;
            }
        return e;
    }
    function ro(t) {
        return (
            "*" === t
                ? (t = Object.keys(Yi))
                : "string" == typeof t
                ? (t = [t])
                : t.constructor === eo
                ? (t = [t.prototype.type])
                : Array.isArray(t) &&
                  t[0].constructor === eo &&
                  (t = t.map(function (t) {
                      return t.type;
                  })),
            (t = t.map(function (t) {
                return t.toLowerCase();
            }))
        );
    }
    function ao(t) {
        return (
            NodeList.prototype.isPrototypeOf(t) && t.length > 0
                ? (t = Array.prototype.slice.call(t))
                : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
                ? (t = [])
                : !Array.isArray(t) && t instanceof Element && (t = [t]),
            t
        );
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (t) {
            var e = t.detail.sectionId,
                s = t.target.querySelector("[" + Zi + '="' + e + '"]');
            null !== s && io(s.getAttribute(to), s);
        }),
        document.addEventListener("shopify:section:reorder", function (t) {
            var e = t.detail.sectionId,
                s = t.target.querySelector("[" + Zi + '="' + e + '"]');
            "object" == typeof oo(s)[0] &&
                oo(s).forEach(function (t) {
                    t.onReorder();
                });
        }),
        document.addEventListener("shopify:section:unload", function (t) {
            var e = t.detail.sectionId,
                s = t.target.querySelector("[" + Zi + '="' + e + '"]');
            "object" == typeof oo(s)[0] &&
                oo(s).forEach(function (t) {
                    var e = Ki.map(function (t) {
                        return t.id;
                    }).indexOf(t.id);
                    Ki.splice(e, 1), t.onUnload();
                });
        }),
        document.addEventListener("shopify:section:select", function (t) {
            var e = no(t.detail.sectionId);
            "object" == typeof e && e.onSelect(t);
        }),
        document.addEventListener("shopify:section:deselect", function (t) {
            var e = no(t.detail.sectionId);
            "object" == typeof e && e.onDeselect(t);
        }),
        document.addEventListener("shopify:block:select", function (t) {
            var e = no(t.detail.sectionId);
            "object" == typeof e && e.onBlockSelect(t);
        }),
        document.addEventListener("shopify:block:deselect", function (t) {
            var e = no(t.detail.sectionId);
            "object" == typeof e && e.onBlockDeselect(t);
        }));
    const lo = "[data-section-id]",
        co = "data-tooltip",
        ho = "data-tooltip-stop-mouseenter",
        uo = "tooltip-default",
        po = "is-visible",
        mo = "is-hiding";
    let vo = {},
        go = class {
            init() {
                if (!document.querySelector(`.${this.class}`)) {
                    const t = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
                        e = document.createElement("div");
                    (e.className = this.class), (e.innerHTML = t), document.body.appendChild(e);
                }
                this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
                    this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
                    this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
                    document.addEventListener("theme:tooltip:close", this.removePinEvent);
            }
            addPin(t = !1) {
                const e = document.querySelector(`.${this.class}`),
                    s = this.tooltip.closest(lo),
                    i = Array.from(s.classList).find((t) => t.startsWith("color-scheme-"));
                if ((null == e || e.classList.add(i), this.label && e && ((t && !this.tooltip.hasAttribute(ho)) || !t))) {
                    const t = e.querySelector(`.${this.class}__arrow`),
                        s = e.querySelector(`.${this.class}__inner`);
                    e.querySelector(`.${this.class}__text`).innerHTML = this.label;
                    const i = s.offsetWidth,
                        o = this.tooltip.getBoundingClientRect(),
                        n = o.top,
                        r = o.width,
                        a = n + o.height + window.scrollY;
                    let l = o.left - i / 2 + r / 2;
                    const c = 24,
                        d = l + i - p() + c;
                    d > 0 && (l -= d),
                        l < 0 && (l = 0),
                        (t.style.left = `${o.left + r / 2}px`),
                        e.style.setProperty("--tooltip-top", `${a}px`),
                        (s.style.transform = `translateX(${l}px)`),
                        e.classList.remove(mo),
                        e.classList.add(po),
                        document.addEventListener("theme:scroll", this.removePinEvent);
                }
            }
            removePin(t, e = !1, s = !1) {
                const i = document.querySelector(`.${this.class}`),
                    o = i.classList.contains(po);
                i &&
                    ((e && !this.tooltip.hasAttribute(ho)) || !e) &&
                    (o &&
                        (s || t.detail.hideTransition) &&
                        (i.classList.add(mo),
                        this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
                        (this.hideTransitionTimeout = setTimeout(() => {
                            i.classList.remove(mo);
                        }, this.transitionSpeed))),
                    i.classList.remove(po),
                    document.removeEventListener("theme:scroll", this.removePinEvent));
            }
            unload() {
                this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
                    this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent),
                    this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent),
                    document.removeEventListener("theme:tooltip:close", this.removePinEvent),
                    document.removeEventListener("theme:scroll", this.removePinEvent);
            }
            constructor(t, e = {}) {
                (this.tooltip = t),
                    this.tooltip.hasAttribute(co) &&
                        ((this.label = this.tooltip.getAttribute(co)),
                        (this.class = e.class || uo),
                        (this.transitionSpeed = e.transitionSpeed || 200),
                        (this.hideTransitionTimeout = 0),
                        (this.addPinEvent = () => this.addPin()),
                        (this.addPinMouseEvent = () => this.addPin(!0)),
                        (this.removePinEvent = (t) => Ge(this.removePin(t), 50)),
                        (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
                        this.init());
            }
        };
    const bo = {
        onLoad() {
            vo[this.id] = [];
            this.container.querySelectorAll(`[${co}]`).forEach((t) => {
                vo[this.id].push(new go(t));
            });
        },
        onUnload: function () {
            vo[this.id].forEach((t) => {
                "function" == typeof t.unload && t.unload();
            });
        },
    };
    so("article", [bo]);
    const fo = "[data-aos]",
        yo = ".collection-item__image",
        wo = "[data-column-image]",
        So = ".flickity-button.next",
        Eo = ".flickity-button.previous",
        Lo = "a:not(.btn)",
        ko = ".product-item__image",
        Ao = "[data-slide]",
        Co = "data-slide",
        qo = "[data-slider]",
        To = "[data-slider-thumb]",
        xo = "data-arrow-position-middle",
        Po = "data-slide-index",
        Io = "data-options",
        Ho = "data-slide-text-color",
        Oo = "aos-animate",
        Do = "desktop",
        Mo = "is-focused",
        Bo = "flickity-enabled",
        Fo = "is-initialized",
        _o = "is-loading",
        $o = "is-selected",
        No = "mobile",
        Ro = "single-slide",
        Wo = {};
    let Uo = class {
        init() {
            this.slideshow.classList.add(_o);
            let t = Ao;
            const i = v(),
                o = `${Ao}:not(.${No})`,
                n = `${Ao}:not(.${Do})`;
            (this.slideshow.querySelectorAll(n).length || this.slideshow.querySelectorAll(o).length) && (t = i ? o : n),
                this.slideshow.querySelectorAll(t).length <= 1 && (this.slideshow.classList.add(Ro), this.slideshow.classList.remove(_o)),
                (this.sliderOptions = {
                    cellSelector: t,
                    contain: !0,
                    wrapAround: !0,
                    adaptiveHeight: !0,
                    ...this.customOptions,
                    on: {
                        ready: () => {
                            requestAnimationFrame(() => {
                                this.slideshow.classList.add(Fo), this.slideshow.classList.remove(_o), this.slideshow.parentNode.dispatchEvent(new CustomEvent("theme:slider:loaded", { bubbles: !0, detail: { slider: this } }));
                            }),
                                this.slideActions(),
                                this.sliderOptions.prevNextButtons && this.positionArrows();
                        },
                        change: (t) => {
                            const e = this.slideshowSlides[t];
                            if (!e || this.sliderOptions.groupCells) return;
                            const s = e.querySelectorAll(fo);
                            s.length &&
                                s.forEach((t) => {
                                    t.classList.remove(Oo),
                                        requestAnimationFrame(() => {
                                            setTimeout(() => {
                                                t.classList.add(Oo);
                                            }, 0);
                                        });
                                });
                        },
                        resize: () => {
                            this.sliderOptions.prevNextButtons && this.positionArrows();
                        },
                    },
                }),
                this.sliderOptions.fade && (this.flkty = new s(this.slideshow, this.sliderOptions)),
                this.sliderOptions.fade || (this.flkty = new e(this.slideshow, this.sliderOptions)),
                this.flkty.on("change", () => this.slideActions(!0)),
                this.sliderThumbs.length &&
                    this.sliderThumbs.forEach((t) => {
                        t.addEventListener("click", (e) => {
                            e.preventDefault();
                            const s = [...t.parentElement.children].indexOf(t);
                            this.flkty.select(s);
                        });
                    }),
                (this.flkty && this.flkty.isActive) || this.slideshow.classList.remove(_o);
        }
        slideActions(t = !1) {
            const e = this.slideshow.querySelector(`.${$o}`);
            if (!e) return;
            const s = e.hasAttribute(Ho) ? e.getAttribute(Ho) : "",
                i = e.querySelector(Lo),
                o = this.slideshow.querySelectorAll(`${Ao} a, ${Ao} button`);
            if (
                (document.body.classList.contains(Mo) && i && this.sliderOptions.groupCells && t && i.focus(),
                o.length &&
                    o.forEach((t) => {
                        const e = t.closest(Ao);
                        if (e) {
                            const s = e.classList.contains($o) ? 0 : -1;
                            t.setAttribute("tabindex", s);
                        }
                    }),
                this.slideshow.style.setProperty("--text", s),
                this.sliderThumbs.length && this.sliderThumbs.length === this.slideshowSlides.length && e.hasAttribute(Po))
            ) {
                const t = parseInt(e.getAttribute(Po)),
                    s = this.container.querySelector(`${To}.${$o}`);
                s && s.classList.remove($o), this.sliderThumbs[t].classList.add($o);
            }
        }
        positionArrows() {
            if (this.slideshow.hasAttribute(xo) && this.sliderOptions.prevNextButtons) {
                const t = this.slideshow.querySelector(yo) || this.slideshow.querySelector(ko) || this.slideshow.querySelector(wo);
                if (!t) return;
                (this.slideshow.querySelector(Eo).style.top = t.clientHeight / 2 + "px"), (this.slideshow.querySelector(So).style.top = t.clientHeight / 2 + "px");
            }
        }
        onUnload() {
            this.slideshow && this.flkty && ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
        }
        onBlockSelect(t) {
            if (!this.slideshow) return;
            const e = this.slideshow.querySelector(`[${Co}="${t.detail.blockId}"]`);
            if (!e) return;
            let s = parseInt(e.getAttribute(Po));
            this.slideshow.classList.add($o), this.flkty && this.slideshow.classList.contains(Bo) && (this.flkty.selectCell(s), this.flkty.stopPlayer());
        }
        onBlockDeselect() {
            this.slideshow && (this.slideshow.classList.remove($o), this.flkty && this.sliderOptions.hasOwnProperty("autoPlay") && this.sliderOptions.autoPlay && this.flkty.playPlayer());
        }
        constructor(t, e = null) {
            (this.container = t),
                (this.slideshow = e || this.container.querySelector(qo)),
                this.slideshow &&
                    ((this.slideshowSlides = this.slideshow.querySelectorAll(Ao)),
                    this.slideshowSlides.length <= 1 ||
                        ((this.sliderThumbs = this.container.querySelectorAll(To)),
                        this.slideshow.hasAttribute(Io) && (this.customOptions = JSON.parse(decodeURIComponent(this.slideshow.getAttribute(Io)))),
                        (this.flkty = null),
                        this.init()));
        }
    };
    const zo = {
        onLoad() {
            Wo[this.id] = [];
            this.container.querySelectorAll(qo).forEach((t) => {
                Wo[this.id].push(new Uo(this.container, t));
            });
        },
        onUnload() {
            Wo[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
        onBlockSelect(t) {
            Wo[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
            });
        },
        onBlockDeselect(t) {
            Wo[this.id].forEach((e) => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
            });
        },
    };
    so("blog-section", [zo]), so("double", zo);
    const Vo = (t) => {
        let { stickyHeaderHeight: e } = r();
        window.scrollTo({ top: t + window.scrollY - e, left: 0, behavior: "smooth" });
    };
    let jo = class {
        write() {
            ((-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((t) => t.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) &&
                (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
        }
        read() {
            if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t) => t.startsWith(this.name))) {
                return document.cookie
                    .split("; ")
                    .find((t) => t.startsWith(this.name))
                    .split("=")[1];
            }
            return !1;
        }
        destroy() {
            document.cookie.split("; ").find((t) => t.startsWith(this.name)) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
        }
        constructor(t, e, s = 7) {
            const i = new Date(),
                o = new Date();
            o.setTime(i.getTime() + 864e5 * s), (this.configuration = { expires: o.toGMTString(), path: "/", domain: window.location.hostname, sameSite: "none", secure: !0 }), (this.name = t), (this.value = e);
        }
    };
    const Jo = "[data-newsletter-form]",
        Xo = "[data-newsletter-heading]",
        Go = "[data-newsletter]",
        Qo = "has-success",
        Yo = "has-error",
        Ko = "hidden",
        Zo = "data-cookie-name",
        tn = {};
    const en = {
        onLoad() {
            tn[this.id] = [];
            this.container.querySelectorAll(Jo).forEach((t) => {
                tn[this.id].push(
                    new (class {
                        init() {
                            this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage();
                        }
                        newsletterSubmitEvent(t) {
                            this.stopSubmit && (t.preventDefault(), t.stopImmediatePropagation(), this.removeStorage(), this.writeStorage(), (this.stopSubmit = !1), this.newsletter.submit());
                        }
                        checkForChallengePage() {
                            this.isChallengePage = "/challenge" === window.location.pathname;
                        }
                        writeStorage() {
                            void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
                        }
                        readStorage() {
                            this.formID = this.sessionStorage.getItem("newsletter_form_id");
                        }
                        removeStorage() {
                            this.sessionStorage.removeItem("newsletter_form_id");
                        }
                        showMessage() {
                            if ((this.readStorage(), this.newsletter.id === this.formID)) {
                                const t = document.getElementById(this.formID),
                                    e = t.parentElement.querySelector(Xo),
                                    s = -1 !== window.location.search.indexOf("?customer_posted=true"),
                                    i = -1 !== window.location.search.indexOf("accepts_marketing");
                                s
                                    ? (t.classList.remove(Yo), t.classList.add(Qo), e && (e.classList.add(Ko), t.classList.remove(Ko)), this.popup && this.cookie.write())
                                    : i && (t.classList.remove(Qo), t.classList.add(Yo), e && (e.classList.add(Ko), t.classList.remove(Ko))),
                                    (s || i) &&
                                        window.addEventListener("load", () => {
                                            this.scrollToForm(t);
                                        });
                            }
                        }
                        scrollToForm(t) {
                            const e = t.getBoundingClientRect();
                            (e.top >= 0 && e.left >= 0 && e.bottom <= m() && e.right <= p()) ||
                                setTimeout(() => {
                                    Vo(t.getBoundingClientRect().top);
                                }, 500);
                        }
                        unload() {
                            this.newsletter.removeEventListener("submit", this.newsletterSubmit);
                        }
                        constructor(t) {
                            (this.sessionStorage = window.sessionStorage),
                                (this.newsletter = t),
                                (this.popup = this.newsletter.closest(Go)),
                                this.popup && (this.cookie = new jo(this.popup.getAttribute(Zo), "user_has_closed", null)),
                                (this.stopSubmit = !0),
                                (this.isChallengePage = !1),
                                (this.formID = null),
                                this.checkForChallengePage(),
                                (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                                this.isChallengePage || this.init();
                        }
                    })(t)
                );
            });
        },
        onUnload() {
            tn[this.id].forEach((t) => {
                "function" == typeof t.unload && t.unload();
            });
        },
    };
    so("footer", [en]);
    const sn = "[data-collection-sidebar]",
        on = "[data-collection-sidebar-slide-out]",
        nn = "[data-collection-sidebar-close]",
        rn = "[data-aria-toggle]",
        an = "drawer--animated",
        ln = "expanded",
        cn = "no-mobile-animation",
        dn = "is-focused";
    let hn = {};
    so("collection", [
        zo,
        {
            onLoad() {
                hn[this.id] = new (class {
                    init() {
                        null !== this.groupTagsButton &&
                            (document.addEventListener("theme:resize:width", this.sidebarResizeEvent),
                            this.groupTagsButton.addEventListener("click", this.groupTagsButtonClickEvent),
                            this.collectionSidebar &&
                                setTimeout(() => {
                                    this.collectionSidebar.classList.remove(cn);
                                }, 1e3),
                            new MutationObserver((t) => {
                                for (const e of t) "attributes" === e.type && "true" == e.target.getAttribute("aria-expanded") && this.showSidebarCallback();
                            }).observe(this.groupTagsButton, { attributes: !0, childList: !1, subtree: !1 })),
                            this.container.addEventListener(
                                "keyup",
                                function (t) {
                                    "Escape" === t.code && this.hideSidebar();
                                }.bind(this)
                            ),
                            this.collectionSidebar &&
                                (this.collectionSidebar.addEventListener("transitionend", () => {
                                    this.collectionSidebar.classList.contains(ln) || this.collectionSidebar.classList.remove(an);
                                }),
                                this.toggleSidebarSlider(),
                                this.container.addEventListener("theme:filter:close", this.collectionSidebarCloseEvent));
                    }
                    showSidebarCallback() {
                        const t = this.container.querySelector(on),
                            e = document.documentElement.hasAttribute("data-scroll-locked"),
                            s = g();
                        this.collectionSidebar.classList.add(an),
                            null === t && !s && e && (this.a11y.removeTrapFocus(), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }))),
                            (s || null !== t) &&
                                (t && this.a11y.trapFocus(this.collectionSidebar, { elementToFocus: this.collectionSidebar.querySelector(nn) }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })));
                    }
                    hideSidebar() {
                        const t = this.container.querySelector(on),
                            e = document.documentElement.hasAttribute("data-scroll-locked");
                        this.groupTagsButton.setAttribute("aria-expanded", "false"),
                            this.collectionSidebar.classList.remove(ln),
                            t && this.a11y.removeTrapFocus(),
                            e && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                    }
                    toggleSidebarSlider() {
                        g() ? this.hideSidebar() : this.collectionSidebar.classList.contains(ln) && this.showSidebarCallback();
                    }
                    collectionSidebarClose(t) {
                        t.preventDefault(), this.hideSidebar(), document.body.classList.contains(dn) && this.groupTagsButton && this.groupTagsButton.focus();
                    }
                    groupTagsButtonClick() {
                        document.documentElement.hasAttribute("data-scroll-locked") && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                    }
                    onUnload() {
                        null !== this.groupTagsButton && (document.removeEventListener("theme:resize:width", this.sidebarResizeEvent), this.groupTagsButton.removeEventListener("click", this.groupTagsButtonClickEvent)),
                            this.collectionSidebar && this.container.removeEventListener("theme:filter:close", this.collectionSidebarCloseEvent);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.collectionSidebar = this.container.querySelector(sn)),
                            (this.groupTagsButton = this.container.querySelector(rn)),
                            (this.a11y = $),
                            (this.groupTagsButtonClickEvent = (t) => this.groupTagsButtonClick(t)),
                            (this.sidebarResizeEvent = () => this.toggleSidebarSlider()),
                            (this.collectionSidebarCloseEvent = (t) => this.collectionSidebarClose(t)),
                            this.init();
                    }
                })(this);
            },
            onUnload() {
                hn[this.id].onUnload();
            },
        },
        bo,
    ]);
    const un = { marquee: ".announcement__bar-holder--marquee", slide: "[data-slide]", slider: "[data-slider]", ticker: "ticker-bar", tickerSlide: ".announcement__slide" },
        pn = "hidden";
    let mn = class extends HTMLElement {
        connectedCallback() {
            this.slider && this.initSliders(),
                this.addEventListener("theme:block:select", (t) => {
                    this.onBlockSelect(t);
                }),
                this.addEventListener("theme:block:deselect", (t) => {
                    this.onBlockDeselect(t);
                }),
                this.addEventListener("theme:countdown:hide", (t) => {
                    if (window.Shopify.designMode) return;
                    const e = t.target.closest(un.marquee);
                    if (1 === this.slidesCount) {
                        this.querySelector(un.ticker).style.display = "none";
                    }
                    if (e) {
                        const e = t.target.closest(un.tickerSlide);
                        this.removeTickerText(e);
                    } else {
                        const e = t.target.closest(un.slide);
                        this.removeSlide(e);
                    }
                }),
                this.addEventListener("theme:countdown:expire", () => {
                    var t;
                    null === (t = this.querySelectorAll(un.ticker)) ||
                        void 0 === t ||
                        t.forEach((t) => {
                            t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
                        });
                }),
                document.dispatchEvent(new CustomEvent("theme:announcement:init", { bubbles: !0 }));
        }
        initSliders() {
            this.initSlider(),
                document.addEventListener("theme:resize:width", this.initSliderEvent),
                this.addEventListener("theme:slider:loaded", () => {
                    var t;
                    null === (t = this.querySelectorAll(un.tickerBar)) ||
                        void 0 === t ||
                        t.forEach((t) => {
                            t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
                        });
                });
        }
        initSlider() {
            const t = v(),
                e = !t;
            var s, i;
            ((t && this.enableSlider) || (e && !this.enableSlider)) &&
                (null === (s = this.slider.flkty) || void 0 === s || s.destroy(),
                t && this.enableSlider ? (this.enableSlider = !1) : e && !this.enableSlider && (this.enableSlider = !0),
                (this.slider = new Uo(this, this.querySelector(un.slider))),
                null === (i = this.slider.flkty) || void 0 === i || i.reposition());
        }
        removeSlide(t) {
            var e, s;
            null === (e = this.slider.flkty) || void 0 === e || e.remove(t), 0 === (null === (s = this.slider.flkty) || void 0 === s ? void 0 : s.cells.length) && this.section.classList.add(pn);
        }
        removeTickerText(t) {
            const e = t.closest(un.ticker);
            t.remove(), e.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
        }
        onBlockSelect(t) {
            this.slider && this.slider.onBlockSelect(t);
        }
        onBlockDeselect(t) {
            this.slider && this.slider.onBlockDeselect(t);
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.initSliderEvent),
                document.removeEventListener("theme:resize:width", this.tickerResizeEvent),
                this.removeEventListener("theme:block:select", (t) => {
                    this.onBlockSelect(t);
                }),
                this.removeEventListener("theme:block:deselect", (t) => {
                    this.onBlockDeselect(t);
                });
        }
        constructor() {
            super(), (this.slider = this.querySelector(un.slider)), (this.enableSlider = v()), (this.slidesCount = this.querySelectorAll(un.tickerSlide).length), (this.initSliderEvent = (t) => this.initSlider(t));
        }
    };
    customElements.get("announcement-bar") || customElements.define("announcement-bar", mn);
    const vn = ".page-header",
        gn = "js__header__stuck",
        bn = "has-header-sticky",
        fn = "shopify-section-group-header-group",
        yn = "data-header-sticky",
        wn = "data-scroll-locked";
    let Sn = {};
    const En = {
            onLoad() {
                Sn = new (class {
                    listen() {
                        document.addEventListener("theme:scroll", this.scrollEvent), document.addEventListener("shopify:section:load", this.updateHeaderOffset), document.addEventListener("shopify:section:unload", this.updateHeaderOffset);
                    }
                    onScroll(t) {
                        t.detail.down ? !this.isStuck && t.detail.position > this.headerOffset && this.stickSimple() : t.detail.position <= this.headerOffset && this.unstickSimple();
                    }
                    updateHeaderOffset(t) {
                        t.target.classList.contains(fn) &&
                            setTimeout(() => {
                                var t;
                                this.headerOffset = null === (t = document.querySelector(vn)) || void 0 === t ? void 0 : t.offsetTop;
                            });
                    }
                    stickOnLoad() {
                        window.scrollY > this.headerOffset && this.stickSimple();
                    }
                    stickSimple() {
                        this.cls.add(gn), (this.isStuck = !0);
                    }
                    unstickSimple() {
                        document.documentElement.hasAttribute(wn) || (this.cls.remove(gn), (this.isStuck = !1));
                    }
                    unload() {
                        document.removeEventListener("theme:scroll", this.scrollEvent),
                            document.removeEventListener("shopify:section:load", this.updateHeaderOffset),
                            document.removeEventListener("shopify:section:unload", this.updateHeaderOffset);
                    }
                    constructor(t) {
                        var e;
                        (this.wrapper = t),
                            (this.sticks = this.wrapper.hasAttribute(yn)),
                            document.body.classList.toggle(bn, this.sticks),
                            this.sticks &&
                                ((this.isStuck = !1),
                                (this.cls = this.wrapper.classList),
                                (this.headerOffset = null === (e = document.querySelector(vn)) || void 0 === e ? void 0 : e.offsetTop),
                                (this.updateHeaderOffset = this.updateHeaderOffset.bind(this)),
                                (this.scrollEvent = (t) => this.onScroll(t)),
                                this.listen(),
                                this.stickOnLoad());
                    }
                })(this.container);
            },
            onUnload: function () {
                "function" == typeof Sn.unload && Sn.unload();
            },
        },
        Ln = "data-hover-disclosure-toggle",
        kn = "[data-hover-disclosure]",
        An = "[data-top-link]",
        Cn = "[data-header-wrapper]",
        qn = "[data-stagger]",
        Tn = "[data-stagger-first]",
        xn = "[data-stagger-second]",
        Pn = "is-visible",
        In = "meganav--visible",
        Hn = "meganav--is-transitioning";
    let On = {},
        Dn = {};
    const Mn = {
            onLoad() {
                (On[this.id] = []),
                    (Dn = this.container.querySelectorAll(kn)),
                    Dn.forEach((t) => {
                        On[this.id].push(
                            new (class {
                                onBlockSelect(t) {
                                    this.disclosure.contains(t.target) && this.showDisclosure(t);
                                }
                                onBlockDeselect(t) {
                                    this.disclosure.contains(t.target) && this.hideDisclosure();
                                }
                                showDisclosure(t) {
                                    t && t.type && "mouseenter" === t.type && this.wrapper.classList.add(Hn),
                                        this.grandparent ? this.wrapper.classList.add(In) : this.wrapper.classList.remove(In),
                                        this.trigger.setAttribute("aria-expanded", !0),
                                        this.trigger.classList.add(Pn),
                                        this.disclosure.classList.add(Pn),
                                        this.transitionTimeout && clearTimeout(this.transitionTimeout),
                                        (this.transitionTimeout = setTimeout(() => {
                                            this.wrapper.classList.remove(Hn);
                                        }, 200));
                                }
                                hideDisclosure() {
                                    this.disclosure.classList.remove(Pn), this.trigger.classList.remove(Pn), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(In, Hn);
                                }
                                staggerChildAnimations() {
                                    const t = this.disclosure.querySelectorAll(qn);
                                    let e = 50;
                                    t.forEach((t, s) => {
                                        (t.style.transitionDelay = s * e + 10 + "ms"), (e *= 0.95);
                                    }),
                                        this.disclosure.querySelectorAll(Tn).forEach((t, e) => {
                                            const s = 100 * e;
                                            (t.style.transitionDelay = `${s}ms`),
                                                t.parentElement.querySelectorAll(xn).forEach((t, e) => {
                                                    const i = 20 * (e + 1);
                                                    t.style.transitionDelay = `${s + i}ms`;
                                                });
                                        });
                                }
                                handleTablets() {
                                    this.trigger.addEventListener(
                                        "touchstart",
                                        function (t) {
                                            this.disclosure.classList.contains(Pn) || (t.preventDefault(), this.showDisclosure(t));
                                        }.bind(this),
                                        { passive: !0 }
                                    );
                                }
                                connectHoverToggle() {
                                    this.trigger.addEventListener("mouseenter", (t) => this.showDisclosure(t)),
                                        this.link.addEventListener("focus", (t) => this.showDisclosure(t)),
                                        this.trigger.addEventListener("mouseleave", () => this.hideDisclosure()),
                                        this.trigger.addEventListener("focusout", (t) => {
                                            this.trigger.contains(t.relatedTarget) || this.hideDisclosure();
                                        }),
                                        this.disclosure.addEventListener("keyup", (t) => {
                                            "Escape" === t.code && this.hideDisclosure();
                                        });
                                }
                                constructor(t) {
                                    (this.disclosure = t),
                                        (this.wrapper = t.closest(Cn)),
                                        (this.key = this.disclosure.id),
                                        (this.trigger = document.querySelector(`[${Ln}='${this.key}']`)),
                                        (this.link = this.trigger.querySelector(An)),
                                        (this.grandparent = this.trigger.classList.contains("grandparent")),
                                        (this.transitionTimeout = 0),
                                        this.trigger.setAttribute("aria-haspopup", !0),
                                        this.trigger.setAttribute("aria-expanded", !1),
                                        this.trigger.setAttribute("aria-controls", this.key),
                                        this.connectHoverToggle(),
                                        this.handleTablets(),
                                        this.staggerChildAnimations();
                                }
                            })(t)
                        );
                    });
            },
            onBlockSelect(t) {
                On[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                On[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
        },
        Bn = "[data-takes-space-wrapper]",
        Fn = "[data-child-takes-space]",
        _n = "[data-header-desktop]",
        $n = '.navlink[href="#"]',
        Nn = "cart-drawer",
        Rn = "[data-cart-toggle]",
        Wn = ".main-content > .shopify-section.section-overlay-header:first-of-type",
        Un = "[data-prevent-transparent-header]",
        zn = "js__header__clone",
        Vn = "has-first-section-overlay-header",
        jn = "js__show__mobile",
        Jn = "has-header-transparent",
        Xn = "data-drawer",
        Gn = "data-drawer-toggle",
        Qn = "data-header-transparent";
    let Yn = {};
    so("header", [
        {
            onLoad() {
                Yn = new (class {
                    initTicker(t = !1) {
                        this.tickerFrames.forEach((e) => {
                            new Ticker(e, t);
                        }),
                            (this.tickerResizeEvent = (t) => this.onTickerResize(t)),
                            document.addEventListener("theme:resize:width", this.tickerResizeEvent);
                    }
                    listenWidth() {
                        "ResizeObserver" in window ? ((this.resizeObserver = new ResizeObserver(this.checkWidth)), this.resizeObserver.observe(this.wrapper)) : document.addEventListener("theme:resize", this.checkWidth);
                    }
                    drawerToggleEvent() {
                        var t;
                        null === (t = this.wrapper.querySelectorAll(`[${Gn}]`)) ||
                            void 0 === t ||
                            t.forEach((t) => {
                                t.addEventListener("click", () => {
                                    let e;
                                    const s = t.hasAttribute(Gn) ? t.getAttribute(Gn) : "",
                                        i = document.querySelector(`[${Xn}="${s}"]`),
                                        o = document.querySelector(`mobile-menu > [${Xn}]`);
                                    (e = v() ? i : ("new" === theme.settings.mobileMenuType && o) || i), e.dispatchEvent(new CustomEvent("theme:drawer:toggle", { bubbles: !1, detail: { button: t } }));
                                });
                            });
                    }
                    killDeadLinks() {
                        this.deadLinks.forEach((t) => {
                            t.onclick = (t) => {
                                t.preventDefault();
                            };
                        });
                    }
                    checkWidth() {
                        if (document.body.clientWidth < this.minWidth) {
                            this.wrapper.classList.add(jn);
                            const { headerHeight: t } = r();
                            document.documentElement.style.setProperty("--header-height", `${t}px`);
                        } else this.wrapper.classList.remove(jn);
                    }
                    getMinWidth() {
                        const t = this.wrapper.cloneNode(!0);
                        t.classList.add(zn), document.body.appendChild(t);
                        const e = t.querySelectorAll(Bn);
                        let s = 0,
                            i = 0;
                        return (
                            e.forEach((t) => {
                                const e = t.querySelectorAll(Fn);
                                let o = 0;
                                (o =
                                    3 === e.length
                                        ? (function (t) {
                                              let e = [];
                                              return (
                                                  t.forEach((t) => {
                                                      t.firstElementChild && e.push(t.firstElementChild.clientWidth);
                                                  }),
                                                  e[0] > e[2] ? (e[2] = e[0]) : (e[0] = e[2]),
                                                  e.reduce((t, e) => t + e)
                                              );
                                          })(e)
                                        : (function (t) {
                                              let e = 0;
                                              return (
                                                  t.forEach((t) => {
                                                      e += t.clientWidth;
                                                  }),
                                                  e
                                              );
                                          })(e)),
                                    o > s && ((s = o), (i = 20 * e.length));
                            }),
                            document.body.removeChild(t),
                            s + i
                        );
                    }
                    cartToggleEvent() {
                        var t;
                        "drawer" === theme.settings.cartType &&
                            (null === (t = this.wrapper.querySelectorAll(Rn)) ||
                                void 0 === t ||
                                t.forEach((t) => {
                                    t.addEventListener("click", (e) => {
                                        const s = document.querySelector(Nn);
                                        s && (e.preventDefault(), s.dispatchEvent(new CustomEvent("theme:cart-drawer:show")), (window.a11y.lastElement = t));
                                    });
                                }));
                    }
                    toggleButtonClick(t) {
                        t.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:toggle", { bubbles: !0 }));
                    }
                    unload() {
                        var t;
                        "ResizeObserver" in window ? null === (t = this.resizeObserver) || void 0 === t || t.unobserve(this.wrapper) : document.removeEventListener("theme:resize", this.checkWidth);
                    }
                    constructor(t) {
                        (this.wrapper = t),
                            (this.style = this.wrapper.dataset.style),
                            (this.desktop = this.wrapper.querySelector(_n)),
                            (this.deadLinks = document.querySelectorAll($n)),
                            (this.resizeObserver = null),
                            (this.checkWidth = this.checkWidth.bind(this)),
                            this.killDeadLinks(),
                            "drawer" !== this.style && this.desktop && ((this.minWidth = this.getMinWidth()), this.listenWidth()),
                            this.drawerToggleEvent(),
                            this.cartToggleEvent();
                        let e = !1;
                        const s = document.querySelector(Wn);
                        s && !s.querySelector(Un) && (e = !0), document.body.classList.toggle(Jn, this.wrapper.hasAttribute(Qn)), document.body.classList.toggle(Vn, e);
                    }
                })(this.container);
            },
            onUnload() {
                "function" == typeof Yn.unload && Yn.unload();
            },
        },
        En,
        Mn,
    ]);
    const Kn = "[data-slider-mobile]",
        Zn = "[data-slide]",
        tr = "[data-slider-thumb]",
        er = "[data-slider-container]",
        sr = "[data-popup-container]",
        ir = "[data-popup-close]",
        or = "is-animating",
        nr = "is-open",
        rr = "data-slider-thumb",
        ar = {};
    function lr() {
        this.entries = [];
    }
    function cr(t, e) {
        dr(t);
        var s = (function (t, e) {
            dr(t),
                (function (t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.");
                })(e);
            var s = [];
            return (
                e.forEach(function (e) {
                    for (var i = 0; i < t.options.length; i++) {
                        if ((t.options[i].name || t.options[i]).toLowerCase() === e.name.toLowerCase()) {
                            s[i] = e.value;
                            break;
                        }
                    }
                }),
                s
            );
        })(t, e);
        return (function (t, e) {
            return (
                dr(t),
                (function (t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.");
                })(e),
                t.variants.filter(function (t) {
                    return e.every(function (e, s) {
                        return t.options[s] === e;
                    });
                })[0] || null
            );
        })(t, s);
    }
    function dr(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.");
    }
    so("look", [
        {
            onLoad() {
                ar[this.id] = new (class {
                    init() {
                        this.slider &&
                            this.slides.length &&
                            this.thumbs.length &&
                            (this.popupContainer.addEventListener("transitionend", (t) => {
                                t.target == this.popupContainer && (this.popupContainer.classList.remove(or), t.target.classList.contains(nr) ? this.popupOpenCallback() : this.popupCloseCallback());
                            }),
                            this.popupContainer.addEventListener("transitionstart", (t) => {
                                t.target == this.popupContainer && this.popupContainer.classList.add(or);
                            }),
                            this.popupClose.forEach((t) => {
                                t.addEventListener("click", () => {
                                    this.popupContainer.classList.remove(nr), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                                });
                            }),
                            this.thumbs.forEach((t, e) => {
                                t.addEventListener("click", (s) => {
                                    s.preventDefault();
                                    const i = t.hasAttribute(rr) && "" !== t.getAttribute(rr) ? parseInt(t.getAttribute(rr)) : e,
                                        o = this.slides[i];
                                    if (g()) {
                                        const t = parseInt(window.getComputedStyle(this.slider).paddingLeft);
                                        this.slider.scrollTo({ top: 0, left: o.offsetLeft - t, behavior: "auto" }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })), this.popupContainer.classList.add(or, nr);
                                    } else {
                                        let { stickyHeaderHeight: t } = r();
                                        const e = o.getBoundingClientRect().top,
                                            s = o.offsetHeight / 2,
                                            i = window.innerHeight,
                                            n = i / 2,
                                            a = this.container.querySelector(er);
                                        let l = e + s - n + window.scrollY;
                                        if (a) {
                                            const e = a.getBoundingClientRect().top + window.scrollY,
                                                s = e + a.offsetHeight;
                                            l < e ? (l = e - t) : l + i > s && (l = s - i);
                                        }
                                        window.scrollTo({ top: l, left: 0, behavior: "smooth" });
                                    }
                                });
                            }));
                    }
                    popupCloseByEvent() {
                        this.popupContainer.classList.remove(nr);
                    }
                    popupOpenCallback() {
                        document.addEventListener("theme:quick-add:open", this.popupCloseByEvent, { once: !0 }), document.addEventListener("theme:product:added", this.popupCloseByEvent, { once: !0 });
                    }
                    popupCloseCallback() {
                        document.removeEventListener("theme:quick-add:open", this.popupCloseByEvent, { once: !0 }), document.removeEventListener("theme:product:added", this.popupCloseByEvent, { once: !0 });
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.slider = this.container.querySelector(Kn)),
                            (this.slides = this.container.querySelectorAll(Zn)),
                            (this.thumbs = this.container.querySelectorAll(tr)),
                            (this.popupContainer = this.container.querySelector(sr)),
                            (this.popupClose = this.container.querySelectorAll(ir)),
                            (this.popupCloseByEvent = this.popupCloseByEvent.bind(this)),
                            this.init();
                    }
                })(this);
            },
        },
    ]),
        (lr.prototype.add = function (t, e, s) {
            this.entries.push({ element: t, event: e, fn: s }), t.addEventListener(e, s);
        }),
        (lr.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (t) {
                return t.element.removeEventListener(t.event, t.fn), !1;
            });
        });
    var hr = '[name="id"]',
        ur = '[name="selling_plan"]',
        pr = '[name^="options"]',
        mr = '[name="quantity"]',
        vr = '[name^="properties"]';
    const gr = "data-scrollbar",
        br = "data-scrollbar-slider",
        fr = "data-scrollbar-slide-fullwidth",
        yr = "[data-scrollbar-arrow-prev]",
        wr = "[data-scrollbar-arrow-next]",
        Sr = "is-hidden";
    let Er = class {
        init() {
            this.arrowNext && this.arrowPrev && (this.toggleNextArrow(), this.events());
        }
        listen() {
            document.addEventListener("theme:modal:open", () => {
                this.toggleNextArrow();
            }),
                document.addEventListener("theme:resize", () => {
                    this.toggleNextArrow();
                });
        }
        events() {
            this.arrowNext.addEventListener("click", (t) => {
                t.preventDefault(), this.goToNext();
            }),
                this.arrowPrev.addEventListener("click", (t) => {
                    t.preventDefault(), this.goToPrev();
                }),
                this.scrollbar.addEventListener("scroll", () => {
                    this.togglePrevArrow(), this.toggleNextArrow();
                });
        }
        goToNext() {
            const t = (this.scrollbar.hasAttribute(fr) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2) + this.scrollbar.scrollLeft;
            this.move(t), this.arrowPrev.classList.remove(Sr), this.toggleNextArrow();
        }
        goToPrev() {
            const t = this.scrollbar.hasAttribute(fr) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2,
                e = this.scrollbar.scrollLeft - t;
            this.move(e), this.arrowNext.classList.remove(Sr), this.togglePrevArrow();
        }
        toggleNextArrow() {
            requestAnimationFrame(() => {
                var t;
                null === (t = this.arrowNext) || void 0 === t || t.classList.toggle(Sr, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth);
            });
        }
        togglePrevArrow() {
            requestAnimationFrame(() => {
                this.arrowPrev.classList.toggle(Sr, this.scrollbar.scrollLeft <= 0);
            });
        }
        scrollToVisibleElement() {
            [].forEach.call(this.scrollbar.children, (t) => {
                t.addEventListener("click", (e) => {
                    e.preventDefault(), this.move(t.offsetLeft - t.clientWidth);
                });
            });
        }
        move(t) {
            this.scrollbar.scrollTo({ top: 0, left: t, behavior: "smooth" });
        }
        constructor(t) {
            (this.scrollbar = t),
                (this.arrowNext = this.scrollbar.parentNode.querySelector(wr)),
                (this.arrowPrev = this.scrollbar.parentNode.querySelector(yr)),
                this.scrollbar.hasAttribute(gr) && (this.init(), this.listen()),
                this.scrollbar.hasAttribute(br) && this.scrollToVisibleElement();
        }
    };
    const Lr = "[data-grid-swatch-form]",
        kr = "[data-grid-item]",
        Ar = "[data-product-information]",
        Cr = "[data-product-image]",
        qr = "[data-swatch-button]",
        Tr = "[data-swatch-link]",
        xr = "[data-swatch-text]",
        Pr = "[data-swatch-template]",
        Ir = "is-visible",
        Hr = "no-events",
        Or = "swatch",
        Dr = "data-swatch-handle",
        Mr = "data-swatch-label",
        Br = "data-scrollbar",
        Fr = "data-swatch-count",
        _r = "data-tooltip",
        $r = "data-swatch-variant-name",
        Nr = "data-variant-title",
        Rr = "data-swatch-values";
    let Wr = class extends HTMLElement {
            connectedCallback() {
                this.hasAttribute(_r) && new go(this);
            }
            constructor() {
                super();
            }
        },
        Ur = class extends HTMLElement {
            connectedCallback() {
                (this.handle = this.getAttribute(Dr)),
                    (this.productItem = this.closest(kr)),
                    (this.productInfo = this.closest(Ar)),
                    (this.productImage = this.productItem.querySelector(Cr)),
                    (this.template = document.querySelector(Pr).innerHTML),
                    (this.swatchesJSON = this.getSwatchesJSON()),
                    (this.swatchesStyle = theme.settings.collectionSwatchStyle);
                const t = this.getAttribute(Mr).trim().toLowerCase();
                (function (t) {
                    const e = `${window.theme.routes.root}products/${t}.js`;
                    return window
                        .fetch(e)
                        .then((t) => t.json())
                        .catch((t) => {
                            console.error(t);
                        });
                })(this.handle).then((e) => {
                    (this.product = e),
                        (this.colorOption = e.options.find(function (e) {
                            return e.name.toLowerCase() === t || null;
                        })),
                        this.colorOption && ((this.swatches = this.colorOption.values), this.init());
                });
            }
            init() {
                if (
                    ((this.innerHTML = ""),
                    (this.count = 0),
                    (this.limitedCount = 0),
                    this.swatches.forEach((t) => {
                        let e = null,
                            s = !1,
                            i = "";
                        for (const s of this.product.variants) {
                            const o = s.options.includes(t);
                            if ((!e && o && (e = s), o && s.featured_media)) {
                                (i = s.featured_media.preview_image.src), (e = s);
                                break;
                            }
                        }
                        for (const e of this.product.variants) {
                            if (e.options.includes(t) && e.available) {
                                s = !0;
                                break;
                            }
                        }
                        if (e) {
                            const r = document.createElement("div");
                            r.innerHTML = this.template;
                            const a = r.querySelector(qr),
                                l = r.querySelector(Tr),
                                c = r.querySelector(xr),
                                d = this.swatchesJSON[t],
                                h = "native" == theme.settings.swatchesType ? d : `var(--${d})`,
                                u = e.title.replaceAll('"', "'");
                            (a.style = `--animation-delay: ${(100 * this.count) / 1250}s`),
                                a.classList.add(`${Or}-${d}`),
                                (a.dataset.tooltip = t),
                                (a.dataset.swatchVariant = e.id),
                                (a.dataset.swatchVariantName = u),
                                (a.dataset.swatchImage = i),
                                (a.dataset.variant = e.id),
                                a.style.setProperty("--swatch", h),
                                (l.href = ((o = this.product.url), (n = e.id), /variant=/.test(o) ? o.replace(/(variant=)[^&]+/, "$1" + n) : /\?/.test(o) ? o.concat("&variant=").concat(n) : o.concat("?variant=").concat(n))),
                                (l.dataset.swatch = t),
                                (l.disabled = !s),
                                (c.innerText = t),
                                "limited" != this.swatchesStyle ? (this.innerHTML += r.innerHTML) : this.count <= 4 && ((this.innerHTML += r.innerHTML), this.limitedCount++),
                                this.count++;
                        }
                        var o, n;
                    }),
                    (this.swatchCount = this.productInfo.querySelector(`[${Fr}]`)),
                    (this.swatchElements = this.querySelectorAll(Tr)),
                    (this.swatchForm = this.productInfo.querySelector(Lr)),
                    (this.hideSwatchesTimer = 0),
                    this.swatchCount.hasAttribute(Fr))
                ) {
                    if ("text" == this.swatchesStyle || "text-slider" == this.swatchesStyle) {
                        if (((this.swatchCount.innerText = `${this.count} ${this.count > 1 ? theme.strings.otherColor : theme.strings.oneColor}`), "text" == this.swatchesStyle)) return;
                        this.swatchCount.addEventListener("mouseenter", () => {
                            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productInfo.classList.add(Hr), this.swatchForm.classList.add(Ir);
                        }),
                            this.productInfo.addEventListener("mouseleave", () => {
                                this.hideSwatchesTimer = setTimeout(() => {
                                    this.productInfo.classList.remove(Hr), this.swatchForm.classList.remove(Ir);
                                }, 100);
                            });
                    }
                    if ((("slider" != this.swatchesStyle && "grid" != this.swatchesStyle) || this.swatchForm.classList.add(Ir), "limited" == this.swatchesStyle)) {
                        const t = this.count - this.limitedCount;
                        this.swatchForm.classList.add(Ir), t > 0 && (this.innerHTML += `<div class="swatch-limited">+${t}</div>`);
                    }
                }
                ("text-slider" != this.swatchesStyle && "slider" != this.swatchesStyle) || (this.hasAttribute(Br) && new Er(this)), this.bindSwatchButtonEvents();
            }
            bindSwatchButtonEvents() {
                var t;
                null === (t = this.querySelectorAll(qr)) ||
                    void 0 === t ||
                    t.forEach((t) => {
                        t.addEventListener("mouseenter", this.showVariantImageEvent), t.hasAttribute(_r) && new go(t);
                    }),
                    this.productItem.addEventListener("mouseleave", this.productItemMouseLeaveEvent);
            }
            showVariantImage(t) {
                var e;
                const s = null === (e = t.target.getAttribute($r)) || void 0 === e ? void 0 : e.replaceAll('"', "'"),
                    i = this.productImage.querySelectorAll(`[${Nr}]`),
                    o = this.productImage.querySelector(`[${Nr}="${s}"]`);
                null == i ||
                    i.forEach((t) => {
                        t.classList.remove(Ir);
                    }),
                    null == o || o.classList.add(Ir);
            }
            hideVariantImages() {
                var t;
                null === (t = this.productImage.querySelectorAll(`[${Nr}].${Ir}`)) ||
                    void 0 === t ||
                    t.forEach((t) => {
                        t.classList.remove(Ir);
                    });
            }
            getSwatchesJSON() {
                if (!this.hasAttribute(Rr)) return {};
                const t = this.getAttribute(Rr).split(","),
                    e = {};
                return (
                    null == t ||
                        t.forEach((t) => {
                            const [s, i] = t.split(":");
                            e[s.trim()] = i.trim();
                        }),
                    e
                );
            }
            constructor() {
                super(), (this.productItemMouseLeaveEvent = () => this.hideVariantImages()), (this.showVariantImageEvent = (t) => this.showVariantImage(t));
            }
        };
    function zr(t) {
        return t.replace(/http(s)?:/, "");
    }
    const Vr = {
            productCutline: "[data-product-cutline]",
            productLink: "[data-product-link]",
            productGridItem: "[data-grid-item]",
            productInfo: "[data-product-information]",
            productImage: "[data-product-image-default]",
            productImageSibling: "[data-product-image-sibling]",
            productPrice: "[data-product-price]",
            siblingsInnerHolder: "[data-sibling-inner]",
            siblingCount: "[data-sibling-count]",
            siblingFieldset: "[data-sibling-fieldset]",
            siblingLink: "[data-sibling-link]",
            tooltip: "[data-tooltip]",
        },
        jr = "is-visible",
        Jr = "is-fade",
        Xr = "no-events",
        Gr = "is-active",
        Qr = "data-sibling-cutline",
        Yr = "data-sibling-image",
        Kr = "data-sibling-link",
        Zr = "data-sibling-price",
        ta = "data-sibling-compare-at-price",
        ea = "data-product-link";
    let sa = class extends HTMLElement {
        connectedCallback() {
            (this.product = this.closest(Vr.productGridItem)),
                (this.siblingScrollbar = this.querySelector(Vr.siblingsInnerHolder)),
                (this.siblingCount = this.querySelector(Vr.siblingCount)),
                (this.siblingFieldset = this.querySelector(Vr.siblingFieldset)),
                (this.siblingLinks = this.querySelectorAll(Vr.siblingLink)),
                (this.productInfo = this.closest(Vr.productInfo)),
                (this.productLink = this.closest(Vr.link)),
                (this.hideSwatchesTimer = 0),
                (this.swatchesStyle = theme.settings.collectionSwatchStyle),
                this.initScrollbar(),
                this.siblingFieldset &&
                    this.productInfo &&
                    (("grid" != this.swatchesStyle && "slider" != this.swatchesStyle && "limited" != this.swatchesStyle) || this.siblingFieldset.classList.add(jr),
                    this.siblingCount && (this.siblingCount.addEventListener("mouseenter", () => this.showSiblings()), this.productInfo.addEventListener("mouseleave", () => this.hideSiblings()))),
                this.siblingLinks.length &&
                    new (class {
                        init() {
                            this.cacheDefaultValues(),
                                this.product.addEventListener("mouseleave", () => this.resetProductValues()),
                                this.product.addEventListener("focusout", () => this.resetProductValues()),
                                this.swatches.forEach((t) => {
                                    t.addEventListener("mouseenter", (t) => this.showSibling(t)), t.addEventListener("focusin", (t) => this.showSibling(t));
                                }),
                                this.productLinks.length &&
                                    this.swatches.forEach((t) => {
                                        t.addEventListener("click", () => {
                                            this.productLinks[0].click();
                                        }),
                                            t.addEventListener("keyup", (t) => {
                                                "Enter" === t.code && this.productLinks[0].click();
                                            });
                                    });
                        }
                        cacheDefaultValues() {
                            (this.productLinkValue = this.productLinks[0].hasAttribute(ea) ? this.productLinks[0].getAttribute(ea) : ""),
                                (this.productPriceValue = this.productPrice.innerHTML),
                                this.productCutline && (this.productCutlineValue = this.productCutline.innerHTML);
                        }
                        resetProductValues() {
                            this.product.classList.remove(Gr),
                                this.productLinkValue &&
                                    this.productLinks.forEach((t) => {
                                        t.href = this.productLinkValue;
                                    }),
                                this.productPrice && (this.productPrice.innerHTML = this.productPriceValue),
                                this.productCutline && this.productCutline && ((this.productCutline.innerHTML = this.productCutlineValue), (this.productCutline.title = this.productCutlineValue)),
                                this.hideSiblingImage();
                        }
                        showSibling(t) {
                            const e = t.target,
                                s = e.hasAttribute(Kr) ? e.getAttribute(Kr) : "",
                                i = e.hasAttribute(Zr) ? e.getAttribute(Zr) : "",
                                o = e.hasAttribute(ta) ? e.getAttribute(ta) : "",
                                n = e.hasAttribute(Qr) ? e.getAttribute(Qr) : "",
                                r = e.hasAttribute(Yr) ? e.getAttribute(Yr) : "";
                            s &&
                                this.productLinks.forEach((t) => {
                                    t.href = s;
                                }),
                                (this.productPrice.innerHTML = o ? `<span class="price sale"><span class="new-price">${i}</span> <span class="old-price">${o}</span></span>` : `<span class="price">${i}</span>`),
                                this.productCutline && (n ? ((this.productCutline.innerHTML = n), (this.productCutline.title = n)) : ((this.productCutline.innerHTML = ""), (this.productCutline.title = ""))),
                                r && this.showSiblingImage(r);
                        }
                        showSiblingImage(t) {
                            if (!this.productImageSibling) return;
                            const e = window.devicePixelRatio || 1,
                                s = this.productImage.offsetWidth * e,
                                i = (function (t, e) {
                                    if (null === e) return t;
                                    if ("master" === e) return zr(t);
                                    const s = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                                    if (s) {
                                        const i = t.split(s[0]),
                                            o = s[0];
                                        return zr(`${i[0]}_${e}${o}`);
                                    }
                                    return null;
                                })(t, 180 * Math.ceil(s / 180) + "x"),
                                o = this.productImageSibling.querySelector(`[src="${i}"]`),
                                n = () => {
                                    this.productImageSibling.classList.add(jr), this.productImageSibling.querySelector(`[src="${i}"]`).classList.add(Jr);
                                },
                                r = () => {
                                    this.productImageSibling.querySelectorAll("img").forEach((t) => {
                                        t.classList.remove(Jr);
                                    }),
                                        requestAnimationFrame(n);
                                };
                            if (o) r();
                            else {
                                const t = document.createElement("img");
                                (t.src = i),
                                    this.productCutline && (t.alt = this.productCutline.innerText),
                                    t.addEventListener("load", () => {
                                        this.productImageSibling.append(t), r();
                                    });
                            }
                        }
                        hideSiblingImage() {
                            this.productImageSibling &&
                                (this.productImageSibling.classList.remove(jr),
                                this.productImageSibling.querySelectorAll("img").forEach((t) => {
                                    t.classList.remove(Jr);
                                }));
                        }
                        constructor(t, e) {
                            (this.swatches = t),
                                (this.product = e),
                                (this.productLinks = this.product.querySelectorAll(Vr.productLink)),
                                (this.productCutline = this.product.querySelector(Vr.productCutline)),
                                (this.productPrice = this.product.querySelector(Vr.productPrice)),
                                (this.productImage = this.product.querySelector(Vr.productImage)),
                                (this.productImageSibling = this.product.querySelector(Vr.productImageSibling)),
                                this.init();
                        }
                    })(this.siblingLinks, this.product),
                this.querySelectorAll(Vr.tooltip).forEach((t) => {
                    new go(t);
                });
        }
        showSiblings() {
            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productLink && this.productLink.classList.add(Xr), "text" != this.swatchesStyle && this.siblingFieldset.classList.add(jr);
        }
        hideSiblings() {
            this.hideSwatchesTimer = setTimeout(() => {
                this.productLink && this.productLink.classList.remove(Xr), this.siblingFieldset.classList.remove(jr);
            }, 100);
        }
        initScrollbar() {
            this.siblingScrollbar && new Er(this.siblingScrollbar);
        }
        constructor() {
            super();
        }
    };
    const ia = "[data-hover-slide]",
        oa = "[data-hover-slide-touch]",
        na = "[data-hover-slider]",
        ra = "[data-product-link]",
        aa = ".flickity-prev-next-button";
    let la = class extends HTMLElement {
        connectedCallback() {
            window.theme.touch ? this.initTouch() : this.initFlickity();
        }
        disconnectedCallback() {
            this.flkty && ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
        }
        initTouch() {
            this.style.setProperty("--slides-count", this.querySelectorAll(oa).length), this.slider.addEventListener("scroll", this.handleScroll);
        }
        handleScroll() {
            const t = this.slider.scrollLeft / this.slider.clientWidth;
            this.style.setProperty("--slider-index", t);
        }
        initFlickity() {
            this.querySelectorAll(ia).length < 2 ||
                ((this.flkty = new e(this.slider, { cellSelector: ia, contain: !0, wrapAround: !0, watchCSS: !0, autoPlay: !1, draggable: !1, pageDots: !1, prevNextButtons: !0 })),
                this.flkty.pausePlayer(),
                this.addEventListener("mouseenter", () => {
                    this.flkty.unpausePlayer();
                }),
                this.addEventListener("mouseleave", () => {
                    this.flkty.pausePlayer();
                }),
                this.closest(ra).addEventListener("click", (t) => {
                    t.target.matches(aa) && t.preventDefault();
                }));
        }
        constructor() {
            super(), (this.flkty = null), (this.slider = this.querySelector(na)), (this.handleScroll = this.handleScroll.bind(this));
        }
    };
    const ca = "body",
        da = "[data-related-section]",
        ha = "[data-tabs-holder]",
        ua = "data-tab",
        pa = "data-tab-index",
        ma = "[data-aos]",
        va = "data-block-id",
        ga = "[data-tab]",
        ba = ".tab-link",
        fa = ".tab-link__recent",
        ya = ".tab-content",
        wa = "[data-scrollbar]",
        Sa = "current",
        Ea = "hidden",
        La = "aos-animate",
        ka = "aos-no-transition",
        Aa = "is-focused",
        Ca = {};
    const qa = {
        onLoad() {
            Ca[this.id] = [];
            this.container.querySelectorAll(ha).forEach((t) => {
                Ca[this.id].push(
                    new (class {
                        init() {
                            const t = this.container.querySelectorAll(ga);
                            this.container.addEventListener("theme:tab:check", () => this.checkRecentTab()),
                                this.container.addEventListener("theme:tab:hide", () => this.hideRelatedTab()),
                                t.length &&
                                    t.forEach((t) => {
                                        const e = parseInt(t.getAttribute(ua)),
                                            s = this.container.querySelector(`${ya}-${e}`);
                                        t.addEventListener("click", () => {
                                            this.tabChange(t, s);
                                        }),
                                            t.addEventListener("keyup", (e) => {
                                                ("Space" !== e.code && "Enter" !== e.code) || !this.body.classList.contains(Aa) || this.tabChange(t, s);
                                            });
                                    });
                        }
                        tabChange(t, e) {
                            if (t.classList.contains(Sa)) return;
                            const s = this.container.querySelector(`${ga}.${Sa}`),
                                i = this.container.querySelector(`${ya}.${Sa}`);
                            null == s || s.classList.remove(Sa),
                                null == i || i.classList.remove(Sa),
                                t.classList.add(Sa),
                                e.classList.add(Sa),
                                t.classList.contains(Ea) && e.classList.add(Ea),
                                this.a11y.a11y.removeTrapFocus(),
                                this.container.dispatchEvent(new CustomEvent("theme:tab:change", { bubbles: !0 })),
                                t.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "tab" } })),
                                this.animateItems(e);
                        }
                        animateItems(t, e = !0) {
                            const s = t.querySelectorAll(ma);
                            s.length &&
                                s.forEach((t) => {
                                    t.classList.remove(La),
                                        e &&
                                            (t.classList.add(ka),
                                            requestAnimationFrame(() => {
                                                t.classList.remove(ka), t.classList.add(La);
                                            }));
                                });
                        }
                        initNativeScrollbar() {
                            this.scrollbarHolder.length &&
                                this.scrollbarHolder.forEach((t) => {
                                    new Er(t);
                                });
                        }
                        checkRecentTab() {
                            const t = this.container.querySelector(fa);
                            if (t) {
                                t.classList.remove(Ea);
                                const e = parseInt(t.getAttribute(ua)),
                                    s = this.container.querySelector(`${ya}[${pa}="${e}"]`);
                                s && (s.classList.remove(Ea), this.animateItems(s, !1)), this.initNativeScrollbar();
                            }
                        }
                        hideRelatedTab() {
                            const t = this.container.querySelector(da);
                            if (!t) return;
                            const e = t.closest(`${ya}.${Sa}`);
                            if (!e) return;
                            const s = parseInt(e.getAttribute(pa)),
                                i = this.container.querySelectorAll(ga);
                            if (i.length > s) {
                                const t = i[s].nextSibling;
                                t && (i[s].classList.add(Ea), t.dispatchEvent(new Event("click")), this.initNativeScrollbar());
                            }
                        }
                        onBlockSelect(t) {
                            const e = this.container.querySelector(`${ba}[${va}="${t.detail.blockId}"]`);
                            e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({ top: 0, left: e.offsetLeft - e.clientWidth, behavior: "smooth" }));
                        }
                        constructor(t) {
                            (this.container = t),
                                (this.body = document.querySelector(ca)),
                                (this.a11y = window.a11y),
                                this.container && ((this.scrollbarHolder = this.container.querySelectorAll(wa)), this.init(), this.initNativeScrollbar());
                        }
                    })(t)
                );
            });
        },
        onBlockSelect(t) {
            Ca[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
            });
        },
    };
    function Ta() {
        const t = Boolean(document.querySelectorAll("dialog[open][data-scroll-lock-required]").length),
            e = Boolean(document.querySelectorAll(".drawer.is-open").length);
        return t || e;
    }
    const xa = {
            added: "is-added",
            animated: "is-animated",
            disabled: "is-disabled",
            error: "has-error",
            loading: "is-loading",
            open: "is-open",
            overlayText: "product-item--overlay-text",
            visible: "is-visible",
            siblingLinkCurrent: "sibling__link--current",
        },
        Pa = 3e3,
        Ia = "[data-animation]",
        Ha = "[data-api-content]",
        Oa = "[data-quick-add-btn]",
        Da = "[data-add-to-cart]",
        Ma = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Ba = "[data-message-error]",
        Fa = "[data-quick-add-modal-handle]",
        _a = "[data-product-upsell-ajax]",
        $a = "[data-quick-add-modal-close]",
        Na = "data-grid-item",
        Ra = "[data-product-information]",
        Wa = "[data-quick-add-holder]",
        Ua = "[data-quick-add-modal]",
        za = "[data-quick-add-modal-template]",
        Va = "[data-tooltip]",
        ja = "closing",
        Ja = "data-product-id",
        Xa = "data-quick-add-modal-handle",
        Ga = "data-sibling-swapper",
        Qa = "data-quick-add-holder";
    let Ya = class extends HTMLElement {
        connectedCallback() {
            this.modalButton && this.modalButton.addEventListener("click", this.modalButtonClickEvent),
                this.buttonATC &&
                    this.buttonATC.addEventListener("click", (t) => {
                        t.preventDefault(), (window.a11y.lastElement = this.buttonATC), document.dispatchEvent(new CustomEvent("theme:cart:add", { detail: { button: this.buttonATC } }));
                    }),
                this.quickAddHolder && (this.quickAddHolder.addEventListener("animationend", this.quickAddLoadingToggle), this.errorHandler());
        }
        modalButtonClickEvent(t) {
            t.preventDefault();
            const e = this.modalButton.hasAttribute(Ga),
                s = this.modalButton.classList.contains(xa.siblingLinkCurrent);
            s || (this.modalButton.classList.add(xa.loading), (this.modalButton.disabled = !0), e && !s && ((this.currentModal = t.target.closest(Ua)), this.currentModal.classList.add(xa.loading)), this.renderModal());
        }
        modalCreate(t) {
            const e = document.querySelector(`${Ua}[${Ja}="${this.productId}"]`);
            if (e) (this.modal = e), this.modalOpen();
            else {
                const e = this.quickAddHolder.querySelector(za);
                if (!e) return;
                const s = document.createElement("div");
                (s.innerHTML = e.innerHTML),
                    document.body.appendChild(s.querySelector(Ua)),
                    e.remove(),
                    (this.modal = document.querySelector(`${Ua}[${Ja}="${this.productId}"]`)),
                    (this.modal.querySelector(_a).innerHTML = new DOMParser().parseFromString(t, "text/html").querySelector(Ha).innerHTML),
                    this.modal.querySelectorAll(Va).forEach((t) => {
                        new go(t);
                    }),
                    this.modalCreatedCallback();
            }
        }
        modalOpen() {
            this.currentModal && this.currentModal.dispatchEvent(new CustomEvent("theme:modal:close", { bubbles: !1 })),
                "function" == typeof this.modal.show && this.modal.show(),
                this.modal.setAttribute("open", !0),
                this.modal.removeAttribute("inert"),
                this.quickAddHolder.classList.add(xa.disabled),
                this.modalButton && (this.modalButton.classList.remove(xa.loading), (this.modalButton.disabled = !1), (window.a11y.lastElement = this.modalButton)),
                requestAnimationFrame(() => {
                    this.modal.querySelectorAll(Ia).forEach((t) => {
                        t.classList.add(xa.animated);
                    });
                }),
                document.dispatchEvent(new CustomEvent("theme:quick-add:open", { bubbles: !0 })),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                document.addEventListener("theme:product:added", this.modalCloseOnProductAdded, { once: !0 });
        }
        modalClose() {
            if (!this.isAnimating) {
                if (!this.modal.hasAttribute(ja)) return this.modal.setAttribute(ja, ""), void (this.isAnimating = !0);
                "function" == typeof this.modal.close ? this.modal.close() : this.modal.removeAttribute("open"),
                    this.modal.removeAttribute(ja),
                    this.modal.setAttribute("inert", ""),
                    this.modal.classList.remove(xa.loading),
                    this.modalButton && (this.modalButton.disabled = !1),
                    this.quickAddHolder && this.quickAddHolder.classList.contains(xa.disabled) && this.quickAddHolder.classList.remove(xa.disabled),
                    this.resetAnimatedItems(),
                    Ta() || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                    document.removeEventListener("theme:product:added", this.modalCloseOnProductAdded),
                    this.a11y.removeTrapFocus(),
                    this.a11y.autoFocusLastElement();
            }
        }
        modalEvents() {
            var t;
            null === (t = this.modal.querySelector($a)) ||
                void 0 === t ||
                t.addEventListener("click", (t) => {
                    t.preventDefault(), this.modalClose();
                }),
                this.modal.addEventListener("click", (t) => {
                    "DIALOG" === t.target.nodeName && "click" === t.type && this.modalClose();
                }),
                this.modal.addEventListener("keydown", (t) => {
                    "Escape" == t.code && (t.preventDefault(), this.modalClose());
                }),
                this.modal.addEventListener("theme:modal:close", () => {
                    this.modalClose();
                }),
                this.modal.addEventListener("animationend", (t) => {
                    t.target === this.modal &&
                        ((this.isAnimating = !1),
                        this.modal.hasAttribute(ja)
                            ? this.modalClose()
                            : setTimeout(() => {
                                  this.a11y.trapFocus(this.modal);
                                  const t = this.modal.querySelector("[autofocus]") || this.modal.querySelector(Ma);
                                  null == t || t.focus();
                              }, 50));
                });
        }
        modalCloseOnProductAdded() {
            this.resetQuickAddButtons(), this.modal && this.modal.hasAttribute("open") && this.modalClose();
        }
        quickAddLoadingToggle(t) {
            t.target == this.quickAddHolder && this.quickAddHolder.classList.remove(xa.disabled);
        }
        errorHandler() {
            this.quickAddHolder.addEventListener("theme:cart:error", (t) => {
                const e = t.detail.holder,
                    s = e.closest(`[${Na}]`);
                if (!s) return;
                const i = e.querySelector(Ba),
                    o = s.classList.contains(xa.overlayText),
                    n = s.querySelector(Ra),
                    r = e.querySelector(Da);
                r && (r.classList.remove(xa.added, xa.loading), e.classList.add(xa.error)),
                    i && (i.innerText = t.detail.description),
                    o && n.classList.add(xa.hidden),
                    setTimeout(() => {
                        this.resetQuickAddButtons(), o && n.classList.remove(xa.hidden);
                    }, Pa);
            });
        }
        resetQuickAddButtons() {
            this.quickAddHolder && this.quickAddHolder.classList.remove(xa.visible, xa.error), this.buttonQuickAdd && (this.buttonQuickAdd.classList.remove(xa.added), (this.buttonQuickAdd.disabled = !1));
        }
        renderModal() {
            this.modal
                ? this.modalOpen()
                : window
                      .fetch(`${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`)
                      .then(this.upsellErrorsHandler)
                      .then((t) => t.text())
                      .then((t) => {
                          this.modalCreate(t);
                      });
        }
        modalCreatedCallback() {
            this.modalEvents(), this.modalOpen(), x(this.modal);
        }
        upsellErrorsHandler(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new Qe({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        resetAnimatedItems() {
            var t;
            null === (t = this.modal) ||
                void 0 === t ||
                t.querySelectorAll(Ia).forEach((t) => {
                    t.classList.remove(xa.animated);
                });
        }
        constructor() {
            var t;
            (super(), (this.container = this), (this.quickAddHolder = this.container.querySelector(Wa)), this.quickAddHolder) &&
                ((this.modal = null),
                (this.currentModal = null),
                (this.productId = this.quickAddHolder.getAttribute(Qa)),
                (this.modalButton = this.quickAddHolder.querySelector(Fa)),
                (this.handle = null === (t = this.modalButton) || void 0 === t ? void 0 : t.getAttribute(Xa)),
                (this.buttonQuickAdd = this.quickAddHolder.querySelector(Oa)),
                (this.buttonATC = this.quickAddHolder.querySelector(Da)),
                (this.button = this.modalButton || this.buttonATC),
                (this.modalClose = this.modalClose.bind(this)),
                (this.modalCloseOnProductAdded = this.modalCloseOnProductAdded.bind(this)),
                (this.a11y = $),
                (this.isAnimating = !1),
                (this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this)),
                (this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this)));
        }
    };
    so("product-grid", [qa]),
        customElements.get("quick-add-product") || customElements.define("quick-add-product", Ya),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Wr),
        customElements.get("grid-swatch") || customElements.define("grid-swatch", Ur),
        customElements.get("product-siblings") || customElements.define("product-siblings", sa),
        customElements.get("hover-images") || customElements.define("hover-images", la);
    const Ka = ".product__page",
        Za = "[data-form-wrapper]",
        tl = "[data-header-sticky]",
        el = "[data-product-media-list]",
        sl = "is-sticky",
        il = "data-sticky-enabled";
    window.theme.variables = { productPageSticky: !1 };
    const ol = {};
    const nl = {
            onLoad() {
                ol[this.id] = new (class {
                    init() {
                        this.stickyEnabled && (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)), this.initSticky();
                    }
                    initSticky() {
                        theme.variables.productPageSticky &&
                            ((this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition())),
                            this.formWrapper.addEventListener("theme:form:sticky", this.stickyFormEvent),
                            document.addEventListener("theme:scroll", this.scrollEvent));
                    }
                    stickyFormEvents(t) {
                        this.removeAnimationFrameSticky(), (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t)));
                    }
                    scrollEvents(t) {
                        (this.scrollTop = t.detail.position), (this.scrollDirectionDown = t.detail.down), this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition()));
                    }
                    resizeEvents(t) {
                        this.stickyScrollCheck(), document.removeEventListener("theme:scroll", this.scrollEvent), this.formWrapper.removeEventListener("theme:form:sticky", this.stickyFormEvent), this.initSticky();
                    }
                    stickyScrollCheck() {
                        const t = this.container.querySelector(`${Ka} ${Za}`);
                        if (t)
                            if (v()) {
                                const e = this.container.querySelector(Za),
                                    s = this.container.querySelector(el);
                                if (!e || !s) return;
                                e.offsetHeight < s.offsetHeight ? ((theme.variables.productPageSticky = !0), t.classList.add(sl)) : ((theme.variables.productPageSticky = !1), t.classList.remove(sl));
                            } else (theme.variables.productPageSticky = !1), t.classList.remove(sl);
                    }
                    calculateStickyPosition(t = null) {
                        if (document.documentElement.hasAttribute("data-scroll-locked")) return void this.removeAnimationFrameSticky();
                        const e = Boolean(t && t.detail),
                            s = Boolean(e && t.detail.element && "accordion" === t.detail.element),
                            i = this.formWrapper.offsetHeight,
                            o = window.innerHeight - i - this.defaultTopBottomSpacings,
                            n = Math.abs(this.scrollTop - this.scrollLastPosition);
                        if ((this.scrollDirectionDown ? (this.stickyScrollTop -= n) : (this.stickyScrollTop += n), this.stickyFormLoad)) {
                            if (document.querySelector(tl)) {
                                let { headerHeight: t } = r();
                                this.stickyDefaultTop = t;
                            } else this.stickyDefaultTop = this.defaultTopBottomSpacings;
                            this.stickyScrollTop = this.stickyDefaultTop;
                        }
                        this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, o), this.stickyDefaultTop);
                        const a = this.stickyScrollTop - this.currentPoint;
                        (this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + 0.5 * a),
                            this.formWrapper.style.setProperty("--sticky-top", `${this.currentPoint}px`),
                            (this.scrollLastPosition = this.scrollTop),
                            (this.stickyFormLoad = !1),
                            (s && this.onChangeCounter <= 10) || (s && this.stickyFormLastHeight !== i) || (this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky)
                                ? (s && (this.onChangeCounter += 1), s && this.stickyFormLastHeight !== i && (this.onChangeCounter = 11), (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t))))
                                : this.requestAnimationSticky && this.removeAnimationFrameSticky(),
                            (this.stickyFormLastHeight = i);
                    }
                    removeAnimationFrameSticky() {
                        this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), (this.requestAnimationSticky = null), (this.onChangeCounter = 0));
                    }
                    onUnload() {
                        this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent), theme.variables.productPageSticky && document.removeEventListener("theme:scroll", this.scrollEvent);
                    }
                    constructor(t) {
                        (this.section = t),
                            (this.container = t.container),
                            (this.stickyEnabled = "true" === this.container.getAttribute(il)),
                            (this.formWrapper = this.container.querySelector(Za)),
                            (this.stickyScrollTop = 0),
                            (this.scrollLastPosition = 0),
                            (this.stickyDefaultTop = 0),
                            (this.currentPoint = 0),
                            (this.defaultTopBottomSpacings = 30),
                            (this.scrollTop = window.scrollY),
                            (this.scrollDirectionDown = !0),
                            (this.requestAnimationSticky = null),
                            (this.stickyFormLoad = !0),
                            (this.stickyFormLastHeight = null),
                            (this.onChangeCounter = 0),
                            (this.scrollEvent = (t) => this.scrollEvents(t)),
                            (this.resizeEvent = (t) => this.resizeEvents(t)),
                            (this.stickyFormEvent = (t) => this.stickyFormEvents(t)),
                            setTimeout(() => {
                                this.init();
                            }, 50);
                    }
                })(this);
            },
            onUnload() {
                ol[this.id].onUnload();
            },
        },
        rl = "data-option-position",
        al = '[name^="options"], [data-popout-option]',
        ll = '[name^="options"]:checked, [name^="options"][type="hidden"]',
        cl = "data-value",
        dl = "[data-popout]",
        hl = "sold-out",
        ul = "unavailable",
        pl = "sale";
    const ml = "[data-product]",
        vl = "[data-product-form]",
        gl = "product-notification",
        bl = "[data-variant-title]",
        fl = "[data-notification-product]",
        yl = "[data-add-to-cart]",
        wl = "[data-add-to-cart-text]",
        Sl = "[data-compare-price]",
        El = "[data-compare-text]",
        Ll = "[data-final-sale-badge]",
        kl = "[data-form-wrapper]",
        Al = "[data-product-select]",
        Cl = "[data-price-wrapper]",
        ql = "product-images",
        Tl = "[data-product-media-list]",
        xl = "[data-product-json]",
        Pl = "[data-product-price]",
        Il = "[data-product-unit-price]",
        Hl = "[data-product-base]",
        Ol = "[data-product-unit]",
        Dl = "[data-product-preorder]",
        Ml = "[data-subscription-watch-price]",
        Bl = "[data-subscription-selectors]",
        Fl = "[data-toggles-group]",
        _l = "data-group-toggle",
        $l = "[data-plan-description]",
        Nl = "[data-section-type]",
        Rl = "[data-variant-sku]",
        Wl = "[data-variant-final-sale-metafield]",
        Ul = "[data-variant-buttons]",
        zl = "[data-variant-option-image]",
        Vl = "[data-quick-add-modal]",
        jl = "[data-price-off-amount]",
        Jl = "[data-price-off-badge]",
        Xl = "[data-price-off-type]",
        Gl = "[data-price-off]",
        Ql = "[data-remaining-count]",
        Yl = "[data-remaining-max]",
        Kl = "[data-remaining-wrapper]",
        Zl = "[data-product-remaining-json]",
        tc = "[data-option-value]",
        ec = "[data-option-position]",
        sc = "[data-product-form-installment]",
        ic = 'input[name="id"]',
        oc = "hidden",
        nc = "variant--soldout",
        rc = "variant--unavailable",
        ac = "product__price--sale",
        lc = "count-is-low",
        cc = "count-is-in",
        dc = "count-is-out",
        hc = "count-is-unavailable",
        uc = "data-remaining-max",
        pc = "data-enable-history-state",
        mc = "data-fader-desktop",
        vc = "data-fader-mobile",
        gc = "data-option-position",
        bc = "data-image-id",
        fc = "data-media-id",
        yc = "data-quick-add-btn",
        wc = "data-final-sale",
        Sc = "data-variant-image-scroll";
    let Ec = class extends HTMLElement {
        connectedCallback() {
            if ((this.cartAddEvents(), (this.container = this.closest(Nl) || this.closest(Vl)), !this.container)) return;
            if (
                ((this.sectionId = this.container.dataset.sectionId),
                (this.product = this.container.querySelector(ml)),
                (this.productForm = this.container.querySelector(vl)),
                (this.productNotification = this.container.querySelector(gl)),
                (this.productImages = this.container.querySelector(ql)),
                (this.productMediaList = this.container.querySelector(Tl)),
                (this.installmentForm = this.container.querySelector(sc)),
                (this.skuWrapper = this.container.querySelector(Rl)),
                (this.sellout = null),
                (this.variantImageScroll = "true" === this.container.getAttribute(Sc)),
                (this.priceOffWrap = this.container.querySelector(Gl)),
                (this.priceOffAmount = this.container.querySelector(jl)),
                (this.priceOffType = this.container.querySelector(Xl)),
                (this.planDescription = this.container.querySelector($l)),
                (this.remainingWrapper = this.container.querySelector(Kl)),
                this.remainingWrapper)
            ) {
                const t = this.container.querySelector(Yl);
                t &&
                    ((this.remainingMaxInt = parseInt(t.getAttribute(uc), 10)),
                    (this.remainingCount = this.container.querySelector(Ql)),
                    (this.remainingJSONWrapper = this.container.querySelector(Zl)),
                    (this.remainingJSON = null),
                    this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? (this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML)) : console.warn("Missing product quantity JSON"));
            }
            (this.enableHistoryState = "true" === this.container.getAttribute(pc)),
                (this.hasUnitPricing = this.container.querySelector(Ol)),
                (this.subSelectors = this.container.querySelector(Bl)),
                (this.subPrices = this.container.querySelector(Ml)),
                (this.isPreOrder = this.container.querySelector(Dl));
            let t = null;
            const e = this.container.querySelector(xl);
            e && (t = e.innerHTML),
                t
                    ? ((this.productJSON = JSON.parse(t)),
                      this.linkForm(),
                      (this.sellout = new (class {
                          init() {
                              this.update();
                          }
                          update() {
                              this.getCurrentState(),
                                  this.optionElements.forEach((t) => {
                                      const e = t.closest(`[${rl}]`);
                                      if (!e) return;
                                      const s = t.value || t.getAttribute(cl),
                                          i = e.getAttribute(rl),
                                          o = parseInt(i, 10) - 1,
                                          n = t.closest(dl);
                                      let r = [...this.selections];
                                      r[o] = s;
                                      const a = this.productJSON.variants.find((t) => {
                                          let e = !0;
                                          for (let s = 0; s < r.length; s++) t.options[s] !== r[s] && (e = !1);
                                          return e;
                                      });
                                      t.classList.remove(hl, ul),
                                          t.parentNode.classList.remove(pl),
                                          n && n.classList.remove(hl, ul, pl),
                                          void 0 === a ? (t.classList.add(ul), n && n.classList.add(ul)) : a && !1 === a.available && (t.classList.add(hl), n && n.classList.add(hl)),
                                          a && a.compare_at_price > a.price && theme.settings.variantOnSale && t.parentNode.classList.add(pl);
                                  });
                          }
                          getCurrentState() {
                              this.selections = [];
                              const t = this.container.querySelectorAll(ll);
                              t.length &&
                                  t.forEach((t) => {
                                      const e = t.value;
                                      e && "" !== e && this.selections.push(e);
                                  });
                          }
                          constructor(t, e) {
                              (this.container = t), (this.productJSON = e), (this.optionElements = this.container.querySelectorAll(al)), this.productJSON && this.optionElements.length && this.init();
                          }
                      })(this.container, this.productJSON)))
                    : console.error("Missing product JSON"),
                (this.variantOptionImages = this.container.querySelectorAll(zl)),
                (this.variantButtons = this.container.querySelectorAll(Ul)),
                this.variantOptionImages.length > 1 && this.optionImagesWidth();
        }
        cartAddEvents() {
            (this.buttonATC = this.querySelector(yl)),
                this.buttonATC.addEventListener("click", (t) => {
                    t.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:add", { detail: { button: this.buttonATC }, bubbles: !1 })), this.closest(Vl) || (window.a11y.lastElement = this.buttonATC);
                });
        }
        destroy() {
            this.productForm.destroy();
        }
        linkForm() {
            (this.productForm = new (class {
                destroy() {
                    this._listeners.removeAll();
                }
                options() {
                    return this._serializeInputValues(this.optionInputs, function (t) {
                        return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                    });
                }
                variant() {
                    const t = this.options();
                    return t.length ? cr(this.product, t) : this.product.variants[0];
                }
                plan(t) {
                    let e = { allocation: null, group: null, detail: null };
                    const s = this.element.querySelector(`${ur}:checked`);
                    if (!s) return null;
                    const i = s.value,
                        o = i && "" !== i ? i : null;
                    return (
                        o &&
                            t &&
                            (e.allocation = t.selling_plan_allocations.find(function (t) {
                                return t.selling_plan_id.toString() === o.toString();
                            })),
                        e.allocation &&
                            (e.group = this.product.selling_plan_groups.find(function (t) {
                                return t.id.toString() === e.allocation.selling_plan_group_id.toString();
                            })),
                        e.group &&
                            (e.detail = e.group.selling_plans.find(function (t) {
                                return t.id.toString() === o.toString();
                            })),
                        e && e.allocation && e.detail && e.allocation ? e : null
                    );
                }
                properties() {
                    return this._serializeInputValues(this.propertyInputs, function (t) {
                        return (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                    });
                }
                quantity() {
                    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
                }
                getFormState() {
                    const t = this.variant();
                    return { options: this.options(), variant: t, properties: this.properties(), quantity: this.quantity(), plan: this.plan(t) };
                }
                _setIdInputValue(t) {
                    t && t.id ? (this.variantElement.value = t.id.toString()) : (this.variantElement.value = ""), this.variantElement.dispatchEvent(new Event("change"));
                }
                _onSubmit(t, e) {
                    (e.dataset = this.getFormState()), t.onFormSubmit && t.onFormSubmit(e);
                }
                _onOptionChange(t) {
                    this._setIdInputValue(t.dataset.variant);
                }
                _onFormEvent(t) {
                    return void 0 === t
                        ? Function.prototype.bind()
                        : function (e) {
                              (e.dataset = this.getFormState()), this._setIdInputValue(e.dataset.variant), t(e);
                          }.bind(this);
                }
                _initInputs(t, e) {
                    return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
                        function (t) {
                            return this._listeners.add(t, "change", this._onFormEvent(e)), t;
                        }.bind(this)
                    );
                }
                _serializeInputValues(t, e) {
                    return t.reduce(function (t, s) {
                        return (s.checked || ("radio" !== s.type && "checkbox" !== s.type)) && t.push(e({ name: s.name, value: s.value })), t;
                    }, []);
                }
                _validateProductObject(t) {
                    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                    if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                    return t;
                }
                constructor(t, e, s) {
                    (this.element = t),
                        (this.product = this._validateProductObject(e)),
                        (this.variantElement = this.element.querySelector(hr)),
                        (s = s || {}),
                        (this._listeners = new lr()),
                        this._listeners.add(this.element, "submit", this._onSubmit.bind(this, s)),
                        (this.optionInputs = this._initInputs(pr, s.onOptionChange)),
                        (this.planInputs = this._initInputs(ur, s.onPlanChange)),
                        (this.quantityInputs = this._initInputs(mr, s.onQuantityChange)),
                        (this.propertyInputs = this._initInputs(vr, s.onPropertyChange));
                }
            })(this.container, this.productJSON, { onOptionChange: this.onOptionChange.bind(this), onPlanChange: this.onPlanChange.bind(this) })),
                this.pushState(this.productForm.getFormState(), !0),
                this.subsToggleListeners();
        }
        onOptionChange(t) {
            this.pushState(t.dataset), this.updateProductImage(t);
        }
        onPlanChange(t) {
            this.subPrices && this.pushState(t.dataset);
        }
        pushState(t, e = !1) {
            var s;
            (this.productState = this.setProductState(t)),
                this.updateAddToCartState(t),
                this.updateNotificationForm(t),
                this.updateProductPrices(t),
                this.updateSaleText(t),
                this.updateSku(t),
                this.updateSubscriptionText(t),
                this.updateRemaining(t),
                this.updateLegend(t),
                this.fireHookEvent(t),
                null === (s = this.sellout) || void 0 === s || s.update(t),
                this.enableHistoryState && !e && this.updateHistoryState(t);
        }
        updateAddToCartState(t) {
            const e = t.variant;
            let s = theme.strings.addToCart;
            const i = this.container.querySelectorAll(Cl),
                o = this.container.querySelectorAll(yl),
                n = this.container.querySelectorAll(wl),
                r = this.container.querySelectorAll(kl);
            if (this.installmentForm && e) {
                const t = this.installmentForm.querySelector(ic);
                (t.value = e.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
            }
            this.isPreOrder && (s = theme.strings.preOrder),
                i.length &&
                    e &&
                    i.forEach((t) => {
                        t.classList.remove(oc);
                    }),
                null == o ||
                    o.forEach((t) => {
                        t.hasAttribute(yc) || (e && e.available ? (t.disabled = !1) : (t.disabled = !0));
                    }),
                null == n ||
                    n.forEach((t) => {
                        let i = s;
                        e ? e.available || (i = theme.strings.soldOut) : (i = theme.strings.unavailable), (t.textContent = i);
                    }),
                r.length &&
                    r.forEach((t) => {
                        if (e) {
                            e.available ? t.classList.remove(nc, rc) : (t.classList.add(nc), t.classList.remove(rc));
                            const s = t.querySelector(Al);
                            s && (s.value = e.id);
                            const i = t.querySelector(`${ic}[form]`);
                            i && ((i.value = e.id), i.dispatchEvent(new Event("change")));
                        } else t.classList.add(rc), t.classList.remove(nc);
                    });
        }
        updateNotificationForm(t) {
            if (!this.productNotification) return;
            const e = this.productNotification.querySelector(bl),
                s = this.productNotification.querySelector(fl);
            null != e && ((e.textContent = t.variant.title), (s.value = t.variant.name));
        }
        updateHistoryState(t) {
            const e = t.variant,
                s = t.plan,
                i = window.location.href;
            if (e && i.includes("/product")) {
                const t = new window.URL(i),
                    o = t.searchParams;
                o.set("variant", e.id), s && s.detail && s.detail.id && this.productState.hasPlan ? o.set("selling_plan", s.detail.id) : o.delete("selling_plan"), (t.search = o.toString());
                const n = t.toString();
                window.history.replaceState({ path: n }, "", n);
            }
        }
        updateRemaining(t) {
            var e;
            const s = t.variant;
            if ((null === (e = this.remainingWrapper) || void 0 === e || e.classList.remove(cc, dc, hc, lc), s && this.remainingWrapper && this.remainingJSON)) {
                const t = this.remainingJSON[s.id];
                ("out" === t || t < 1) && this.remainingWrapper.classList.add(dc),
                    ("in" === t || t >= this.remainingMaxInt) && this.remainingWrapper.classList.add(cc),
                    ("low" === t || (t > 0 && t < this.remainingMaxInt)) && (this.remainingWrapper.classList.add(lc), this.remainingCount && (this.remainingCount.innerHTML = t));
            } else !s && this.remainingWrapper && this.remainingWrapper.classList.add(hc);
        }
        optionImagesWidth() {
            if (!this.variantButtons) return;
            let t = 0;
            requestAnimationFrame(() => {
                this.variantOptionImages.forEach((e) => {
                    const s = e.clientWidth;
                    s > t && (t = s);
                }),
                    this.variantButtons.forEach((e) => {
                        var s;
                        null === (s = e.style) || void 0 === s || s.setProperty("--option-image-width", t + "px");
                    });
            });
        }
        getBaseUnit(t) {
            return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
        }
        subsToggleListeners() {
            this.container.querySelectorAll(Fl).forEach((t) => {
                t.addEventListener(
                    "change",
                    function (t) {
                        const e = t.target.value.toString(),
                            s = this.container.querySelector(`[${_l}="${e}"]`),
                            i = this.container.querySelectorAll(`[${_l}]`);
                        if (s) {
                            s.classList.remove(oc);
                            const t = s.querySelector('[name="selling_plan"]');
                            (t.checked = !0), t.dispatchEvent(new Event("change"));
                        }
                        i.forEach((t) => {
                            if (t !== s) {
                                t.classList.add(oc);
                                t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                                    (t.checked = !1), t.dispatchEvent(new Event("change"));
                                });
                            }
                        });
                    }.bind(this)
                );
            });
        }
        updateSaleText(t) {
            this.productState.planSale ? this.updateSaleTextSubscription(t) : this.productState.onSale ? this.updateSaleTextStandard(t) : this.priceOffWrap && this.priceOffWrap.classList.add(oc);
        }
        isVariantFinalSale(t) {
            var e;
            const s = null === (e = document.querySelector(Wl)) || void 0 === e ? void 0 : e.textContent;
            if (!s) return;
            const i = JSON.parse(s);
            let o = !1;
            return (
                i.forEach((e) => {
                    Number(e.variant_id) === t.id && (o = "true" === e.metafield_value);
                }),
                o
            );
        }
        updateSaleTextStandard(t) {
            var e, s, i;
            const o = t.variant,
                n = null === (e = this.priceOffWrap) || void 0 === e ? void 0 : e.querySelector(Ll),
                r = null === (s = this.priceOffWrap) || void 0 === s ? void 0 : s.querySelector(Jl),
                a = null == o ? void 0 : o.compare_at_price,
                l = null == o ? void 0 : o.price;
            if ((this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"), r && this.priceOffAmount && a && l && !(a <= l))) {
                const t = Math.round(((a - l) / a) * 100);
                (this.priceOffAmount.innerHTML = `${t}%`), r.classList.remove(oc);
            } else null == r || r.classList.add(oc);
            const c = (null === (i = this.priceOffWrap) || void 0 === i ? void 0 : i.hasAttribute(wc)) || this.isVariantFinalSale(o);
            n && n.classList.toggle(oc, !c), this.priceOffWrap.classList.remove(oc);
        }
        updateSubscriptionText(t) {
            t.plan && this.planDescription ? ((this.planDescription.innerHTML = t.plan.detail.description), this.planDescription.classList.remove(oc)) : this.planDescription && this.planDescription.classList.add(oc);
        }
        updateSaleTextSubscription(t) {
            if ((this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton"), this.priceOffAmount && this.priceOffWrap)) {
                const e = t.plan.detail.price_adjustments[0],
                    s = e.value;
                e && "percentage" === e.value_type ? (this.priceOffAmount.innerHTML = `${s}%`) : (this.priceOffAmount.innerHTML = Xe(s, theme.moneyFormat)), this.priceOffWrap.classList.remove(oc);
            }
        }
        updateProductPrices(t) {
            const e = t.variant,
                s = t.plan;
            this.container.querySelectorAll(Cl).forEach((t) => {
                const i = t.querySelector(Sl),
                    o = t.querySelector(Pl),
                    n = t.querySelector(El);
                let r = "",
                    a = "";
                this.productState.available && ((r = e.compare_at_price), (a = e.price)),
                    this.productState.hasPlan && (a = s.allocation.price),
                    this.productState.planSale && ((r = s.allocation.compare_at_price), (a = s.allocation.price)),
                    i &&
                        (this.productState.onSale || this.productState.planSale ? (i.classList.remove(oc), n.classList.remove(oc), o.classList.add(ac)) : (i.classList.add(oc), n.classList.add(oc), o.classList.remove(ac)),
                        (i.innerHTML = Xe(r, theme.moneyFormat))),
                    (o.innerHTML = 0 === a ? window.theme.strings.free : Xe(a, theme.moneyFormat));
            }),
                this.hasUnitPricing && this.updateProductUnits(t);
        }
        updateProductUnits(t) {
            const e = t.variant,
                s = t.plan;
            let i = null;
            if ((e && e.unit_price && (i = e.unit_price), s && s.allocation && s.allocation.unit_price && (i = s.allocation.unit_price), i)) {
                const t = this.getBaseUnit(e),
                    s = Xe(i, theme.moneyFormat);
                (this.container.querySelector(Il).innerHTML = s), (this.container.querySelector(Hl).innerHTML = t), this.container.querySelector(Ol).classList.remove(oc);
            } else this.container.querySelector(Ol).classList.add(oc);
        }
        updateSku(t) {
            this.skuWrapper && (this.skuWrapper.innerHTML = `${theme.strings.sku}: ${t.variant.sku}`);
        }
        fireHookEvent(t) {
            const e = t.variant;
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", { detail: { variant: e }, bubbles: !0 }));
        }
        setProductState(t) {
            const e = t.variant,
                s = t.plan,
                i = { available: !0, soldOut: !1, onSale: !1, showUnitPrice: !1, requiresPlan: !1, hasPlan: !1, planPerDelivery: !1, planSale: !1 };
            return (
                !e || (e.requires_selling_plan && !s)
                    ? (i.available = !1)
                    : (e.available || (i.soldOut = !0),
                      e.compare_at_price > e.price && (i.onSale = !0),
                      e.unit_price && (i.showUnitPrice = !0),
                      this.product && this.product.requires_selling_plan && (i.requiresPlan = !0),
                      s && this.subPrices && ((i.hasPlan = !0), s.allocation.per_delivery_price !== s.allocation.price && (i.planPerDelivery = !0), e.price > s.allocation.price && (i.planSale = !0))),
                i
            );
        }
        updateProductImage(t) {
            const e = t.dataset.variant;
            if (e && e.featured_media) {
                const t = this.container.querySelector(`[${bc}="${e.featured_media.id}"]`);
                if (t) {
                    const e = t.getAttribute(fc),
                        s = v();
                    if ((t.dispatchEvent(new CustomEvent("theme:media:select", { bubbles: !0, detail: { id: e } })), s && !this.productImages.hasAttribute(mc) && this.variantImageScroll)) {
                        const e = t.getBoundingClientRect().top;
                        document.dispatchEvent(new CustomEvent("theme:tooltip:close", { bubbles: !1, detail: { hideTransition: !1 } })), Vo(e);
                    }
                    s || this.productImages.hasAttribute(vc) || this.productMediaList.scrollTo({ left: t.offsetLeft });
                }
            }
        }
        updateLegend(t) {
            const e = t.variant;
            if (e) {
                const t = this.container.querySelectorAll(tc);
                t.length &&
                    t.forEach((t) => {
                        const s = t.closest(ec);
                        if (s) {
                            const i = s.getAttribute(gc),
                                o = parseInt(i, 10) - 1,
                                n = e.options[o];
                            t.innerHTML = n;
                        }
                    });
            }
        }
        constructor() {
            super();
        }
    };
    const Lc = "[data-popup-open]",
        kc = "[data-popup-close]",
        Ac = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Cc = "closing";
    let qc = class {
        popupOpen() {
            this.popup &&
                ((this.isAnimating = !0),
                this.showModal && "function" == typeof this.popup.showModal ? this.popup.showModal() : this.showModal || "function" != typeof this.popup.show ? this.popup.setAttribute("open", "") : this.popup.show(),
                this.popup.removeAttribute("inert"),
                this.popup.setAttribute("aria-hidden", !1),
                this.popup.focus(),
                this.enableScrollLock && document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                N(this.popup).then(() => {
                    (this.isAnimating = !1), this.enableScrollLock && this.a11y.trapFocus(this.popup);
                    const t = this.popup.querySelector("[autofocus]") || this.popup.querySelector(Ac);
                    null == t || t.focus();
                }));
        }
        popupClose() {
            if (!this.isAnimating && this.popup && !this.popup.hasAttribute("inert")) {
                if (!this.popup.hasAttribute(Cc))
                    return (
                        this.popup.setAttribute(Cc, ""),
                        (this.isAnimating = !0),
                        void N(this.popup).then(() => {
                            (this.isAnimating = !1), this.popupClose();
                        })
                    );
                "function" == typeof this.popup.close ? this.popup.close() : (this.popup.removeAttribute("open"), this.popup.setAttribute("aria-hidden", !0)), this.popupCloseActions();
            }
        }
        popupCloseActions() {
            this.popup.hasAttribute("inert") ||
                (this.popup.setAttribute("inert", ""),
                this.popup.setAttribute("aria-hidden", !0),
                this.popup.removeAttribute(Cc),
                !Ta() && this.enableScrollLock && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                this.popup.dispatchEvent(new CustomEvent("theme:popup:onclose", { bubbles: !1 })),
                this.enableScrollLock && (this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()));
        }
        popupEvents() {
            var t;
            if (!this.popup) return;
            null === (t = this.buttonPopupOpen) ||
                void 0 === t ||
                t.addEventListener("click", (t) => {
                    t.preventDefault(), this.popupOpen(), (window.a11y.lastElement = this.buttonPopupOpen);
                });
            const e = this.popup.querySelectorAll(kc);
            e.length &&
                e.forEach((t) => {
                    t.addEventListener("click", (t) => {
                        t.preventDefault(), this.popupClose();
                    });
                }),
                this.showModal &&
                    this.popup.addEventListener("click", (t) => {
                        "DIALOG" === t.target.nodeName && "click" === t.type && this.popupClose();
                    }),
                this.popup.addEventListener("keydown", (t) => {
                    "Escape" === t.code && (t.preventDefault(), this.popupClose());
                }),
                this.popup.addEventListener("close", () => this.popupCloseActions());
        }
        constructor(t, e, s = !0, i = !0) {
            var o;
            (this.popup = t),
                (this.holder = e),
                (this.a11y = $),
                (this.isAnimating = !1),
                (this.showModal = s),
                (this.enableScrollLock = i),
                (this.buttonPopupOpen = null === (o = this.holder) || void 0 === o ? void 0 : o.querySelector(Lc)),
                this.popupEvents();
        }
    };
    const Tc = "dialog";
    let xc = class extends HTMLElement {
            connectedCallback() {
                new qc(this.querySelector(Tc), this, !0, !0);
            }
            constructor() {
                super();
            }
        },
        Pc = class extends ee {
            loadContent() {
                super.loadContent(), Shopify.loadFeatures([{ name: "model-viewer-ui", version: "1.0", onLoad: this.setupModelViewerUI.bind(this) }]);
            }
            setupModelViewerUI(t) {
                t || (this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer")));
            }
            constructor() {
                super();
            }
        };
    (window.ProductModel = {
        loadShopifyXR() {
            Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: this.setupShopifyXR.bind(this) }]);
        },
        setupShopifyXR(t) {
            t ||
                (window.ShopifyXR
                    ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach((t) => {
                          window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
                      }),
                      window.ShopifyXR.setupXRElements())
                    : document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR()));
        },
    }),
        window.addEventListener("DOMContentLoaded", () => {
            window.ProductModel && window.ProductModel.loadShopifyXR();
        });
    const Ic = "[data-add-to-cart]",
        Hc = "[data-product-json]",
        Oc = "[data-product-form]",
        Dc = "#cart-bar",
        Mc = "[data-popup-open]",
        Bc = ".product__submit__add",
        Fc = "[data-form-wrapper]",
        _c = "[data-product-variants]",
        $c = "[data-slider]",
        Nc = "is-visible",
        Rc = "is-loading",
        Wc = "data-cart-bar-enabled",
        Uc = "data-add-to-cart-bar",
        zc = "data-cart-bar-scroll",
        Vc = "data-cart-bar-product-notification",
        jc = "data-section-id",
        Jc = "data-slider-index",
        Xc = {};
    const Gc = {
        onLoad() {
            Xc[this.id] = new (class {
                initCartBar() {
                    (this.cartBarBtns = this.cartBar.querySelectorAll(Bc)),
                        this.cartBarBtns.length > 0 &&
                            this.cartBarBtns.forEach((t) => {
                                t.addEventListener("click", (t) => {
                                    if ((t.preventDefault(), t.currentTarget.hasAttribute(Uc)))
                                        this.cartBarEnabled && (t.currentTarget.classList.add(Rc), t.currentTarget.setAttribute("disabled", "disabled")), this.form.querySelector(Ic).dispatchEvent(new Event("click", { bubbles: !0 }));
                                    else if (t.currentTarget.hasAttribute(zc)) this.scrollToTop();
                                    else if (t.currentTarget.hasAttribute(Vc)) {
                                        var e;
                                        null === (e = this.form.querySelector(Mc)) || void 0 === e || e.dispatchEvent(new Event("click"));
                                    }
                                }),
                                    t.hasAttribute(Uc) && document.addEventListener("theme:product:add-error", this.scrollToTop);
                            }),
                        this.setCartBarHeight();
                }
                scrollToTop() {
                    const t = this.container.querySelector(_c),
                        e = (v() ? this.container : t || this.form).getBoundingClientRect().top;
                    Vo(v() ? e : e - 10);
                }
                toggleCartBarOnScroll() {
                    const t = window.scrollY,
                        e = theme.variables.productPageSticky && this.formWrapper ? this.formWrapper : this.form;
                    if (e && this.cartBar) {
                        const s = t > e.offsetTop + e.offsetHeight;
                        this.cartBar.classList.toggle(Nc, s);
                    }
                }
                setCartBarHeight() {
                    const t = this.cartBar.offsetHeight;
                    document.documentElement.style.setProperty("--cart-bar-height", `${t}px`);
                }
                onUnload() {
                    document.removeEventListener("theme:product:add-error", this.scrollToTop),
                        this.cartBarEnabled && (document.removeEventListener("theme:scroll", this.toggleCartBarOnScroll), document.removeEventListener("theme:resize", this.setCartBarHeight));
                }
                onBlockSelect(t) {
                    const e = t.srcElement.closest($c);
                    if (e && this.slider.length) {
                        const s = e.hasAttribute(Jc) ? e.getAttribute(Jc) : 0;
                        if (!this.slider[s]) return;
                        this.slider[s].onBlockSelect(t);
                    }
                }
                onBlockDeselect(t) {
                    const e = t.srcElement.closest($c);
                    if (e && this.slider.length) {
                        const s = e.hasAttribute(Jc) ? e.getAttribute(Jc) : 0;
                        if (!this.slider[s]) return;
                        this.slider[s].onBlockDeselect(t);
                    }
                }
                constructor(t) {
                    (this.section = t),
                        (this.container = t.container),
                        (this.id = this.container.getAttribute(jc)),
                        (this.sliders = this.container.querySelectorAll($c)),
                        (this.slider = []),
                        (this.formWrapper = this.container.querySelector(Fc)),
                        (this.cartBarEnabled = this.container.hasAttribute(Wc)),
                        (this.cartBar = this.container.querySelector(Dc)),
                        (this.setCartBarHeight = this.setCartBarHeight.bind(this)),
                        (this.scrollToTop = this.scrollToTop.bind(this)),
                        (this.toggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this)),
                        (this.unlockTimer = 0),
                        (this.accessibility = $);
                    const e = this.container.querySelector(Hc);
                    if ((e && !e.innerHTML) || !e) return;
                    const s = JSON.parse(e.innerHTML).handle;
                    let i = {};
                    s && (i = { handle: s }),
                        Shopify.Products.recordRecentlyViewed(i),
                        (this.form = this.container.querySelector(Oc)),
                        this.sliders.length &&
                            this.sliders.forEach((t, e) => {
                                t.setAttribute(Jc, e), this.slider.push(new Uo(this.container, t));
                            }),
                        this.cartBarEnabled && (this.initCartBar(), this.setCartBarHeight(), document.addEventListener("theme:scroll", this.toggleCartBarOnScroll), document.addEventListener("theme:resize", this.setCartBarHeight));
                }
            })(this);
        },
        onUnload(t) {
            Xc[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            Xc[this.id].onBlockSelect(t);
        },
        onBlockDeselect(t) {
            Xc[this.id].onBlockDeselect(t);
        },
    };
    so("product", [Gc, bo, qa, nl]),
        customElements.get("product-form") || customElements.define("product-form", Ec),
        customElements.get("product-modal") || customElements.define("product-modal", xc),
        customElements.get("product-model") || customElements.define("product-model", Pc),
        customElements.get("product-siblings") || customElements.define("product-siblings", sa),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Wr);
    const Qc = "[data-api-related-template]",
        Yc = "[data-related-section]",
        Kc = "[data-grid-item]",
        Zc = "[data-recent-wrapper]",
        td = "[data-recently-viewed-wrapper]",
        ed = ".product-item",
        sd = "grid-slider",
        id = "data-limit",
        od = "data-minimum",
        nd = "data-product-id",
        rd = "is-hidden",
        ad = "grid--mobile-slider",
        ld = {};
    const cd = {
        onLoad() {
            ld[this.id] = new (class {
                init() {
                    this.loadRelatedProducts(), this.loadRecentlyViewedProducts();
                }
                loadRelatedProducts() {
                    const t = this.container.querySelector(Yc);
                    if (!t) return;
                    const e = t.getAttribute(nd),
                        s = t.getAttribute(id),
                        i = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${s}&product_id=${e}&intent=related`;
                    fetch(i)
                        .then((t) => t.text())
                        .then((e) => this.handleRelatedProductsResponse(e, t))
                        .catch(() => this.hideSection(t));
                }
                handleRelatedProductsResponse(t, e) {
                    const s = document.createElement("div");
                    s.innerHTML = new DOMParser().parseFromString(t, "text/html").querySelector(Qc).innerHTML;
                    const i = s.querySelectorAll(Kc).length;
                    i > 0 ? ((e.innerHTML = s.innerHTML), (this.relatedItems = i), 0 === parseInt(e.style.getPropertyValue("--COLUMNS-MOBILE")) && e.querySelector(Kc).parentElement.classList.add(ad)) : this.hideSection(e),
                        this.updateVisibility();
                }
                loadRecentlyViewedProducts() {
                    const t = this.container.querySelector(Zc),
                        e = parseInt(t.getAttribute(id)) || 4,
                        s = parseInt(t.getAttribute(od)) || 4;
                    Shopify.Products.showRecentlyViewed({
                        howManyToShow: e,
                        wrapperId: `recently-viewed-products-${this.sectionId}`,
                        section: this.section,
                        target: "api-product-grid-item",
                        onComplete: (e, i) => this.handleRecentlyViewedResponse(e, i, t, s),
                    });
                }
                handleRecentlyViewedResponse(t, e, s, i) {
                    const o = e.container;
                    if (!o) return;
                    const n = o.querySelector(td),
                        r = t.querySelectorAll(ed),
                        a = s.querySelector(sd),
                        l = !n && r.length > 0,
                        c = n && r.length >= i;
                    (l || c) && (c && n.classList.remove(rd), s.classList.remove(rd), s.dispatchEvent(new CustomEvent("theme:tab:check", { bubbles: !0 })), a && a.dispatchEvent(new CustomEvent("theme:grid-slider:init", { bubbles: !0 }))),
                        this.updateVisibility();
                }
                hideSection(t) {
                    t.dispatchEvent(new CustomEvent("theme:tab:hide", { bubbles: !0 }));
                }
                updateVisibility() {
                    const t = Shopify.Products.getConfig().howManyToShow < 1 && this.relatedItems < 1;
                    this.container.classList.toggle(rd, t);
                }
                constructor(t) {
                    (this.section = t), (this.sectionId = t.id), (this.container = t.container), (this.relatedItems = 0), this.init();
                }
            })(this);
        },
    };
    so("related", [cd, qa]), so("reviews", [zo]);
    const dd = {},
        hd = "[data-slider-logos]",
        ud = "[data-slider-text]",
        pd = "[data-slide]",
        md = "is-selected",
        vd = "is-initialized",
        gd = "flickity-enabled",
        bd = "data-slide",
        fd = "data-slide-index";
    so("logos", [
        {
            onLoad() {
                dd[this.id] = new (class {
                    getSlidesWidth() {
                        return 200 * this.logoSlides.length;
                    }
                    initSlideshowText() {
                        this.slideshowText &&
                            (this.flkty = new s(this.slideshowText, {
                                fade: !0,
                                autoPlay: !1,
                                prevNextButtons: !1,
                                cellAlign: "left",
                                contain: !0,
                                pageDots: !1,
                                wrapAround: !1,
                                selectedAttraction: 0.2,
                                friction: 0.6,
                                draggable: !1,
                                accessibility: !1,
                                on: { ready: () => this.sliderAccessibility(), change: () => this.sliderAccessibility() },
                            }));
                    }
                    sliderAccessibility() {
                        const t = this.slideshowText.querySelectorAll(`${pd} a, ${pd} button`);
                        t.length &&
                            t.forEach((t) => {
                                const e = t.closest(pd);
                                if (e) {
                                    const s = e.classList.contains(md) ? 0 : -1;
                                    t.setAttribute("tabindex", s);
                                }
                            });
                    }
                    initSlideshowNav() {
                        this.slideshowNav &&
                            (this.logoSlides.length &&
                                this.logoSlides.forEach((t) => {
                                    t.addEventListener("click", () => {
                                        const e = parseInt(t.getAttribute(fd)),
                                            s = this.slideshowNav.classList.contains(gd);
                                        if ((this.flkty && this.flkty.select(e), s)) this.flktyNav.select(e), this.slideshowNav.classList.contains(md) || this.flktyNav.playPlayer();
                                        else {
                                            const e = this.slideshowNav.querySelector(`.${md}`);
                                            e && e.classList.remove(md), t.classList.add(md);
                                        }
                                    });
                                }),
                            this.setSlideshowNavState(),
                            document.addEventListener("theme:resize", this.setSlideshowNavStateOnResize));
                    }
                    setSlideshowNavState() {
                        const t = this.slideshowNav.classList.contains(gd);
                        if (this.logoSlidesWidth > p()) {
                            if (!t) {
                                this.slideshowNav.classList.add(vd);
                                const t = this.slideshowNav.querySelector(`.${md}`);
                                t && t.classList.remove(md),
                                    this.logoSlides[0].classList.add(md),
                                    this.flktyNav ||
                                        ((this.flktyNav = new e(this.slideshowNav, { autoPlay: 4e3, prevNextButtons: !1, contain: !1, pageDots: !1, wrapAround: !0, watchCSS: !0, selectedAttraction: 0.05, friction: 0.8, initialIndex: 0 })),
                                        this.flktyNav.on("deactivate", () => {
                                            this.slideshowNav.querySelector(pd).classList.add(md), this.flkty && this.flkty.select(0);
                                        }),
                                        this.flkty && (this.flkty.select(0), this.flktyNav.on("change", (t) => this.flkty.select(t))));
                            }
                        } else t && this.slideshowNav.classList.remove(vd);
                    }
                    onBlockSelect(t) {
                        if (!this.slideshowNav) return;
                        const e = this.slideshowNav.querySelector(`[${bd}="${t.detail.blockId}"]`),
                            s = parseInt(e.getAttribute(fd));
                        this.slideshowNav.classList.contains(gd) ? (this.flktyNav.select(s), this.flktyNav.stopPlayer(), this.slideshowNav.classList.add(md)) : e.dispatchEvent(new Event("click"));
                    }
                    onBlockDeselect() {
                        this.slideshowNav && this.slideshowNav.classList.contains(gd) && (this.flktyNav.playPlayer(), this.slideshowNav.classList.remove(md));
                    }
                    onUnload() {
                        document.removeEventListener("theme:resize", this.setSlideshowNavStateOnResize);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.slideshowNav = this.container.querySelector(hd)),
                            (this.slideshowText = this.container.querySelector(ud)),
                            (this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState()),
                            (this.flkty = null),
                            (this.flktyNav = null),
                            (this.logoSlides = this.slideshowNav.querySelectorAll(pd)),
                            (this.logoSlidesWidth = this.getSlidesWidth()),
                            this.initSlideshowText(),
                            this.initSlideshowNav();
                    }
                })(this);
            },
            onUnload(t) {
                dd[this.id].onUnload(t);
            },
            onBlockSelect(t) {
                dd[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                dd[this.id].onBlockDeselect(t);
            },
        },
    ]),
        so("slideshow", [zo]),
        so("custom-content", [zo, en]);
    const yd = "[data-large-promo]",
        wd = "[data-large-promo-inner]",
        Sd = "cart-bar",
        Ed = "[data-newsletter]",
        Ld = "[data-newsletter-holder]",
        kd = "[data-newsletter-heading]",
        Ad = "[data-newsletter-field]",
        Cd = "[data-promo-text]",
        qd = "[data-newsletter-form]",
        Td = "data-popup-delay",
        xd = "data-cookie-name",
        Pd = "data-target-referrer",
        Id = "hidden",
        Hd = "has-value",
        Od = "cart-bar-visible",
        Dd = "is-visible",
        Md = "has-success",
        Bd = "selected",
        Fd = "has-block-selected",
        _d = "mobile",
        $d = "desktop",
        Nd = "bottom";
    let Rd = {},
        Wd = class {
            always() {
                this.popupActions.popupOpen();
            }
            delayed(t = 10) {
                setTimeout(() => {
                    this.popupActions.popupOpen();
                }, 1e3 * t);
            }
            idle() {
                let t = 0;
                const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    s = ["load", "resize", "scroll"],
                    i = () => {
                        (t = setTimeout(() => {
                            (t = 0), this.popupActions.popupOpen();
                        }, 6e4)),
                            e.forEach((t) => {
                                document.addEventListener(t, o);
                            }),
                            s.forEach((t) => {
                                window.addEventListener(t, o);
                            });
                    },
                    o = () => {
                        t && clearTimeout(t),
                            e.forEach((t) => {
                                document.removeEventListener(t, o);
                            }),
                            s.forEach((t) => {
                                window.removeEventListener(t, o);
                            }),
                            i();
                    };
                i();
            }
            bottom() {
                document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            showPopupOnScroll() {
                window.scrollY + window.innerHeight >= document.body.clientHeight && (this.popupActions.popupOpen(), document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent));
            }
            onUnload() {
                document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            constructor(t, e, s) {
                if (
                    ((this.element = e),
                    (this.delay = t.getAttribute(Td)),
                    (this.isSubmitted = -1 !== window.location.href.indexOf("accepts_marketing") || -1 !== window.location.href.indexOf("customer_posted=true")),
                    (this.popupActions = s),
                    (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
                    ("always" === this.delay || this.isSubmitted) && this.always(),
                    this.delay && this.delay.includes("delayed") && !this.isSubmitted)
                ) {
                    const t = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
                    this.delayed(t);
                }
                "bottom" !== this.delay || this.isSubmitted || this.bottom(), "idle" !== this.delay || this.isSubmitted || this.idle();
            }
        },
        Ud = class {
            init() {
                -1 !== this.locationPath.indexOf(this.el.getAttribute(Pd)) || window.Shopify.designMode || this.el.parentNode.removeChild(this.el);
            }
            constructor(t) {
                if (((this.el = t), (this.locationPath = location.href), !this.el.hasAttribute(Pd))) return !1;
                this.init();
            }
        };
    const zd = {
        onLoad() {
            Rd[this.id] = [];
            this.container.querySelectorAll(yd).forEach((t) => {
                Rd[this.id].push(
                    new (class {
                        init() {
                            const t = !1 !== this.cookie.read(),
                                e = this.popup.classList.contains(_d),
                                s = this.popup.classList.contains($d),
                                i = !v();
                            let o = !0;
                            if ((((e && !i) || (s && i)) && (o = !1), !o)) return this.a11y.removeTrapFocus(), void document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                            (t && !window.Shopify.designMode) ||
                                (window.Shopify.designMode || window.location.pathname.endsWith("/challenge") || new Wd(this.popup, this.modal, this.popupActions),
                                this.form && this.form.classList.contains(Md) && this.checkForSuccess(),
                                this.modal.addEventListener("theme:popup:onclose", () => this.cookie.write()));
                        }
                        checkForSuccess() {
                            this.popupActions.popupOpen(), this.cookie.write();
                        }
                        onBlockSelect(t) {
                            this.popup.contains(t.target) && (this.popupActions.popupOpen(), this.popup.classList.add(Bd), this.popup.parentNode.classList.add(Fd));
                        }
                        onBlockDeselect(t) {
                            this.popup.contains(t.target) && (this.popupActions.popupClose(), this.popup.classList.remove(Bd), this.popup.parentNode.classList.remove(Fd));
                        }
                        constructor(t) {
                            (this.popup = t),
                                (this.modal = this.popup.querySelector(wd)),
                                (this.form = this.popup.querySelector(qd)),
                                (this.cookie = new jo(this.popup.getAttribute(xd), "user_has_closed")),
                                (this.isTargeted = new Ud(this.popup)),
                                (this.popupActions = new qc(this.modal, this.modal, !0, !0)),
                                (this.a11y = $),
                                this.init();
                        }
                    })(t)
                );
            });
            this.container.querySelectorAll(Ed).forEach((t) => {
                Rd[this.id].push(
                    new (class {
                        init() {
                            const t = !1 !== this.cookie.read(),
                                e = -1 !== window.location.search.indexOf("?customer_posted=true"),
                                s = [...this.holder.classList].toString().includes(Nd);
                            e && (this.delay = 0), (t && !window.Shopify.designMode) || (this.show(), this.form.classList.contains(Md) && this.checkForSuccess()), s && this.observeCartBar();
                        }
                        show() {
                            window.location.pathname.endsWith("/challenge") || (window.Shopify.designMode ? this.popupActions.popupOpen() : new Wd(this.popup, this.holder, this.popupActions)),
                                this.showForm(),
                                this.inputField(),
                                this.holder.addEventListener("theme:popup:onclose", () => this.cookie.write());
                        }
                        checkForSuccess() {
                            this.popupActions.popupOpen(), this.cookie.write();
                        }
                        observeCartBar() {
                            if (((this.cartBar = document.getElementById(Sd)), !this.cartBar)) return;
                            let t = this.cartBar.classList.contains(Dd);
                            document.body.classList.toggle(Od, t),
                                (this.observer = new MutationObserver((e) => {
                                    for (const s of e) "attributes" === s.type && ((t = s.target.classList.contains(Dd)), document.body.classList.toggle(Od, t));
                                })),
                                this.observer.observe(this.cartBar, { attributes: !0, childList: !1, subtree: !1 });
                        }
                        showForm() {
                            this.heading.addEventListener("click", (t) => {
                                t.preventDefault(), this.heading.classList.add(Id), this.form.classList.remove(Id), this.newsletterField.focus();
                            }),
                                this.heading.addEventListener("keyup", (t) => {
                                    "Enter" === t.code && this.heading.dispatchEvent(new Event("click"));
                                });
                        }
                        inputField() {
                            const t = () => {
                                this.resetClassTimer && clearTimeout(this.resetClassTimer), "" !== this.newsletterField.value && this.holder.classList.add(Hd);
                            };
                            this.newsletterField.addEventListener("input", t),
                                this.newsletterField.addEventListener("focus", t),
                                this.newsletterField.addEventListener("focusout", () => {
                                    this.resetClassTimer && clearTimeout(this.resetClassTimer),
                                        (this.resetClassTimer = setTimeout(() => {
                                            this.holder.classList.remove(Hd);
                                        }, 2e3));
                                });
                        }
                        onBlockSelect(t) {
                            this.popup.contains(t.target) && (this.popupActions.popupOpen(), this.popup.classList.add(Bd), this.popup.parentNode.classList.add(Fd));
                        }
                        onBlockDeselect(t) {
                            this.popup.contains(t.target) && (this.popupActions.popupClose(), this.popup.classList.remove(Bd), this.popup.parentNode.classList.remove(Fd));
                        }
                        onUnload() {
                            this.observer && this.observer.disconnect();
                        }
                        constructor(t) {
                            (this.popup = t),
                                (this.holder = this.popup.querySelector(Ld)),
                                (this.heading = this.popup.querySelector(kd)),
                                (this.newsletterField = this.popup.querySelector(Ad)),
                                (this.cookie = new jo(this.popup.getAttribute(xd), "newsletter_is_closed")),
                                (this.form = this.popup.querySelector(qd)),
                                (this.isTargeted = new Ud(this.popup)),
                                (this.popupActions = new qc(this.holder, this.holder, !1, !1)),
                                (this.resetClassTimer = 0),
                                this.init();
                        }
                    })(t)
                );
            });
            this.container.querySelectorAll(Cd).forEach((t) => {
                Rd[this.id].push(
                    new (class {
                        init() {
                            (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                                (window.Shopify.designMode ? this.popupActions.popupOpen() : new Wd(this.popup, this.popup, this.popupActions), this.popup.addEventListener("theme:popup:onclose", () => this.cookie.write()));
                        }
                        onSelect() {
                            this.popupActions.popupOpen(), this.popup.classList.add(Bd), this.popup.parentNode.classList.add(Fd);
                        }
                        onDeselect() {
                            this.popupActions.popupClose(), this.popup.classList.remove(Bd), this.popup.parentNode.classList.remove(Fd);
                        }
                        constructor(t) {
                            (this.popup = t), (this.cookie = new jo(this.popup.getAttribute(xd), "user_has_closed")), (this.isTargeted = new Ud(this.popup)), (this.popupActions = new qc(this.popup, this.popup, !1, !1)), this.init();
                        }
                    })(t)
                );
            });
        },
        onBlockSelect(t) {
            Rd[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
            });
        },
        onBlockDeselect(t) {
            Rd[this.id].forEach((e) => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
            });
        },
        onSelect() {
            Rd[this.id].forEach((t) => {
                "function" == typeof t.onSelect && t.onSelect();
            });
        },
        onDeselect() {
            Rd[this.id].forEach((t) => {
                "function" == typeof t.onDeselect && t.onDeselect();
            });
        },
        onUnload() {
            Rd[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
    };
    so("popups", [zd, en]);
    const Vd = "[data-password-modal]",
        jd = "#login_form .errors";
    so("password-template", {
        onLoad() {
            new (class {
                constructor(t) {
                    (this.container = t.container), (this.popupActions = new qc(this.container.querySelector(Vd), this.container, !0, !0)), this.container.querySelector(jd) && this.popupActions.popupOpen();
                }
            })(this);
        },
    }),
        so("list-collections", [zo]),
        so("columns", [zo]),
        so("newsletter", en);
    const Jd = "[data-scroll-to]",
        Xd = "[data-tooltip]",
        Gd = "[data-collapsible-trigger]",
        Qd = "open",
        Yd = "data-scroll-to",
        Kd = "data-tooltip-stop-mouseenter",
        Zd = {};
    const th = {
            onLoad() {
                Zd[this.id] = new (class {
                    init() {
                        this.scrollToButtons.forEach((t) => {
                            t.addEventListener("click", () => {
                                const e = this.container.querySelector(t.getAttribute(Yd));
                                e && "A" !== t.tagName && this.scrollToElement(e);
                            });
                        });
                    }
                    scrollToElement(t) {
                        Vo(t.getBoundingClientRect().top + 1);
                        const e = t.nextElementSibling.matches("details") ? t.nextElementSibling : null;
                        if (e) {
                            const t = null == e ? void 0 : e.querySelector(Gd);
                            e.hasAttribute(Qd) || null == t || t.dispatchEvent(new Event("click"));
                        }
                        const s = document.querySelectorAll(`${Xd}:not([${Kd}])`);
                        s.length &&
                            s.forEach((t) => {
                                t.setAttribute(Kd, ""),
                                    setTimeout(() => {
                                        t.removeAttribute(Kd);
                                    }, 1e3);
                            });
                    }
                    constructor(t) {
                        (this.section = t), (this.container = t.container), (this.scrollToButtons = this.container.querySelectorAll(Jd)), this.scrollToButtons.length && this.init();
                    }
                })(this);
            },
        },
        eh = "[data-scroll-spy]",
        sh = "is-selected",
        ih = "data-scroll-spy",
        oh = "data-scroll-spy-mobile",
        nh = "data-scroll-spy-desktop",
        rh = "data-scroll-trigger-point",
        ah = {};
    const lh = {
        onLoad() {
            var t;
            (ah[this.id] = []),
                null === (t = this.container.querySelectorAll(eh)) ||
                    void 0 === t ||
                    t.forEach((t) => {
                        const e = this.container.querySelector(t.getAttribute(ih));
                        ah[this.id].push(
                            new (class {
                                init() {
                                    this.toggleScrollObserver(), document.addEventListener("theme:resize:width", this.toggleScrollObserver);
                                }
                                toggleScrollObserver() {
                                    this.isEligible()
                                        ? this.initialized || (document.addEventListener("theme:scroll", this.scrollCallback), (this.initialized = !0))
                                        : (document.removeEventListener("theme:scroll", this.scrollCallback), (this.initialized = !1));
                                }
                                isEligible() {
                                    const t = v();
                                    return (!t && this.anchor.hasAttribute(oh)) || (t && this.anchor.hasAttribute(nh)) || (!this.anchor.hasAttribute(nh) && !this.anchor.hasAttribute(oh));
                                }
                                onScroll() {
                                    this.top = this.elementToSpy.getBoundingClientRect().top;
                                    const t = Math.round(window.innerHeight),
                                        e = Math.round(window.scrollY),
                                        s = e + t,
                                        i = Math.round(this.top + e),
                                        o = this.elementToSpy.offsetHeight;
                                    i < s &&
                                        !(i + o < e) &&
                                        this.triggerPointReached() &&
                                        (this.anchorSiblings.forEach((t) => {
                                            t.matches(this.anchorSelector) || t.classList.remove(sh);
                                        }),
                                        this.anchor.classList.add(sh));
                                }
                                triggerPointReached() {
                                    let t = !1;
                                    switch (this.triggerPoint) {
                                        case "top":
                                        default:
                                            t = this.top <= 0;
                                            break;
                                        case "middle":
                                            t = this.top <= window.innerHeight / 2;
                                            break;
                                        case "bottom":
                                            t = this.top <= window.innerHeight;
                                    }
                                    return t;
                                }
                                onUnload() {
                                    document.removeEventListener("theme:resize:width", this.toggleScrollObserver), document.removeEventListener("theme:scroll", this.scrollCallback);
                                }
                                constructor(t, e) {
                                    (this.container = t),
                                        (this.elementToSpy = e),
                                        (this.anchorSelector = `[${ih}="#${this.elementToSpy.id}"]`),
                                        (this.anchor = this.container.querySelector(this.anchorSelector)),
                                        (this.anchorSiblings = this.container.querySelectorAll(`[${ih}]`)),
                                        (this.initialized = !1),
                                        this.anchor && ((this.triggerPoint = this.anchor.getAttribute(rh)), (this.scrollCallback = () => this.onScroll()), (this.toggleScrollObserver = this.toggleScrollObserver.bind(this)), this.init());
                                }
                            })(this.container, e)
                        );
                    });
        },
        onUnload() {
            ah[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
    };
    so("sidebar", [th, lh]);
    const ch = "[data-hover-target]",
        dh = "[data-collection-image]",
        hh = "data-hover-target",
        uh = "is-visible",
        ph = "is-selected";
    let mh = {};
    so("collections-hover", [
        {
            onLoad() {
                mh[this.id] = new (class {
                    init() {
                        this.buttons.length &&
                            this.buttons.forEach((t) => {
                                t.addEventListener("mouseenter", (t) => {
                                    const e = t.currentTarget.getAttribute(hh);
                                    this.updateState(e);
                                });
                            });
                    }
                    updateState(t) {
                        const e = this.container.querySelector(`[${hh}="${t}"]`),
                            s = this.container.querySelector(`#${t}:not(.${uh})`),
                            i = this.container.querySelector(`${ch}.${ph}`),
                            o = this.container.querySelector(`${dh}.${uh}`);
                        s && v() && (null == o || o.classList.remove(uh), null == i || i.classList.remove(ph), s.classList.add(uh), e.classList.add(ph));
                    }
                    onBlockSelect(t) {
                        this.updateState(t.target.id);
                    }
                    constructor(t) {
                        (this.container = t.container), (this.buttons = this.container.querySelectorAll(ch)), this.init();
                    }
                })(this);
            },
            onBlockSelect(t) {
                mh[this.id].onBlockSelect(t);
            },
        },
        lh,
    ]);
    const vh = "[data-featured-image]",
        gh = "[data-featured-aside]",
        bh = "[data-featured-content]",
        fh = "[data-featured-wrapper]",
        yh = "data-horizontal-scroll",
        wh = "data-horizontal-scroll-reversed",
        Sh = {};
    so("featured-product", [
        {
            onLoad() {
                Sh[this.id] = new (class {
                    init() {
                        this.horizontalScroll && this.imagesHolder && ((this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent)), document.addEventListener("theme:scroll", this.scrollEvent)),
                            this.wrapper && this.contentHolder && this.images.length && (this.calculateHeight(), document.addEventListener("theme:resize:width", this.calculateHeightEvent));
                    }
                    scrollEvents() {
                        this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent));
                    }
                    removeAnimationFrame() {
                        this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), (this.requestAnimationSticky = null));
                    }
                    calculateHorizontalPosition() {
                        let t = window.scrollY + this.headerHeight;
                        const e = t + window.innerHeight,
                            s = this.imagesHolder.offsetTop,
                            i = this.imagesHolder.offsetHeight,
                            o = s + i + this.headerHeight,
                            n = i - (window.innerHeight - this.headerHeight),
                            r = this.horizontalScrollReversed ? 1 : -1;
                        let a = 0;
                        (a = t >= s && e <= o ? ((t - s) / n) * 100 : t < s ? 0 : 100),
                            (a *= this.images.length - 1),
                            this.container.style.setProperty("--translateX", a * r + "%"),
                            this.lastPercent !== a ? (this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent)) : this.requestAnimationSticky && this.removeAnimationFrame(),
                            (this.lastPercent = a);
                    }
                    calculateHeight() {
                        let { stickyHeaderHeight: t } = r();
                        this.container.style.removeProperty("--min-height"), this.container.style.setProperty("--min-height", `${this.wrapper.offsetHeight + this.contentHolder.offsetHeight}px`), (this.headerHeight = t);
                    }
                    onUnload() {
                        this.horizontalScroll && this.imagesHolder && document.removeEventListener("theme:scroll", this.calculateHorizontalPositionEvent),
                            this.wrapper && this.contentHolder && this.images.length && document.removeEventListener("theme:resize:width", this.calculateHeightEvent);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.horizontalScroll = this.container.hasAttribute(yh)),
                            (this.horizontalScrollReversed = this.container.hasAttribute(wh)),
                            (this.images = this.container.querySelectorAll(vh)),
                            (this.imagesHolder = this.container.querySelector(gh)),
                            (this.contentHolder = this.container.querySelector(bh)),
                            (this.wrapper = this.container.querySelector(fh)),
                            (this.requestAnimationSticky = null),
                            (this.lastPercent = 0),
                            (this.scrollEvent = () => this.scrollEvents()),
                            (this.calculateHorizontalPositionEvent = () => this.calculateHorizontalPosition()),
                            (this.calculateHeightEvent = () => this.calculateHeight()),
                            this.init();
                    }
                })(this);
            },
            onUnload(t) {
                Sh[this.id].onUnload(t);
            },
        },
    ]);
    const Eh = {};
    function Lh(t = {}) {
        if ((t.type || (t.type = "json"), t.url))
            return Eh[t.url]
                ? Eh[t.url]
                : (function (t, e) {
                      const s = new Promise((s, i) => {
                          "text" === e
                              ? fetch(t)
                                    .then((t) => t.text())
                                    .then((t) => {
                                        s(t);
                                    })
                                    .catch((t) => {
                                        i(t);
                                    })
                              : (function (t, e, s) {
                                    let i = document.getElementsByTagName("head")[0],
                                        o = !1,
                                        n = document.createElement("script");
                                    (n.src = t),
                                        (n.onload = n.onreadystatechange = function () {
                                            o || (this.readyState && "loaded" != this.readyState && "complete" != this.readyState) ? s() : ((o = !0), e());
                                        }),
                                        i.appendChild(n);
                                })(
                                    t,
                                    function () {
                                        s();
                                    },
                                    function () {
                                        i();
                                    }
                                );
                      });
                      return (Eh[t] = s), s;
                  })(t.url, t.type);
        if (t.json)
            return Eh[t.json]
                ? Promise.resolve(Eh[t.json])
                : window
                      .fetch(t.json)
                      .then((t) => t.json())
                      .then((e) => ((Eh[t.json] = e), e));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return Eh[e]
                ? Eh[e]
                : (function (t) {
                      const e = "".concat(t.name, t.version),
                          s = new Promise((e, s) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: t.name,
                                          version: t.version,
                                          onLoad: (t) => {
                                              !(function (t, e, s) {
                                                  s ? e(s) : t();
                                              })(e, s, t);
                                          },
                                      },
                                  ]);
                              } catch (t) {
                                  s(t);
                              }
                          });
                      return (Eh[e] = s), s;
                  })(t);
        }
        return Promise.reject();
    }
    document.addEventListener("DOMContentLoaded", function () {
        io("*");
        const t = document.querySelector("[data-scroll-top-button]");
        t &&
            (t.addEventListener("click", () => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }),
            document.addEventListener("theme:scroll", () => {
                t.classList.toggle("is-visible", window.scrollY > window.innerHeight);
            })),
            window.self !== window.top && document.querySelector("html").classList.add("iframe"),
            "scrollBehavior" in document.documentElement.style || Lh({ url: window.theme.assets.smoothscroll });
    }),
        window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies"));
})(themeVendor.ScrollLock, themeVendor.Flickity, themeVendor.FlickityFade);


function carrinho (n) {

    switch (n) {
        case 0:
            document.getElementById("1st").setAttribute("data-active", "false");
            document.getElementById("2nd").setAttribute("data-active", "false");
            document.getElementById("3rd").setAttribute("data-active", "false");
            document.getElementById("progresso").style.width = "0%";
            break;
        case 1:
            document.getElementById("1st").setAttribute("data-active", "true");
            document.getElementById("2nd").setAttribute("data-active", "false");
            document.getElementById("3rd").setAttribute("data-active", "false");
            document.getElementById("progresso").style.width = "20%";
            break;
        case 2:
            document.getElementById("1st").setAttribute("data-active", "true");
            document.getElementById("2nd").setAttribute("data-active", "true");
            document.getElementById("3rd").setAttribute("data-active", "false");
            document.getElementById("progresso").style.width = "50%";
            break;
        default:
            document.getElementById("1st").setAttribute("data-active", "true");
            document.getElementById("2nd").setAttribute("data-active", "true");
            document.getElementById("3rd").setAttribute("data-active", "true");
            document.getElementById("progresso").style.width = "100%";
            break;
    }
}
